module.exports={
  login: {
    title: "LOGIN SYSTEM",
    logIn: "Login",
    username: "Enter Your Username",
    password: "Password Length 6-18 Bits",
    changeCheckCode:"Change Code",
    checkcode:"Please enter verification code",
    footerTxt:"China Telecom",
    contact:"Contract System",
    scm:"Supply Chain",
    project:"Project Management",
    hr:"Hr System",
    error_account_null:"Account number cannot be empty",
    error_pwd_null:"Password can not be empty",
    error_checkcode_null:"Verification code cannot be empty",
    switchingusers:"Shift User",
    retreat:"Exit",
    loginoutmsg:"You Have Signed out The System Or Login Timeout, Please Login Again"
    },
  layout: {
    sysTitle: "PTO SYSTEM"
    },
  ffbreadcb: {
    currlocation: "Current Position："
    },
  common: {
    home:"Homepage",
    indexMethod: "S/N",
    expList: "Export",
    expDataCutList: "Cutover Export",
    impDataCut: "Data cutting import",
    checkboxT: "Select",
    addbut: "Add",
    delbut: "Delete",
    query:"Query",
    advancedquery : "Advanced Query",
    reset:"Reset",
    delnoselected:"Please select the records to be deleted!",
    delsuccess:"Delete successfully!",
    savesuccess:"Save Successfully！",
    reloadsuccess:"Reload Succeeded!",
    opertype : "Operation",
    fileup: "Upload The Attachment",
    todo:"Transact",
    inputTips:"Please Enter",
    selectTips: "Please Select",
    selectfile:"Select A File",
    uptoftp:"Upload",
    nodata:"No Data Available",
    reload : "Reload",
    todos:"To-Do",
    alreadtodo:"Done",
    yes:"YES",
    cannot:"Can Not",
    morethan:"Exceed",
    develop :"Expand",
    shrink:"Shrink",
    clean:"Clear",
    close:"Close",
    save:"Save",
    reqcompanycodeTips:"Please Select Company",
    confirm : "OK",
    cancel : "Cancel",
    impexcel: "Import Excel",
    delmsg : "Are you sure to delete the document?",
    tiptitle : "PROMPT",
    cancelmsg : "Operation Canceled",
    batchtodo : "Batch Processing",
    showMoreTip: "Expand",
    hideTip: "Hide",
    panelShowDetailTip: "Expand",
    panelhideTip: "Hide",
    companycode: "Company Code",
    selnulluserinfotip: "Please Select Personnel Information",
    logouttip:"Are you sure to exit the system",
    warning:"Warning",
    refeshright:"Refresh Module Authority",
    reqfileTips:"Please Click to Browse and Select the Import File!",
    print:"Print",
    },
  materialcommon: {
    changestoreTips: "Please clear the selected material requirement details, and then, replace the warehouse!",
    checkapplynumtip: "The Line Item Application Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    donenum: "Issued Order Quantity",
    usablestorenum: "Available Inventory Quantity",
    onlinenum: "In-Transit Occupied Quantity",
    costcentercode: "Cost Center Code",
    costcentername: "Cost Center Name",
    orimanuname: "Original Manufacturer",
    orimanuprodname: "Original Manufacturer’S Product Name",
    orimanuspec: "Original Manufacturer Specification Model",
    orimanudrip: "Product Description Of Original Manufacturer",
    outprojcode: "Entrustment Subproject Code",
    belongeregion: "Region",
    orderno: "PO Number",
    ordername: "PO Name",
    manuname: "Vendor",
    materialcode: "Material Code",
    materialname: "Material Name",
    spec: "Model",
    chunit: "UOM",
    chcurrency: "Transaction Currency",
    startdate: "Start Date",
    enddate: "End Date",
    baseinfoTab: "Basic Information",
    billno: "Document Encoding",
    plandate: "Billing Date",
    storedate: "Posting Date",
    storeid: "Warehouse",
    recstoreid: "Storage Location",
    planuserid: "Material Coordinator",
    storeuserid: "Warehouse Officer",
    remark: "Remarks",
    materialWrap: "Material Requirement Details",
    price: "Unit Price",
    plannum: "Billing Quantity",
    storenum: "Actual Quantity",
    recsum: "Amount",
    degree: "Inventory Attribute",
    notes: "Remarks",
    checknumtip: "The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    outbillno: "Entrustment Goods Issue Form Number",
    outmanuname: "Entrusted Vendor",
    projcode: "Subproject Code",
    projname: "Subproject Name",
    applyareaname : "Application Region",
    applydeptname:"Application Department",
    applyusername : "Applicant",
    demandbillno : "Application Number",
    applyuser_tel : "Telephone Number Of Applicant",
    createtime:"Application Date",
    fileup:"Upload Attachment",
    applynum: "Application Quantity",
    brecbillno : "Official Document Code",
    chdemandstatus : "Requirement Status",
    demandlistinfo : "List Of Requirements",
    listinfo : "Delivery List",
    emptyrowlist : "This delivery list cannot be empty!",
    checkplannumtip : "The Line Item Bill Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    checkdemandnumtip : "The Bill quantity of this time + the processed quantity cannot be greater than the requirement application quantity",
    demandbillno2 : "Requirement Document Code",
    receivedate : "Time To Task Pool"
    },
  pubbillhead: {
    sendsap : "Send To Sap",
    sendmq:"Send MQ",
    assetaddsendsap : "Asset Creation Status",
    assetmodifysendsap : "Asset Modification Status",
    mblnrs : "Material Document",
    sendbss : "Send To BSS"
    },
    pubbillbtn: {
      resetsaplog : "Reset SAP log"
    },
  syslog: {
    logdate1: "Log File Date",
    indexMethod: "S/N",
    logfilename: "Log File",
    logdate: "Interface Request Date",
    servicecode: "Interface Code",
    query: "Query",
    reset: "Reset",
    servicename: "Interface Name",
    requestTime: "Request Date",
    requestlog: "Request Message",
    responselog: "Response Message",
    clienttitle: "CLIENT LOG",
    servertitle: "SERVER LOG",
    url:"URL Address",
    valid:"Validity",
    system:"System",
    keyval:"Business Document ID",
    result:"Successful or not"
    },
  testdemo: {
    listDemo: "Test List",
    listDemoDetail: "Test List Detail Page"
    },
  travel: {
    //出差审批
    task: "To-Do",
    deleteList: "Delete",
    addList: "Add",
    checkboxT: "Select",
    indexMethod: "S/N",
    creadate: "Date",
    currusername: "Name",
    applydept: "Department",
    applydate: "Handling Date",
    applyuser: "Current Handler",
    currstatus: "Current Status",
    status: "Status",
    operate: "Operation",
    look: "View",
    allFiles: "Allfiles"
    },
  travelDetail: {
    //出差审批详情
    title: "TRAVEL APPROVAL",
    applyuser: "Applicant",
    applydept: "Application Department",
    applyareacode: "Number",
    usernum: "Number Of Business Personnel",
    toolname: "Travel Tools",
    travelauser: "Staff On A Business Trip",
    traveldate: "Business Trip Date",
    returndate: "Return Time",
    traveladdress: "Business Trip Destination",
    task: "Business Trip Description",
    zsap: "Accommodation Arrangements",
    zsremark: "Accommodation Arrangement Remarks",
    toolremark: "Transportation Remarks",
    remark: "Remarks",
    selectedPlaceholder: "Please Select",
    inputPlaceholder: "Please Enter The Content",
    startTime: "Start Time",
    endTime: "End Time",
    //单据标题
    contentTitle:"CONTENT TITLE",
    contentLine:"Line Item List",
    contentFlow:"Handling Process",
    //行项列表
    nums:"Quantity",
    price:"Business Trip Expenses"
    },
  flow_process:{
    title : "PROCESSING",
    nextstatus: "Next Step",
    nextuser: "Next handler",
    reader: "Carbon Copy(CC)",
    advice:"Handler's Comments",
    advicelengthwarn:"The length of handler's comments shall not exceed 2000",
    pleaseselect:"Please Select",
    addadvice :"Add As Commonly Used Comment",
    deladvicesucc :"Delete common comments successfully",
    deladviceerror :"Failed to delete common comments",
    changle:"Cancel",
    confirm:"OK",
    retrieve:"Retrieve To-Do",
    successtip1:"The system will",
    successtip2:"Seconds to return to the former page!",
    savesuccess:"Save Successfully！",
    currlocation:"Current Position",
    curruser:"Current Handler",
    notnulltip:"Required",
    msgtitle:"ERROR MESSAGE",
    saveerror:"There is a problem with data storage. please try again later.",
    saveerror2:"There is a problem in data saving, please contact the administrator.",
    processtitle:"PROMPT",
    deletemsg : "Are you sure to delete the document?",
    cancelmsg : "Operation Canceled",
    confirmReclaim:"After confirmation, recycle to this step!",
    loading:"Loading...",
    submitting:"Submitting...",
    errormsg:"{0} cannot be empty!",
    defaultadvice_agree:"Agree",
    defaultadvice_disagree:"Disagree",
    notice: "Notice",
    sendmail: "Send Mail(To Approver)",
    sendmail_to_cc: "Send Mail(To CC Person)",
    sendsms: "Send Sms",

    // 办理过程
    bflow_flowinfo: "Process Info",
    bflow_flowname: "Process Name",
    bflow_flowstatus: "Process Status",
    bflow_currflowstatus: "Current Step",
    bflow_list_info: "Process And Opinion Tracking List",
    bflow_list_index: "S/N",
    bflow_list_username: "Approver",
    bflow_list_status: "Processing Activity",
    bflow_list_advice: "Approval Comment",
    bflow_list_proctime: "Approval Time",

    // 设置流程
    setflow_list_title: "SET PROCESS",
    setflow_list_index: "S/N",
    setflow_list_currstatus: "Current Processing Step",
    setflow_list_currarea: "Current Region",
    setflow_list_currdept: "Current Department",
    setflow_list_currusername: "Current Handler",
    setflow_list_receivetime: "Current Handler",

    setflow_adjusted: "Adjust To",
    setflow_latest_steps: "Latest Step",
    setflow_latest_handler: "Latest Handler",
    setflow_orderno: "Operation and Maintenance Work Order No.",
    setflow_notion: "Adjustment Reason",

    // 历史调整记录
    history_list_title: "HISTORY OF ADJUSTMENT",
    history_list_index: "S/N",
    history_list_orderno: "Operation and Maintenance Work Order No.",
    history_list_notion: "Adjustment Reason",
    history_list_adjustmenttime: "Adjustment Time",
    history_list_handler: "Operating Personnel",
    history_list_OriginalProcessName: "Original Process Name",
    history_list_NewProcessName: "New Process Name",

    //阅办
    read_title: "COMMENT",
    read_advice: "Please input the handling comment",
    process_prediction: "Process Map",
    process_track: "Process Tracking",
    tip_syncTaskSucc: "Extract Task Successfully",
    tip_chgCurrFlowSucc: "Adjust process task instance successfully",
    billreloaderror : "The document has not been loaded. Please refresh or reopen the document for operation."
    },
  selectUser:{
    title :"PERSONNEL SELECTION",
    rownum:"S/N",
    username : "Username",
    account:"Account Number",
    deptname:"Department",
    clear:"Clear",
    query:"Query",
    placeholder:"Enter Keyword to Search",
    confirm:"OK",
    cancel:"Cancel",
    nomsg :"No Data Available",
    notselectuser : "Please Select Personnel Information"
    },
  treeTag:{
    placeholder : "Please enter keyword to filter"
    },
  selectList:{
    title :"LINE ITEM SELECTION",
    clear:"Clear",
    reset:"Reset",
    query:"Query",
    confirm:"OK",
    },
  demo: {
    //模版
    indexMethod: "S/N",
    expList: "Export",
    tabname: "List",
    checkboxT: "Select",
    a1: "Vendor Code",
    a2: "Vendor Name",
    a3: "",
    id: "Primary Key",
    titeData:["Demo Page"],
    reflash:"Refresh"
    },
  formValidate:{
    tipTitle:"INFORMATION ERROR",
    maxCharLength:"The Total Length of Content Cannot Exceed {0} Characters",
    minCharLength:"The Total Content Length Cannot Be Less Than {0} Characters",
    decimal1:"Please Enter An Integer No More Than {0} Bits",
    decimal2:"Please Enter A Number With Integer Digits No More Than {0} and Decimal Digits No More Than {1}",
    integer:"Please Enter An Integer No More Than {0} Bits",
    positive:"Please Enter A Positive Number",
    negative:"Please Enter A Negative Number",
    handler:"Customized Client (Method: {0}) Validation Errors Occured (Details Not Provided, Please Contact The Developer For Supplementation).",
    idcard:"Please Enter The Correct Second Generation ID Number",
    phone:"Please enter the correct phone number",
    email:"Please enter the correct E-mail!",
    savesuccess:"Save Successfully！",
    success:"Success！",
    defeat:"Fail！",
    },
  contract:{
    btnUpdate:"Modify",
    btnsave:"Save",
    btnpdf:"Finalization",
    title:"CONTRACT APPROVAL FORM",
    info:"Contract Info",
    relatedContract:"Related Contract",
    createtime:"Draft Date",
    signcode:"Initiation Number",
    contractcode:"Contract Number",
    frameflag:"Contract Type",
    contractname:"Contract Name",
    contractfactbook:"Contract Background and Overview",
    partatype:"Company Code",
    tradesum:"Contract Amount",
    concode3class:"Contract Type",
    fundflag:"Payment Type",
    emergencydegree:"Urgency Level",
    iffinancialpro:"Financial Commitment Or Not",
    applyareadept:"Requesting Department",
    department:"Department",
    applyusername:"Requestor",
    applyusertel:"Contact Number",
    tel:"Requestor/Tel.",
    partbname:"Counterparty Name",
    ifrelatetrading:"Related Transaction Or Not",
    relatetradetype:"Related Transaction Type",
    ifinsidetrade:"Is It An Internal Transaction?",
    insidetradetype:"Internal Transaction Type",
    accountname:"Account Name",
    bankname:"Deposit Bank",
    bankaccounts:"Bank Account Number",
    mgrdept:"Authorized Representative",
    consaddr:"Address",
    partbtradesum:"Contract Allocation Amount",
    presentid:"Our Party",
    baseTitle:"BASIC INFORMATION",
    partbTitle:"SIGNING PARTIES",
    payTitle:"PERFORMANCE INFORMATION",
    selectpaytype1:"Payment Method",
    selectpaytype2:"Collection Method",
    paymethoddesc1:"Payment Method Description",
    paymethoddesc2:"Collection Method Description",
    extendedterms:"Is there any extension clause",
    manuname:"Counterparty Name",
    payno:"Nth",
    payitem:"Performance Requirements",
    perdate:"Agreed Performance Date",
    payplan1:"Payment Schedule",
    theorypaydate_days1:"Estimated Date Of Prepayment",
    perrate1:"Agreed Payment Rate(%)",
    persum1:"Agreed Payment Amount",
    payplan2:"Collection Schedule",
    theorypaydate_days2:"Estimated Collection Date",
    perrate2:"Agreed Collection Rate(%)",
    persum2:"Agreed Amount",
    payplan3:"Collection Schedule",
    theorypaydate_days3:"Estimated Collection Date",
    perrate3:"Agreed Collection Rate(%)",
    persum3:"Agreed Amount",
    opinionTitle:"CONTRACT APPROVAL INFORMATION",
    deptopinion:"Comment from the Requesting Department",
    signopinion:"Comments from Functional Departments",
    finaceopinion:"Comment from Finance Department",
    lawopinion:"Comment from Legal Department",
    manageopinion:"Management Comments",
    fileTitle:"CONTRACT CONTEXT AND ANNEXES",
    usecontext:"Contract Template Type",
    firstPage:"Homepage",
    contractCreate:"New Contract",
    contractContent:"Contract Approval",
    pre_contractname:"Original Contract Name",
    pre_contractcode:"Original Contract Number",
    iftradechange:"Is Invovled Amount Changed",
    currencytype:"Transaction Currency",
    pre_tradesum:"Original Contract Amount",
    tradesumchange:"Contract Difference After Change",
    changetradesum:"Amount after Change",
    concodedate:"Date Numbered",
    finaldate:"Finalization Date",
    stampdate:"Signing date",
    stampuser:"Signatory",
    signenddate:"Effective Date",
    signenduser:"Effective Personnel",
    archivedate:"Date Archived",
    archiveuser:"Archiving Personnel",
    applyuser: "Requestor",
    applyarea: "Requesting Department",
    applydept: "Requesting Department",
    signdateenddate:"Date of Performance",
    status:"Status",
    legalofficer:"Chief Legal Officer",
    signuser:"Review Department",
    tradesumstandard:"Amount of Functional Currency after Conversion",
    signTitle:"SUPPORTING DOCUMENT",
    poweranalyzeflag:"Supporting Document",
    powerfile:"Supporting Document",
    pbasecontext:"Remark Description",
    htfiletype:"Contract Template Type",
    contractproper:"Contract Context",
    attachmentinfo:"Annexes / Attachments",
    signendbook:"Remarks",
    contractperiod:"Contract Performance Period",
    postponeddate:"Deferred Date",
    paytype:"Expense Type",
    finaTitle:"FINANCE AND TAX INFORMATION",
    taxitem:"Item Involving Stamp Duty",
    taxableproperty:"Taxation Property",
    ifvatinvoices:"VAT Invoice Provided Or Not",
    taxpayertype:"Taxpayer Type",
    taxpayerno:"Taxpayer Id No.",
    invoicetype:"Invoice Type",
    exctaxamount:"VAT Exclusive Amount",
    taxrate:"Tax Rate",
    tax:"Tax Amount",
    totalvalorem:"Cross Amount (Including Tax)",
    costtype:"Contract Expense Type",
    costtype2:"Cost Attribute",
    otherTitle:"ADDITIONAL INFORMATION",
    internalappitems:"Internal Control Type",
    renewcontractflag:"Reminder Of Renewal Of Contract Or Not",
    ifoutsourccon:"Business Outsourcing Contract Or Not",
    ifrelatedcon:"Related Contract Or Not",
    relatedcontractid:"Related Contract Information",
    frametype:"Framework Agreement Attribute",
    frameareas:"Applicable Regions Of Framework Agreement",
    sumMoney:"Sum.",
    framename:"Framework Agreement Name",
    framecode:"Framework Agreement Number",
    gencontractcode:"Contract Number",
    btnstamp:"Signed But Not Effective",
    btnstampsign:"Signed And Effective",
    cancelbtnstamp:"Cancellation Of Signature",
    cancelbtnstampsign:"Cancellation And Entry Into Force",
    stampsucces:"Signed Successfully",
    signsucces:"Come Into Effect",
    cancelstampscucces:"Cancel Signed Successfully",
    cancelsignscucces:"Cancel Signed And Effective Successfully",
    toarchive:"Archive",
    archiveend:"Archived",
    templatename:"Text Name",
    templatetype:"Contract Template Type",
    versionno:"Document Initiation Number",
    btnContractWrod:"Self Prepared Text (Word Doc.)",
    btnContractTemplate:"Contract Template",
    templateCreateTime:"Registration Time",
    approvedate:"Formal In-Storage Time",
    templateTitle:"REVIEWING FORM OF CONTRACT TEMPLATE",
    arearange:"Scope (Multiple Choices Are Avilable)",
    templateConcode3class:"Applicable Contract Type",
    templateFile:"Attachment Of Template Text",
    templateOtherFile:"Other Attachments",
    btnUploadFile:"Upload Attachment",
    currstatus:"Process Steps",
    month:"Month",
    remindingtime:"Renewal Reminder Time",
    accountmanuname:"Vendor Name",
    accountmanuno:"Vendor No.",
    srcbankname:"Original Deposit Bank",
    srcaccountname:"Original Account Name",
    srcbankaccounts:"Original Account Number",
    chgbankname:"Changed Bank's Name",
    chgaccountname:"Changed the Counterparty's Name in bank",
    chgbankaccounts:"Account Number After Change",
    accountchangefile:"Supporting Documents for Account Change",
    accountTitle:"APPROVAL FOR CHANGE OF COLLECTION ACCOUNT OF COUNTERPARTY",
    finalpdf:"Finalization",
    uploadsignpage:"Upload Signature Page",
    contractexecutor:"Contract Implementer",
    perifrequency:"Frequency",
    perieachamount:"Amount Per Period",
    sealednomore:"The signed contract can not be signed again!",
    nosigned:"The signed and effective contract can not be made effective again!",
    nocancelsign:"The contract is not effective, so there is no need to make the operation of “signed and effective”",
    nostamp:"The Contract Is Not Signed, there is no need to cancel signing",
    pleaseinputcontract:"Please Enter Contract Number",
    pleaseclickseach:"Please Click Search Button!",
    seachcontracterror:"No Relevant Document Information Is Found According To The Contract No.",
    billno:"Document Number",
    billtime:"Document Date",
    description:"Performance Description",
    performdoc:"Performance Document",
    performanceTitle:"APPROVAL FORM FOR ADDITIONAL DOCUMENTS OF CONTRACT PERFORMANCE",
    ifcounterpartychange:"Change Of Counter Party",
    transfertype:"Types Of Transfer",
    ifsrccounterparty:"Original Contract Or Not",
    cancelBtn:"Cancellation",
    sureCancelContract:"Confirm to initiate the contract cancellation?",
    nostampsign:"The Operation Is Not Available Because The Contract Is Effective",
    archivemsg:"Archive Successfully!",
    pleaseupload:"Please Download and Install The Following Related Software First!",
    contractperform:"Performance Record",
    btnStopCancel:"Termination Of Cancellation",
    stopCancelMsg:"Cancellation Of Termination Succeeded!",
    stopCancelMsg1:"Termination Cancellation Failed!",
    stopCancelMsg2:"The original step does not exist and cannot be cancelled!",
    stopCancelError:"Termination Cancellation Failed!",
    revokereason:"Reasons For Cancellation",
    beginRevoke:"Failed To Initiate Cancellation!",
    beginRevoke1:"The original step does not exist, cannot initiate cancellation!",
    extendedtype1:"Extend To",
    extendedtype2:"Indefinite Extension",
    ifmainsupplier:"Main Equipment Vendor or not",
    delafterflow:"Delete successfully",
    checkstock:"There is order generated from the contract, so the contract can’t be canceled.",
    checkcfmoney:"Occupied by the finance department and can not be canceled",
    btnCSPF:"Generate CSPF",
    btnSendMail:"Email Notification",
    btnSend:"Send",
    mailTitleInfo:"EMAIL CONTENT",
    defaultMailInfo:"Hello:\n   {contractname} has generated contract signing procedure form, please accept, thank you!",
    defualtSignMailInfo:"Hello:\n  Contract number:{contractcode}has been signed and already \n effective.",
    defualtSendMail:"Send Successfully",
    },
  contractntko:{
    ntkodesc1:"PDFCREATE is not installed",
    ntkodesc2:"The control can not be installed. Please check the security configuration.",
    ntkodesc3:"The NTKO Web Firefox browser plug-in is not installed",
    ntkodesc4:"Other browsers are not supported temporarily",
    ntkodesc5:"Vue integration with ntko example browser parameters:",
    },
  contractselect:{
    companyCode:"Select Company Code",
    signingType:"Select Contract Signing Type",
    paymentType:"Select Payment Type",
    incomeType:"Select Income Type",
    department:"Select Department",
  },
  contractstock:{
    stockresult:"Procurement Result",
    projcode:"Project Code",
    projname:"Project Name",
    projsum:"Project Allocation Amount",
    resultno:"Procurement Result Number",
    resultname:"Procurement Result Name",
    checkselectmsg:"The sources of the procurement results are not the same, can not be selected",
    },
  contractorder:{
    signcode:"Order origination Number",
    contractcode:"Order Contract Number",
    contractname:"PO Name",
    partatype:"Company Name",
    contractfactbook:"Order Content Overview",
    tradesum:"Total Order Charge",
    ordertotalprice:"Total Order Prices",
    ordertotaltax:"Order Total Tax",
    exchangerate:"Exchange Rate",
    funcurrency:"Functional Currency",
    tradesumstandard:"Amount of Functional Currency",
    applyarea:"Order Creation Department",
    applyusername:"Order Creator",
    orderstardate:"From Order Fulfillment Date",
    orderenddate:"End Of Order Fulfillment Date",
    arrivaldate:"Arrival Date Agreed By Both Parties",
    pre_contractcode:"Original Order No",
    pre_contractname:"Original Order Name",
    pre_tradesum:"Original Order Amount",
    cancelbegin:"Cancellation Initiated Successfully",
    },
  contractstatus:{
    revokestatus:"(Canceled)",
    stampstatus:"(Signed)",
    signstatus:"(Signed And Effective)",
    archivestatus:"(Signed - Archived)",
    },
  contractcheck:{
    countpartblist:"Fill In At Least One Record For The Counter Party Line Item",
    countpaylist:"Fill In At Least One Record For Performance Information Line Item Record!",
    template3class:"Please select a contract type first!",
    signpage:"Signature page must be uploaded!",
    contractword:"Contract text must be uploaded!",
    checkselectpay:"Either 'Payment Method' or 'Payment Method Description' Should Be Filled In!",
    checkselectpay2:"Either 'Collection Method' or 'Collection Method Description' Should Be Filled In!",
    fileupload:"Please Click The [Upload To Server] Button First",
    filenum:"The Number of Current Uploaded Files  Limit",
    filetype:"Only these file types can be uploaded",
    bsscheck1:"Contract has been generated for this document ID, please check!",
    bsscheck2:"The document ID has been cancelled, or contract change in transit document has been generated, please check!",
    bsscheck3:"The document ID has been cancelled, or contract change in transit document has been generated, please check!",
    bsscheckcancel:"This document ID has generated a contract cancellation document or does not support initiating contract cancellation. Please check!",
    checkcontractcode:"Please generate the contract number first!",
    checkFinalPdf:"Please finalize the document first!",
    checkifmainsupplier:"Only one primary equipment supplier can be selected",
    checkifmainsupplier2:"Must select one main equipment vendor",
    checkremovecfmoney:"The Contract is occupied by the finance department and cannot be terminated",
    checkremovecgmoney:"There is order generated from the contract, so the contract can’t be terminated",
    checkCGOrderMoney:"The allocation amount of the vendor cannot be less than the generated order amount",
    checkCGFrameMoney:"There are orders in transit generated from the contract, so the contract can not be changed.",
    checkStockResult:"Please select purchase result first",
    checkcspf:"Generation failed",
    checkhttradesum:"Contract amount must be greater than 0",
    checkfundflag:"Please select payment type",
    checkframeflag:"Please select the signing type",
    checkpartatype:"Please select company entity",
    checkcooperatetype:"Please select the cooperation sharing method",
    },
  problem:{
    problemTitle:"CONTRACT ISSUE APPROVAL FORM",
    problemcode:"Typo Number",
    questiontitle:"Name of the Typo Format",
    revisedcontents:"Revision Content",
    applyusername:"Initiator",
    applydate:"Registration Date",
    curruser:"Current Handler",
    currstatus:"Process Status",
    problemtype:"Typo Type",
    revisewhyreason:"Reasons And Reasons For Revision",
    dealremark:"Handling Results Of Operation And Maintenance Personnel",
    dealdate:"Handling Time",
    applyadvice:"Confirmation Of Requestor",
    finishdate:"Handling Time",
    contractcodeandname:"Contract No. / Contract Name",
    applyusertel:"Requestor's Tel",
    contractstatus:"Contract Status",
    probleminfo:"General Situation Of Problems",
    opinionTitle:"APPROVAL INFORMATION OF QUESTIONNAIRE",
    problemMsg1:"(Note: It Is Necessary To Correct The Error Information On  Approval Form of The Contracts That are Being Approved，Signed and Archived. )",
    problemMsg2:"(Note: It Is Necessary To Correct The Error Information In The Contract Attachments (Such As The Contract Review Draft and Other Attachments) under approval. )",
    problemMsg3:"(Note: The Applicable Units of The Blanket Agreement Need To Be Supplemented. )",
    },
  impExcel: {
    title: "EXCEL IMPORT",
    impFormat: "Import Format",
    impTemplate: "Import Template",
    impMethod: "Import Method",
    over: "Cover",
    append: "Append",
    impdesc: "Description",
    impRemark: "Appending means to add to the  existing lists, and covering means to cover all the former lists with the imported lists .",
    impExcelFile: "Excel Import",
    selUpFile: "Select to upload a file",
    browse: "Browsing",
    import: "Import",
    impDesc: "Only xls. and xlsx. files can be uploaded",
    impErrorIdx: "S/N",
    impErrorMsg: "Error Message",
    impLimitMsg: "You can only select 1 file!",
    selOneFileMsg: "Please select file!",
    upSuccessMsg: "Timing File is uploaded successfully!",
    },
  itemlist: {
    titeData: "Project Approval",
    indexMethod: "S/N",
    tabname: "List",
    checkboxT: "Select",
    itemcode: "Project Code",
    itemname: "Project Name",
    projmanager: "Project Manager",
    applyuser: "Creator",
    applyarea: "Create Unit",
    applydept: "Created by",
    currstatus:"Current Processing Step",
    curruser:"Current Handler",
    id: "Primary Key",
    addbut: "Add",
    delbut: "Delete",
    savebut: "Save",
    title:"PROJECT APPROVAL",
    tabmain:"Basic Information",
    detailtitle:"CONSTRUCTION PROJECT INFORMATION",
    detailtitlesec:"PROJECT DECOMPOSITION",
    investyear:"Investment Year",
    managementunit:"Project Approval Management Unit",
    itemleader:"Project Approval Administrator",
    itemapproveamount:"Amount of Project Approval",
    constructunit:"Construction Unit",
    itemthisyearsum:"Investment Amount of This Year",
    itemspeccode:"Major",
    itemsubspeccode:"Sub-major",
    planbegindate:"Planned launch date",
    planenddate:"Planned completion date",
    managemode:"Project Type",
    itemdesigntype:"Design Type",
    itemchecktype:"Acceptance Type",
    companycode:"Company Code",
    profitcenter:"Profit Center",
    belongregion:"Region",
    buildmotivation:"Reasons For Construction",
    resourcestatus:"Resource Situation",
    itembuildcontent:"Construction Content",
    file:"Attachment",
    fileup:"Upload The Attachment",
    intputmoney:"Please Enter The Amount",
    intputseldate:"Please select a date",
    toselect:"Please Select",
    investtype:"Investment Channels",
    itemstatus:"Project Status",
    home:"Homepage",
    projectlist:"Sub Project List",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    manager:"Subproject Manager",
    projinvestsum:"Estimated Total Investment",
    expList: "Export",
    reset:"Reset",
    query:"Query",
    applydate:"Initializing time",
    buscate:"Business Category",
    debuscate:"Business Sub-Category",
    itemapplydate:"Project Completion Date",
    sentosap:"Send To Sap",
    deliverloadlist: "List Of Delivered Assets",
    itembudgetsum:"Project Budget",
    itemthisbudgetsum:"Project Budget This Year",
    projapprovaldocno:"Document No. of Project Approval",
    basestationaccessmode:"Base Station Access Mode",
    longitude:"Longitude",
    latitude:"Latitude",
    constructcontent:"Construction Content",
    itemimpexcel:"Project Import",
    projimpexcel:"Subproject Import",
    srvimpexcel:"Service Order Import",
    srvrowimpexcel:"Service Order Row Import",
    smimpexcel:"Project SM Registration Import",
    srvprojornot:"Service Project or not",
    relatedeqsubproj:"Related Equipment Subproject",
    assistant:"Assistant",

    //审批信息
    approvalinfo:"APPROVAL INFORMATION"
    },
  itemchange: {
    changetype:"Project Change Type",
    title:"PROJECT CHANGE\/TERMINATION",
    taptitle:"PROJECT CHANGE\/TERMINATION",
    ifcancel:"Whether To Cancel The Project",
    preamount:"Original Amount Of Project Approval",
    prethisyearsum:"Original Investment Amount This Year",
    changeamount:"The Amount Of The Project After Adjustment",
    changethisyearsum:"Investment This Year After Adjustment",
    chgagreedate:"The Date Of Change Approval",
    chgagreeno:"The Document Number of Change Approval",
    signdept:"Review Department",
    remark:"Update Reason",
    changebefore_thisyearsum:"Original Total Investment Amount This Year",
    changeafter_thisyearsum:"Total Investment This Year After Adjustment",
    changebefore_investsum:"Original Estimate Amount Of The Total Investment",
    changeafter_investsum:"Total Estimated Investment Amount After Adjustment",
    chgprojmanager:"Main Project Manager After Adjustment",
    ifcancelproj:"Cancel The Subproject or Not",
    rowtitle:"SUBPROJECT INFORMATION",
    tip1:"Project amount after adjustment cannot be empty",
    tip2:"The Amount of This Change Is Greater Than The Available Budget",
    tip3:"Please Enter The Correct Amount After Change",
    tip4:"After Change, The Investment In This Year Cannot Be Greater Than The Total Investment",
    tip5:"The Total Amount After The Change of the Subproject Cannot Be Greater Than The Amount After The Change of The Project",
    tip6:"Please select change type before adding",
    aftprojmanager:"Project Manager After Change"
    },
  design: {
    designntitle:"DESIGN TITLE",
    designtype:"Design Type",
    designtage:"Design Phase",
    designcode:"Design Approval Code",
    designname:"Design Approval Title",
    designwtcode:"Design Delegate Code",
    designwtname:"Design Commission Title",
    design:"Design Information",
    designpf:"Design Entry",
    designwt:"Design Assignment",
    wtmanuname:"Design Agency",
    manuname:"Design Trustee",
    reallyfinishdate:"Actual Completion Date",
    designreplydate:"Design Approval Date",
    designdetail:"Design Requirements",
    designpfinvestsum:"Design Amount",
    designpfsum:"Design Approval Amount",
    designremark:"Design Situation",
    replyramerk:"Approval Status",
    designperson:"The Designer",
    designgm:"Design Size",
    designreplycode:"Document Number Of Design Approval",
    tip1:"Please Select Subprojects Under The Same Project",
    tip2:"Please Don't Select Subproject Repeatedly",
    tip3:"Please select design type first!",
    firststagedesignunitname:"Phase I Design Vendor",
    secondstagedesignunitname:"Phase II Design Vendor",
    bigtitle:"PROJECT SERVICE ORGANIZATION MANAGEMENT FORM",
    effectivedate:"Effective Date",
    checkProjcode:"Subproject code cannot be empty",
    batchimport:"Batch import",
    unitrowbigtitle:"SERVICE VENDOR DETAIL INFORMATION"
    },
  designchange: {
    title:"VARIATION OF DESIGNING",
    taptitle:"VARIATION OF DESIGNING",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    changetumes:"Number Of Changes",
    changedate:"Date Of Change",
    predesignsum:"Original Design Amount",
    chgdesignsum:"Design Amount After Change",
    changreason:"Variation Details & Reason",
    chgreplysum:"Approved Amount Of Design Change",
    designreplydate:"Approval Date Of Design Change",
    designreplyno:"Approval Document No. Of Design Change",
    designreplyname:"Approval Document Name Of Design Change",
    replytitle:"APPROVAL INFORMATION",
    tip1:"Please enter the correct ",
    tip2:"The Design Approval Amount of The Subproject Cannot Be Greater Than The Total Investment of The Project",
    tip3:"Documents In Transit"
    },
  itemanalyze: {
    chstatus:"Current Status",
    itemanalyze:"Project Decomposition",
    finishbut:"The Decomposition Is Completed",
    analyzeflag:"Final Decomposition Completion",
    calanalyzeflag:"Final Decomposition Cancellation Is Completed",
    tip1:"Please finish the Decomposition of The Subprojects of this time first, and then carry out the final decomposition!",
    tip2:"The Total Estimated Investment of The Decomposed Subprojects Cannot Be Greater Than The Project Approval Amount!",
    tip3:"The decomposed subprojects Investment of this year shall not exceed the estimated total investment",
    tip4:"The Total Investment Amount of this year of The Decomposed Subprojects Cannot Be Greater Than The Project Investment of this year!",
    tip5:"When service project or not select yes,the related equipment subproject cannot be empty!"
    },
  budgetapproval: {
    taptitle:"BUDGET ALLOCATION/ADJUSTMENT",
    title:"BUDGET ALLOCATION/ADJUSTMENT",
    year:"Year",
    version:"Version Number",
    valid:"Valid Or Not",
    speccode:"Investment Speciality",
    ifcontrol:"Strictly Controlled Or Not",
    control:"Is Strictly Controlled",
    budgetsum:"Budget Making",
    zybudgetsum:"Occupied Budget",
    ysxbudgetsum:"Effective Budget",
    combut:"Take Effect",
    sykybudgetsum:"Available Budget",
    exxdbudgetsum:"Budget Released In The Previous Version",
    allspeccode:"All System Modules",
    kybudgetsum:"Remaining Available Budget",
    ifvalid:"Confirm to take effect or not",
    tip1:"The Total Issued Budget of All System Modules Cannot Be Less Than The Occupied Budget!",
    tip2:"Issued Budget Cannot Be Less Than The Occupied Budget!",
    check:"Validation",
    yes:"Yes"
    },
  projbegin: {
    beigintitle:"COMMENCEMENT TITLE",
    begindate:"Actual Starting Date",
    planbegindate:"Planned Commencement Date",
    begincode:"Commencement Code",
    title:"COMMENCEMENT MANAGEMENT",
    projinvestsum:"Total Investment Of Subproject",
    execunitid:"Construction Vendor",
    moniunitid:"Supervising Unit",
    constructscale:"Construction Content",
    safefile:"List Of Safety Matters",
    otherfile:"Other Attachments"
    },
  projend: {
    endtitle:"TITLE FOR COMPLETION FORM",
    enddate:"Actual Completion Date",
    planenddate:"Planned completion date",
    endcode:"Document No. for completion form",
    title:"COMPLETION MANAGEMENT",
    projinvestsum:"Total Investment Of Subproject",
    execunitid:"Construction Vendor",
    moniunitid:"Supervising Unit",
    constructscale:"Project Construction",
    safefile:"List Of Safety Matters",
    otherfile:"Attachment"
    },
  firstcheck: {
    title:"PRELIMINARY ACCEPTANCE CERTIFICATE",
    taptitle:"PRELIMINARY ACCEPTANCE CERTIFICATE",
    lzworkplan:"Ledger Progress",
    sgdw:"Construction Vendor",
    jldw:"Supervising Unit",
    begindate:"Commencement date",
    enddate:"Completion Date",
    firstcheckcode:"PAC Code",
    firstchecktitle:"PAC TITLE",
    remark:"Project Acceptance Content",
    leftproblems:"Punch list of PAC",
    fileup:"List of Acceptance Items",
    firstcheckdate:"Actual PAC Date"
    },
  finalcheck: {
    title:"FINAL ACCEPTANCE CERTIFICATE",
    taptitle:"FINAL ACCEPTANCE CERTIFICATE",
    lzworkplan:"Ledger Progress",
    sgdw:"Construction Vendor",
    jldw:"Supervising Unit",
    begindate:"Commencement date",
    enddate:"Completion Date",
    finalcheckcode:"FAC Code",
    finalchecktitle:"FAC TITLE",
    remark:"Subproject Acceptance Content",
    leftproblems:"Remaining Problems In Final Acceptance",
    fileup:"List of Acceptance Items",
    finalcheckdate:"Actual FAC Date",
    finalchecksum:"Final Acceptance Amount"
    },
  asset: {
    finalacctcode:"Business Document No.",
    startdate : "Start Time",
    enddate : "End Time",
    fttitle:"PROJECT DELIVERY",
    tapfttitle:"PROJECT DELIVERY",
    tap2title:"ACCOUNTING DOCUMENT",
    applyuser:"Initiator",
    applydate:"Initializing time",
    projinvest:"Estimated Total Investment Amount of Subproject",
    projsjinvest:"Total Investment Of Subproject",
    accountsum:"Ledger Amount",
    tabtitle1:"FILL IN BY FT PROJECT LEADER",
    agreeflag:"Confirmation",
    expandflag:"Created Method",
    oripcardno_krsb:"Card No. Of Original Fixed Assets Of Expansion Equipment",
    originpcardno:"Original asset card number of overhaul asset",
    area:"Region",
    assetcategory:"Asset Classification",
    assetcatalog:"Fixed-asset Catalog",
    assetname:"Asset Name",
    spec:"Model",
    val:"Quantity",
    unit:"UOM",
    checkdate:"Acceptance Date",
    vendor:"Manufacturer",
    tradesum:"Equipment Procurement Contract Price (Excl. VAT)",
    tabtitle2:"FILLED IN BY NETWORK OPERATION DEPARTMENT",
    managedepartment:"Management department of physical material",
    checkinput:"Warehouse Officer",
    dept:"Using Department",
    materialman:"Keeper",
    dutyman:"User",
    costcenter:"Cost Center Code",
    tabtitle3:"FILL IN BY FT PROJECT LEADER",
    eqpno:"Physical ID",
    address:"Region and address",
    jobcostclass:"The asset classification of the activity cost",
    tabtitle4:"FEEDBACK AFTER SAP ALLOCATION",
    equipsum:"Equipment Amount",
    otherfee:"Amount To Be Amortized (yuan)",
    assetdeliversum:"Value of Delivered Assets",
    tabtitle5:"PRE-FUNDING DEPARTMENT / FINANCE DEPARTMENT IS RESPONSIBLE FOR AUDIT",
    voucher:"Ownership Certificate",
    depreciation:"Depreciation Period",
    remark:"Remarks",

    eqpno_popup_title:"ASSOCIATED PHYSICAL ID",
    eqpno_popup_save: "Save",
    sno:"S/N",
    companycode:"Company Code",
    finaareacode:"Profit Center Group",
    accountyear:"Accounting Year",
    completedate:"Document Completion Date",
    voucherno:"Document Number",
    zbvoucherno:"Self-Compiled Document Number",
    voucherman:"Document Maker",
    chgsum:"Document Amount (yuan)",
    thisacctchgtotal:"Document Subtotal Amount This Time"
    },
  close: {
    closeproj:"Close Or Not",
    close:"Close",
    open:"Open",
    alclose:"Closed",
    alopen:"Opened",
    teclose:"Technical Close",
    teopen:"Technical Open",
    ficlose:"Close",
    fiopen:"Open",
    closeitemmsg:"Are you sure to close the project?",
    closeprojmsg:"Are you sure to close the subproject?",
    openitemmsg:"Are you sure to start the project?",
    openprojmsg:"Are you sure to start the subproject?"
    },
  projsrventry:{
    signcode:"Contract Initiation Number",
    contractcode:"Contract Number",
    contractname:"Contract Name",
    contractuser:"Contract Requestor",
    contractmanuno:"Vendor Code",
    contractmanu:"Vendor",
    contractmanuname:"Vendor Name",
    srvcode:"Service Order Number",
    srvname:"Service Order Name",
    contractcurrency:"Transaction Currency",
    srventryamount:"Total Amount of Service Order",
    applydate:"Date Created",

    bigtitle:"SERVICE ORDER",
    baseinfo:"Basic Information",
    applydate2:"Initializing time",
    applyuser:"Initiator",
    belongregion:"Region",
    contractamount:"Total Contract Value",
    yscfwtmamount:"Total Amount of the Created Service Orders",
    pricetotal:"Total Price Amount",
    taxtotal:"Total Tax Amount",
    pricetaxtotal:"Total Amount Of Price And Tax",
    contractpaytype:"Payment Method",
    exchangerate:"Exchange Rate",
    checkpricetaxtotal:"The total amount of price and tax plus the total amount of the created service order can not be greater than the total contract amount!",
    checksubmajor:"Sub-major cannot be empty!",

    rowbigtitle:"SERVICE ORDER DETAIL INFORMATION",
    number:"S/N",
    srvrowid:"Line Item ID",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    unitid:"UOM",
    stocknum:"Quantity",
    price:"Unit Price (VAT inclusive)",
    price1:"Unit Price",
    costprice:"Price (Excl. Tax)",
    taxrate:"VAT Rate (%)",
    taxprice:"VAT",
    totalsum:"Total Price (VAT Inclusive)",

    occupynum:"Occupied Quantity",
    prepayment:"Prepayment Amount",
    progresspayment:"Progress Payment Amount",
    opertype:"Operation",
    payrecord:"Payment Record",
    bigtitle2:"SERVICE ORDER QUERY",
    billcode:"Bill No",
    payment:"Amount Payable",
    paydate:"Time Of Payment",
    usenumber:"Use Quantity",
    major:"Major",
    submajor:"Sub-major",
    ppacceptedqty:"PP Accepted Qty",
    pacacceptedqty:"PAC Accepted Qty",
    facacceptedqty:"FAC Accepted Qty",
    payer:"Payer",
    orimanuname: "Original Manufacturer",
    orimanuprodname: "Original Manufacturer's Product Name",
    orimanuspec: "Original Manufacturer Specification Model",
    orimanudrip: "Product Description Of Original Manufacturer",
    shareflag:"Shared by All Regions",
    paybaseassessment:"Payment Based on Assessment",
    createdaterange:"Date Range of Creation",
    applyusername:"Creator",
    contractusername:"Contract Initiator",
    frameflagname:"Contract Signing Type",
    contractamount_que:"Contract Amount"
    },
  itemasset:{
      bigtitle:"Transfer Project Capital to Fixed Assets",
      applyuser:"Initiator",
      applydate:"Date of Initiation",
      finalacctcode:"Form No.",
      projcode:"F&T Subproject Code",
      projname:"F&T Subproject Name",
      settleamount:"Settlement Amount",
      capinterestrate:"Capitalized Interest Rate",
      supervisionfeerate:"Supervision Fee Rate",
      siteselectionfeerate:"Site Selection Fee Rate",
      capinterestamount:"Capitalized Interest Amount",
      supervisionfeeamount:"Supervision Fee Amount",
      siteselectionfeeamount:"Site Selection Fee Amount",
      assetmode:"Mode",
      resourcesysstatus:"Resource System Status",
      acceptancedate:"Date of Acceptance",
      sapassetstatus:"Status in SAP",
      fixedassetsamount:"Amount of Fixed Assets",
  
      settletab:"Settlement Table",
      pono:"F&T PO NO.",
      eono:"EO NO.",
  
      assettab:"Fixed Asset",
      agreeflag: "Confirmation Status(Yes/No)",
      expandflag: "Method of Card Creation",
      oripcardno_krsb: "Ref No. of Original Asset Card of Expansive Equipment/ Major Repair",
      originpcardno: "Ref No. of Original Asset Card of Major Repair",
      area: "ORG Region",
      assetcategory: "Type of Asset",
      assetcatalog: "Index of Fixed Asset",
      assetname: "Name of Fixed Asset",
      spec: "Model",
      val: "Quantity",
      unit: "UOM",
      checkdate: "Date of Acceptance",
      vendor: "Vendor",
      tradesum: "Equipment Price",
      managedepartment: "Dept. in Charge",
      checkinput: "Asset Administrator",
      dept: "User Dept.",
      materialman: "Keeper",
      dutyman: "User",
      eqpno: "ID of Physical Asset",
      region:"Region",
      province:"Province",
      city:"City",
      barangay:"Barangay",
      costcenter: "Cost Center",
      cipsupervision:"CIP - Telco Equip – Supervision",
      cipinterest:"CIP - Telco Equip - Finance Cost/Interest",
      cipsite:"CIP - Telco Equip – Site",
      ciptariff:"CIP - Telco Equip –Tariff",
      tabtitle3: "FILL IN BY FT PROJECT LEADER",
      address: "Location/Site ID",
      assetvalue:"Total Value of Asset Card",
      assetno:"Asset Card No.",
      voucher: "Certificate of Ownership",
      depreciation: "Depreciation Period",
      remark: "Remarks",
      ifimports:"Tariff (Yes/No)",
      documentno:"Document No."
    },
  moneyrate:{
    month:"Month",
    version:"Version",
    status:"Status",
    effectivedate:"Effective Date",
    bigtitle:"Maintenance of Exchange & Interest Rate",
    currency:"Currency",
    eono:"EO No.",
    exchangerate1:"Exchange Rate 1",
    capinterestrate:"Capitalized Interest Rate",
    exchangerate2:"Exchange Rate 2",
    checkMonth: "Month cannot be empty",

    mode1:"Mode 1",
    mode2:"Mode 2",
    describe1:"Initiate asset transfer process to trigger the OSS resource management system to compile the asset transfer table and complete the asset confirmation process. This mode is applicable to network projects.",
    describe2:"Initiate asset transfer process to compile the asset transfer table and complete the asset confirmation process  in the MSS auxiliary system. This mode is applicable to non-network projects.",
    majorcode:"Major Code",
    major:"Major",
    makeway:"Asset Transfer Mode"
  },
  projsrvprepay:{
    bigtitle:"SERVICE ADVANCE PAYMENT REGISTRATION FORM",
    prepaycode:"Service Advance Payment Registration Form Number",
    prepayname:"Service Advance Payment Registration Form Name",
    prepaymentamount:"Prepayment Amount",
    applydate:"Initializing date",
    status:"Status",
    prepaymenttotal:"Total Advance Payment",
    srvrowidori:"Line Item ID",
    prepayment:"Prepayment Amount（VAT Exclusive）",
    prepaydate:"Payment Due Date",
    checkcurrencyandmanuno:"Only service orders with the same currency and the same vendor can be selected!",
    checkSrvcode:"The Service Order Number cannot be empty!",
    checkprepayment:"The prepayment amount（VAT Exclusive）can not be greater than the price (VAT Exclusive)!",
    paymentrate:"Payment Rate(%)",
    beforegolive:"Historical Data Before System Go-live"
    },
  projpay:{
    paycode:"Project Progress Payment Summary Form Number",
    payname:"Project Progress Payment Summary Form Name",
    belongregion:"Region",
    currency:"Transaction Currency",
    currstatus:"Status",
    bigtitle:"PROJECT PROGRESS PAYMENT SUMMARY FORM",
    baseinfo:"Basic Information",
    rowbigtitle:"SUMMARY INFORMATION",
    taxrate:"VAT Rate",
    paytype:"Type",
    alreadmoney:"Advance Payment/Payment of the Received Goods",
    paymoney:"Paid Progress Payment Amount",
    thispayment:"Payment Amount This Time（VAT Exclusive）",
    outsourcecode:"Entrustment Form Number",
    srvcode:"Service Order Number/PO Number",
    totalpayment:"Total Payment Amount This Time",
    checkcurrency:"Only material service registration with the same currency can be selected",
    checktotalmoney:"The payment amount this time（VAT Exclusive）plus the paid progress payment amount cannot exceed the price (VAT Exclusive)",
    unitid:"UOM",
    taxprice:"VAT",
    applyusername:"Initiator",
    applydate:"Initializing Date Period",
    milestonepayment:"Milestone Payment",
    lastpayment:"Last Payment"
    },
  projsettle:{
    bigtitle:"PROJECT SETTLEMENT FORM",
    settlecode:"Settlement Form Number",
    tabpanetable:"Settlement Table",
    tabpaneadd:"Markup Settlement Table",
    tabpanedetail:"Detailed Materials Settlement Table",
    tabpanesummary:"Settlement Summary Table",
    outsourcecode:"Entrustment Form Number",
    managemode:"Management Attribute",
    outmanuno:"Entrusted Vendor",
    ifimports:"Pay Tariff or not",
    addrate:"Markup Percentage(%)",
    expexcel:"Export",
    deliverfee:"Delivery Amount",
    checklastpayment:"Please register the last payment of service charge first.",
    verpr:"Unit Price in Functional Currency",
    verpramount:"Amount in Functional Currency",
    costpricesum:"Cost Amount (VAT Exclusive)",
    deliverfeesum:"Revenue Amount (VAT Exclusive)",
    amount:"Amount (VAT Inclusive)",
    receivableprogress:"Account Receivable (Progress Payment) VAT Exclusive",
    receivablesettle:"Account Receivable (Settlement Payment) VAT Exclusive",
    verprcostamount:"Cost Amount in Functional Currency (VAT Exclusive)",
    verprreceivable:"Account Receivable in Functional Currency (VAT Exclusive)",
    sendtosap:"Send to SAP",
    sapstatus:"Status in SAP",
    ifsendtosap:"Confirm to Send to SAP or not",
    tabpanedocumentno:"Document No. Table",
    costdocno:"Cost Document No.",
    recdocno1:"Accounts Receivable Document No. 1",
    recdocno2:"Accounts Receivable Document No. 2",
    recdocno3:"Accounts Receivable Document No. 3",
    costreversedocno:"Cost Reverse Document No.",
    arreversedocno1:"AR Reverse Document No. 1",
    arreversedocno2:"AR Reverse Document No. 2",
    arreversedocno3:"AR Reverse Document No. 3"
    },
  projsm:{
    bigtitle:"PROJECT MATERIAL AND SERVICE REGISTRATION FORM",
    designreplysum:"Design Approval Amount",
    materialsum:"Material Amount",
    servicesum:"Service Fee Amount",
    investsum:"Subproject Estimated Cost",
    opertype:"Operation",
    input:"Input",

    rowbigtitle:"SUBPROJECT RELATED INFORMATION",
    type:"Type",
    advancepayment:"Prepayment Amount",
    outsourcecode:"Entrustment Form Number",
    itemorbillcode:"Service Order Number/PO Number",
    managemode:"Management Attribute",
    ifimports:"Pay Tariff or not",
    editnum:"Modify Quantity",
    outmanuname:"Entrusted Vendor",
    tip1:"The registered quantity cannot be greater than the remaining quantity",
    tip2:"Registered quantity cannot be empty",
    tip3:"Type cannot be empty",
    tip4:"Tip:  This line is invalid",
    sendoss:"Send to OSS",
    sendsuccess:"Send Successfully",
    validrowdate:"Effective Date"
    },
  queryproj:{
    title:"SUBPROJECT PANARAMIC VIEW",
    projstatus:"Subproject Status",
    tab1:"Basic Information",
    tab2:"Investment",
    tab3:"Design",
    tab4:"Procurement",
    tab5:"Contract",
    tab6:"Construction",
    tab7:"Material Requisition",
    tab8:"Acceptance",
    tab9:"Accrue Expense",
    tab10:"Delivery",
    tab11:"Approval Information",
    designtab:"Phase I Design",
    designtabsec:"Preliminary Design",
    designtabsec2:"Implementation Design",
    tztab2:"Total Investment / Budget Occupation Details",
    batchtab:"Construction Information",
    checktab1:"Preliminary Acceptance Information",
    checktab2:"Final Acceptance Information",
    firstcheckdate:"Preliminary Acceptance Date",
    finalcheckdate:"Final Acceptance Date",
    belnr:"Document Number",
    budat:"Accounting Date",
    bldat:"Document Date",
    kstar:"Cost Element",
    matnr:"Material Number",
    maktx:"Material Description",
    mbgbtr:"Total Input Quantity",
    wtgbtrs:"Debit Amount",
    wtgbtrh:"Creditor Amount",
    uprice:"Unit Price",
    meinb:"UOM",
    usnam:"Operating User",
    refbn:"Reference Document No.",
    ebeln:"Purchase Document No.",
    zddlsh:"Purchase Order Serial Number",
    proninvestsum:"Subproject Decomposition Amount",
    designsum:"Budgetary Estimate Approval Amount",
    designdate:"Budgetary Estimate Approval Date",
    ztys:"Project Total Budget",
    ndys:"Project Current Annual Budget",
    xmkyyszt:"Project Available Total Budget",
    xmzyyszt:"Total Budget Occupied by the Project",
    xmkyysnd:"Project Available Annual Budget",
    xmzyysnd:"Annual Budget Occupied by the Project",
    assetdate:"Delivery Date",
    assetno:"Delivery Document",
    alltab1:"Project Approval",
    alltab2:"Subproject Design",
    alltab3:"Variation of Designing",
    alltab4:"Commencement Management",
    alltab5:"Completion Management",
    alltab6:"Preliminary Acceptance",
    alltab7:"Final/One-time Acceptance",
    alltab8:"Project Delivery",
    ebelp:"Procurement Document Line Item No.",
    netwr:"Net Order Value of PO Currency",
    dmbtrt:"Order Goods Receipt Amount",
    dmbtrs:"Service Receipt Amount",
    reewr:"Invoice Amount (VAT Exclusive)",
    reevat:"Invoice Amount (VAT)",
    reewrvat:"Invoice Amount (VAT Inclusive)",
    status:"Order Status",
    elikz:"Goods Receipt Completed or Not",
    menge:"Quantity",
    netpr:"Unit Price",
    lifnr:"Vendor Name",
    aedat:"Order Creation Date",
    zhshhrq:"Last Receipt Date",
    zhfprq:"Last Invoice Date",
    zextdocno:"Requisition / Hand-over Material Document Number",
    zeile:"Line Item Number",
    prdha:"Material Catalog",
    meins:"Unit",
    unitprice:"Unit Price",
    dmbtr:"Total Value",
    gysmc:"Vendor Name",
    charg:"Batch of Materials",

    presentname:"Contract Party",
    contractcode:"Contract Code",
    contracttype:"Contract Type",
    supplier:"Vendor",
    contractamount:"Total Contract Value",
    projtradesum:"Apportionment Amount of the Project in the Contract",
    contractstatus:"Contract Status",
    signdate:"Contract Signing Date",
    archivedate:"Contract Archiving Date",

    investsum:"Subproject Cost",
    sendsapdate:"Project Approval Date",
    deliverydate:"Delivery Date",
    stationaccessmode:"Base Station Access Mode",
    longandlatitude:"Longitude and Latitude",
    stoutsourcematerialamount:"Entrustment of the Entrusted Materials Amount",
    zcoutsourcematerialamount:"Entrustment of the Self-purchased Materials Material Amount",
    stautogestionmaterialamount:"Self-management of the Entrusted Materials Material Amount",
    zcautogestionmaterialamount:"Self-management of the Self-purchased Materials Material Amount",
    alreadmoney:"Advance Payment/Payment of the Received Goods",
    paymoney:"Progress Payment Amount",
    price:"Unit Price",
    costprice:"Price"
    },
  supplierapply:{
    title:"VENDOR INFORMATION FORM",
    baseinfoTab:"Basic Information",
    otherinfoTab:"Other Information",
    baseinfoWrap:"Basic Information",
    inputTips:"Please Enter",
    corpfullname:"Full Name Of Company",
    shortname:"Company Abbreviation",
    suppliercode:"Vendor Code",
    suppliergroup:"Vendor Account Group",
    corptype:"Company Type",
    cooperatebiz:"Cooperative Business",
    supplierdisctype:"Legal Identification Type Of Vendor",
    relation:"Internal Vendor or Not",
    relationtype:"Internal Vendor Type",
    buslicensevaliddate:"Validity Of Business License",
    buslicenseAttach:"Scanned Copy Of Business License",
    reginfo:"Vendor Registration Information",
    regcontinent:"Continents",
    regcountry:"Country or Region",
    regprovince:"Province",
    regcity:"City",
    inputTips4Regprovince:"Please Enter Province",
    inputTips4Regcity:"Please Enter City",
    linktel:"Telephone Number Of Enterprise",
    linktel2:"Extension Number",
    fax:"Fax",
    email:"E-Mail",
    tipstel:"Sms No.",
    legalbodycodeidtype:"Type Of Legal Representative Certificate",
    legalbodycodeidnum:"Number Of Legal Representative Certificate",
    legalbodycode:"Legal Representative",
    manlinkman:"Primary Contact Of Vendor",
    manlinkmantel:"Primary Telephone Number Of Vendor",
    postaddr:"Postal Address",
    postalcode:"Zip Code",
    corpinfo:"Company Profile",
    applydept:"Applicant Department",
    applyuser:"Applicant",
    chstatus:"Process Status",
    createtime:"Creation Time",
    bankinfoWrap:"Bank Account Information",
    bankinfoinWrap:"Vendor Domestic Bank",
    number:"S/N",
    accopenprovince:"Province Of Account Opening",
    accopencity:"City Of Account Opening",
    accopenbank:"Deposit Bank",
    bankcategory:"Bank Type",
    accopenname:"Account Name",
    accopenaccount:"Account",
    oldaccopenaccount:"Original Account",
    combinenum:"Link Bank",
    func:"Public/Private",
    isdefault:"Default Account",
    createprovince:"Province Of Creation",
    bankinfooutWrap:"Vendor Overseas Bank",
    bankname:"Bank Name",
    subbankname:"Branch Name",
    subbankcode:"Branch Code",
    bankaddress:"Bank Address",
    payeename:"Payee Name",
    payeeaddress:"Payee Address",
    accounttype:"Account Type",
    payeeaaccountnumber:"Payee Account No./Iban No.",
    accountcurrency:"Account Currency",
    taxnum:"Tax Identification Number",
    middlebankname:"Name Of Intermediary Bank",
    middlebankaccount:"Account Number In Intermediary Bank",
    middlebankswift:"Swift Code Of Intermediary Bank",
    middlebankiban:"Iban Number Of Intermediary Bank",
    internationalbank:"Bank Information Of International Company Or Not",
    bankareanum:"Area Code Of Bank",
    bankaccount:"Account",
    eccontactsWrap:"Commercial Contact Information",
    contactsname:"Name",
    contactsjob:"Job",
    contactsaddress:"Mailing Address",
    contactsemail:"E-Mail",
    contactslinktel:"Fixed-Line",
    contactsstatus:"Status",
    btaxWrap:"Basic Information Of Tax",
    busitype:"Business Type",
    taxpayercode:"Taxpayer Id No.",
    taxcooperatebiz:"Cooperative Business",
    taxitem:"Taxable Project",
    busitaxtype:"Business Tax Type",
    taxrate:"Taxable Rate",
    factrate:"Actual Tax Rate",
    businessrange:"Business Scope",
    regfoundcurrency:"Currency Of Registered Capital",
    regfound:"Registered Capital",
    createdate:"Company Establishment Date",
    corpscale:"Company Scale",
    familyteleassg:"Does the owner / senior manager have direct relatives and family members working in the telecom company",
    rootsuppliercode:"Code Of Parent Company/Headquarters",
    rootsuppliername:"Name Of Parent Company/Headquarters",
    rootsupplierdisctype:"Legal Identification Type Of Parent / Head Office",
    rootsupplierdisctypeval:"Legal Identification Code Of Parent Company/Headquarters",
    welfarecorp:"Social Welfare Enterprise or Not",
    authencertwrap:"Certificate",
    authencertname:"Certificate Name",
    authencerttype:"Certificate Type",
    authencertenddate:"Validity Period",
    hrWrap:"Human Resources",
    hryear:"Year",
    psncount:"Total Number Of Employees",
    productorpsncount:"Production Personnel",
    managerpsncount:"Management Personnel",
    devpsncount:"R&D Personnel",
    servicepsncount:"Service And Technical Support Personnel",
    marketpsncount:"Marketing And Sales Personnel",
    businessinfowrap:"Financial And Operating Conditions Of The Company",
    businessinfoyear:"Year",
    biregfoundcurrency:"Currency Of Registered Capital",
    assettotal:"Year-End Value Of Total Assets(Php)",
    debttotal:"Year-End Value Of Total Liabilities (Php)",
    debttrate:"Year-End Value Of Asset-Liability Rate(%)",
    assettotalavg:"Average Balance Of Total Assets (Php)",
    capitaltotal:"Capital Reserve (Php)",
    assetflow:"Year-End Value Of Current Assets (Php)",
    assetstore:"Year-End Value Of Stock (Php)",
    debtflow:"Year-End Value Of Current Liabilities (Php)",
    speedrate:"Year-End Value Of Liquidity Ratio (%)",
    payablemoney:"Year-End Value Of Accounts Payable Balance (Php)",
    fundtotal:"Year-End Value Of Monetary Capital (Php)",
    transtotal:"Year-End Value Of Trading Financial Assets (Php)",
    moneyrate:"Year-End Value Of Cash Rate (%)",
    totalincome:"Sales Revenue (Php)",
    serviceincome:"Primary Business Revenue (Php)",
    servicetaxincome:"Primary Business Tax And Surcharges (Php)",
    serviceprofit:"Primary Business Profit(Php)",
    saleprof:"Operating Profit(Php)",
    yearbeginrecmoney:"Year-Begining Value Of Accounts Receivable Balance (Php)",
    yearendrecmoney:"Year-End Value Of Accounts Receivable Balance (Php)",
    recmoneyavg:"Average Value Of Accounts Receivable (Php)",
    recmoneyrate:"Turnover Rate Of Accounts Receivable (%)",
    devinmoney:"R&D Investment (Php)",
    stockholderassignwrap:"Vendor Shareholder Structure",
    seniorstockholderratio:"Shareholding Percentage Of Shareholders",
    stockholdertype:"Type Of Legal Identification Of Shareholder",
    stockholdernumber:"Number Of Legal Id Certificate Of Shareholder",
    stockholdername:"Full Name Of Shareholder",
    stockholderratio:"Shareholding Ratio",
    rootsupplierattach:"Scanned Copy Of Legal Identification Certificate Of Parent Company/Headquarters",
    reqsupplierbankinrow:"Please Fill In The Vendor’S Domestic Bank Account Line Item",
    reqeccontactsrow:"Please Fill In The Commercial Contact Information Line Item",
    reconcaccountwrap:"Reconciliation Account",
    reconcaccount:"Reconciliation Account",
    assignfile: "Attachment",
    businessinfofile: "Attachment",
    bankswift:"Bank SWIFT Code",
    postalcodeExactlyCharLength:"The Total Length of the Content Needs to be {0} Characters",
    postalcodeMaxCharLength:"The Total Length of Content Cannot Exceed {0} Characters",
    bankinforownoTips: "[Bank Account Information] The {0} Line ",
    impexcel4Main: "Vendor Master Table Import",
    impexcel4Item: "Vendor Line Item Import",
    mainsupplierfile: "Scanned Copy of Legal Identification",
    bankoutfile: "Account Information Certificate",
    factratevat: "VAT",
    factrateei: "Withholding Tax",
    zzlgys: "Lease Vendor Indicator",
    zterm: "Payment Terms",
    zwels: "Payment Methods",
    ztermnotnulltip: "Payment Terms,Required",
    zwelsnotnulltip: "Payment Methods,Required",
    regcitynotnulltip: "City,Required",
    postaddrnotnulltip: "Postal Address,Required",
    nodatadisplay : "The bank information you need is not found. Please click the \"Create Bank Information\" button in the upper right corner to add the bank master data information."
    },
  supplierchange:{
    title:"VENDOR CHANGE",
    reqchangesupplier:"Please Select The Vendor To Be Changed",
    taxratesingleTips: "VAT、Withholding Tax Only Single Choice!"
    },
  supplierstatus:{
    title:"VENDOR FREEZING / UNFREEZING",
    buysellstatus:"Procurement Status",
    paystatus:"Payment Status",
    reason:"Reason For Freezing/Unfreezing",
    reqchgstatussupplier:"Please Select Vendors To Frozen/Thaw",
    choperflag: "Application Type",
    reqchgstatus: "Please Select Application Type!",
    title1:"VENDOR FREEZING",
    title2:"VENDOR UNFREEZING",
    thawstatusTips: "Purchase status and payment status. Please select one of them as unfrozen status!",
    frozenstatusTips: "Purchase status and payment status. Please select one of them as frozen status!",
    thawbuysellstatusTips: "Purchase status. Please select unfrozen status!",
    frozenbuysellstatusTips: "Purchase status. Please select frozen status!",
    thawpaystatusTips: "Payment Status, Please Select Unfrozen Status!",
    frozenpaystatusTips: "Payment Status, Please Select Frozen Status!",
    stitle2:"FREEZE VENDOR PROCUREMENT",
    stitle3:"FREEZE VENDOR PAYMENT",
    stitle4:"UNFREEZE VENDOR PROCUREMENT",
    stitle5:"UNFREEZE VENDOR PAYMENT"
    },
  stockorderlist:{
    orderno: "PO Number",
    ordername: "PO Name",
    stocktype: "Purchase Material Type",
    toselect:"Please Select",
    addbut: "Add",
    delbut: "Delete",
    expList: "Export Excel",
    indexMethod: "S/N",
    chooseordertype: "Please select purchase order type!",
    choosefundsource: "Please select the source of the procurement requirement!",
    purchasetype: "Purchase Type",
    fundsource: "Source Of Requirement",
    ordertype: "Order Type",
    billno: "Document Encoding",
    applydate: "Initializing date",
    currstatus: "Change Status",
    currusername: "Current Handler",
    },
  stocksmallorderlist:{
    orderno: "PO Number",
    ordername: "PO Name",
    toybTab: "List of closed procurement results",
    todoTab: "Simple PO List",
    toaddsmallorder: "Trigger A Simple PO",
    },
  stockorderquerylist: {
    orderno: "PO Number",
    applydate: "Application Date",
    createtime: "Date Created",
    remark: "Remarks",
    rownotes: "Line Item Remarks",
    billno: "Bill No.",
    orderno_exact: "PO Number",
    ordertype: "Order Type",
    fundsource: "Source Of Requirement",
    showdetail: "Details",
    chcompany: "Company Code",
    chordertype: "Order Type",
    chfundsource: "Source Of Requirement",
    applydeptname: "Created by",
    currstatus: "Document Status",
    currname: "Current Handler",
    applyusername: "Applicant",
    remark2: "Remarks",
    materialcode: "Material Code",
    materialname: "Material Name",
    },
  stockorderload: {
    bigtitle: "PO INFORMATION FORM",
    baseinfo:"Basic Information",
    otherinfo:"Other Info",
    stockfeerow: "List Of Expenses",
    fee_chfeetype: "Expense Type",
    fee_contractcode: "Framework Agreement Code",
    fee_manuname: "Vendor Name",
    fee_paytype: "Payment Method",
    fee_relatetrade: "Related Type",
    fee_relatetradetype: "Internal Transaction Type",
    fee_notaxsum: "Total Price",
    fee_taxsum: "Total Tax Charge",
    fee_totalsum: "Total Amount Of Price And Tax",
    billid: "Document Id",
    orderno: "PO Number",
    billno: "Document Encoding",
    ordername: "PO Name",
    resultno: "Procurement Result Code",
    resultname: "Procurement Result Name",
    companycode: "Company Code",
    contractid: "Contract Id",
    contractcode: "Contract Code",
    contractname: "Contract Name",
    newcontractcode: "New Contract Code",
    newcontractname: "New Contract Name",
    orderhtcode: "Order Contract No.",
    manuid: "Vendor ID",
    manuno: "Vendor Code",
    manuname: "Vendor Name",
    fundsource: "Source Of Requirement",
    stocktype: "Purchase Material Type",
    stocktaxsum: "Order Total Tax",
    stockcostsum: "Total Order Prices",
    stockrecsum: "Total Order Charge",
    currency: "Transaction Currency",
    fxrate: "Exchange Rate",
    basecurrency: "Functional Currency",
    sumcurrency: "Amount of Functional Currency",
    frameid: "Framework Agreement ID",
    framecode: "Framework Agreement Quotation No.",
    framename: "Framework Agreement Quotation Name",
    frameuserid: "Framework Agreement Procurement Administrator",
    frametel: "Contact Number Of Framework Agreement Procurement Administrator",
    frameareacode: "Framework Agreement Signing Unit",
    frameclassifi: "Framework Agreement Share Category",
    applyareacode: "Order Creation Department",
    applyuserid: "Order Creator",
    applydeptid: "Order Creation Department",
    applydept: "Order Creation Department",
    applydate: "Creation Time",
    applytel: "Procurement Administrator'S Contact Number",
    alluserid: "All Who Have Handled",
    status: "Process status, default 1 Drafting",
    billstatus: "Document Status. Default 0 normal,1 void.",
    zfflag: "Direct Delivery Site Or Not",
    recareacode: "Procurement Receiving Unit",
    recaddr: "Delivery Address",
    recuser: "Consignee",
    rectel: "Telephone Of Consignee",
    arrivedate: "Appointed Date Of Arrival",
    deliverynoteflag: "Delivery Order State",
    receipttel: "Feedbacker Phone",
    receiptdate: "Feedback Date",
    receiptuserid: "Feedbacker Name",
    chgreason: "Update Reason",
    voidflag: "Cancel Or Not",
    cancelreason: "Cancel Reason",
    signdept: "Review Department",
    createtime: "Date Created",
    lastupdatetime: "Last Update Time",
    inputPlaceholder: "Please Enter The Content",
    stockorderrow: "Order Material Details",
    materialcode: "Material Code",
    materialname: "Material Name",
    spec: "Model",
    unitid: "UOM",
    costprice: "Unit Price (VAT Exclusive)",
    taxrate: "VAT Rate (%)",
    taxprice: "Tax Charge",
    price: "Goods Receipt Price",
    stocknum: "Purchase Quantity",
    prestocknum: "Purchase quantity before change",
    aftstocknum: "Purchase quantity after change",
    actarrivalnum: "Actual Arrival Quantity",
    costsum: "Order Price Subtotal",
    taxsum: "Tax Subtotal",
    recsum: "Subtotal Of Total Materials Price Including Tax",
    servicerecsum: "Subtotal Of Service Charge Including Tax",
    thisarrivalnum: "Quantity of Arrival",
    actarrivalsum: "Actual Arrived Equipment Payment",
    returnbillflag: "Return Or Not",
    invoicamount: "Billing Amount",
    orimanuname: "Original Manufacturer",
    orimanuprodname: "Original Manufacturer’S Product Name",
    orimanuspec: "Original Manufacturer Specification Model",
    orimanudrip: "Product Description Of Original Manufacturer",
    inventoryaddress: "Storage Location",
    rowremark: "Remarks",
    loekzstate: "Loekz Status",
    demanduser: "Requirement Applicant",
    demandusertel: "Requirement Applicant'S Phone Number",
    stockdemandno: "PR Code",
    materialdemandno: "Material Demand Number",
    sysresource: "Source System",
    selectservicebtn: "Select service fee",
    urgentflag: "Emergency Or Not",
    printflag: "Print Or Not",
    sendcontflag: "Send Contact System Status",
    senderpflag: "Send Erp System Status",
    celpayflag: "Summary And Payment Status",
    saporderno: "SAP Order Number",
    shipdate: "Shipping Date",
    suppplandate: "Arrival date expected by vendor",
    archivedate: "Date Archived",
    chgdate: "Change Time",
    gjflag: "Data Cut Status",
    actpricesum: "Actual Total Of Material Prices",
    acttaxsum: "Prices And Taxes Total Of Actual Received Goods",
    budgetcheckflag: "Has the SAP budget check been carried out?",
    projcode: "Project Code",
    projname: "Project Name",
    projmanager: "Project Administrator",
    costcenter: "Cost Center",
    applytype: "Purchase Requisition Type",
    assetcodeno: "Assets Card No.",
    assetclass: "Asset Classification",
    createassetbtn: "Create Asset Cards",
    viewservicebtn: "View Service Charges",
    tipbeyondpricemsg: "The unit price exceeds the the set unit price!",
    beyondhtmainsummsg: "The equipment cost cannot exceed the amount allocated to the primary vendor in the contract!",
    signmode: "Signing Mode",
    selstocktypemsg: "The material information has been selected, and the line item information will be deleted when you are sure",
    ordertype: "Purchase Order Type",
    void: "Cancel",
    voidtitle: "PO Cancellation",
    voidreason: "Please input reasons for cancellation",
    checkstocknummsg: "The changed purchase quantity is less than the quantity of the delivered goods!",
    checkstocknummsg1: "The quantity of the procurement after change cannot exceed the quantity of the pre-made purchase order!",
    ebelp: "Line Item Number",
    number: "S/N",
    checkstocktypemsg: "Choose The Purchase Material Type First!",
    belongregion: "Region",
    speccode: "Major",
    subspeccode: "Sub-major",
    paymentterms : "Terms of Payment"
    },
  stockdemandlist:{
    billno : "Document Encoding",
    demandname : "Requirement Name",
    applyusername : "Applicant",
    applydate : "Application Date",
    choosefundsource : "Please select the requirement source!",
    companycode : "Company Code",
    purchasetype : "Purchase Type",
    fundsource : "Source Of Requirement",
    fromdingtalk: "From DINGTALK",
    },
  stockdemandload:{
    bigtitle: "PR FORM",
    baseinfo: "Basic Information",
    rowbigtitle: "PROJECT ASSOCIATION INFORMATION",
    billid: "Document Id",
    billno: "Document Encoding",
    demandname: "Requirement Name",
    fundsource: "Source Of Requirement",
    companycode: "Company Code",
    ygsum: "Estimated Total Procurement Amount",
    currency: "Functional Currency",
    arrivedate: "Planned Arrival Time Of Purchased Material",
    sugpurmethod: "Suggested Procurement Method",
    sugpurmethodremark: "Reason For Suggested Procurement Method",
    sugmanuremark: "Reason Of Vendor Recommendation",
    remark: "Requirement Description",
    billstatus: "Document Status. Default 0 normal,1 void, 2 procurement completed.",
    sourcesys: "Source System. Default 1 Procurement System",
    applyareacode: "Application Unit",
    applyusername: "PR Applicant",
    applydeptid: "PR Department",
    applydept: "PR Department",
    applydate: "Creation Time",
    applyuser_tel: "Telephone Number Of The Applicant",
    alluserid: "All Who Have Handled",
    status: "Process status, default 1 Drafting",
    approvedate_begin: "Approval Start Time",
    approvedate_end: "Approval Of End Time",
    number: "S/N",
    itemcode: "Project Code",
    itemname: "Project Name",
    projcode: "Subproject Code",
    projname: "Subproject Name",
    projsum: "Procurement Budget",
    costcenter: "Cost Center",
    projremark: "Remarks",
    stockuserid: "Purchaser",
    returnreason: "Return Reason",
    returnuser: "Requisition Return Person",
    checkprojsum: "The estimated procurement amount is required if the project information is not empty!",
    useframestockflag: "Whether Purchase By The Framework Agreement",
    },
  stockdemandgolist:{
    billno : "Document Encoding",
    demandname : "Requirement Name",
    applyusername : "Applicant",
    applydate : "Application Date",
    choosedemandtype: "Please select the material service type.",
    },
  stockdemandgowzload:{
    bigtitle: "COMPREHENSIVE MATERIAL PURCHASE REQUIREMENT FORM",
    baseinfo: "Basic Information",
    rowbigtitle: "PROJECT PROCUREMENT INFORMATION",
    billno: "Requirement Code",
    demandname: "Requirement Name",
    applydate: "Document Date",
    applydeptid: "PR Department",
    applydept: "PR Department",
    applyusername: "PR Applicant",
    applyuser_tel: "Telephone Number Of PR Applicant",
    fundsource: "Source Of Requirement",
    companycode: "Company Code",
    applytype: "Purchase Requisition Type",
    sugpurmethod: "Procurement Methods",
    paytype: "Payment Method",
    currency: "Transaction Currency",
    demanddate: "Demand Date",
    arrivedate: "Planned Arrival Time Of Purchased Material",
    ygsum: "Estimated Total Procurement Amount",
    budgetsum: "Budget Amount",
    approvedflag: "Whether It Is Approved",
    sugpurmethodremark: "Reason For Suggested Procurement Method",
    sugmanuremark: "Reason Of Vendor Recommendation",
    remark: "Requirement Description",
    number: "S/N",
    demanddesc: "Description Of The Requirements",
    costcenter: "Cost Center",
    num: "Quantity",
    unit: "UOM",
    projsum: "Procurement Budget",
    projremark: "Remarks",
    estpayduedate: "Estimated Payment Date",
    saqrelated: "SAQ Related",
    dingtalkid: "Related Dingtalk  Approval ID",
    },
  stockplanlist:{
    billno: "Document Encoding",
    planname: "Requirement Name",
    applyusername: "Applicant",
    applydate: "Application Date"
    },
  stockplanload: {
    bigtitle: "PROCUREMENT PLAN",
    baseinfo: "Basic Information",
    rowbigtitle: "INTENTION VENDOR",
    thirdbigtitle: "ASSOCIATED INFORMATION",
    billno: "Procurement Plan Code",
    companycode: "Company Code",
    applyareaname: "Application Unit",
    applydept: "Application Department",
    applyuserid: "Procurement Administrator",
    planname: "Procurement Plan Name",
    fundsource: "Source Of Requirement",
    stockmethod: "Procurement Methods",
    stockcostsum: "Estimated Total Procurement Amount",
    stockrecsum: "Total Procurement Budget (VAT Inclusive)",
    stockcostsumcapital: "Estimated Total Procurement Amount",
    stockrecsumcapital: "Total Purchase Estimates VAT inclusive (Capitalization)",
    prequalification: "Prequalification",
    ifwtzb: "Entrusted Bidding Or Not",
    manuno: "Bidding Agency",
    purchpurposes: "Procument Purpose",
    servicetype: "Service Type",
    stockdesc: "Purchasing Embodiment Description",
    applyareacode: "Application Unit",
    applyuser_tel: "Telephone Number Of The Applicant",
    applyuseremial: "Procurement Administrator Mailbox",
    manurow_manuno: "Vendor Code",
    manurow_manuname: "Intention Vendor Name",
    manurow_manuremark: "Recommended Reason",
    manurow_sugpurmethod: "Recommended Procurement Method",
    projrow_itemcode: "Project Code",
    projrow_itemname: "Project Name",
    projrow_projcode: "Subproject Code",
    projrow_projname: "Subproject Name",
    projrow_projsum: "Procurement Budget",
    number: "S/N",
    costcenter: "Cost Center",
    operate: "Operation",
    demandcode: "Select PR",
    selfundsourcetip: "Prompt",
    selfundsourcemsg: "Procurement Requirement Information is selected. The line item will be deleted when it is confirmed.",
    currency: "Transaction Currency",
    fxrate: "Exchange Rate",
    basecurrency: "Functional Currency",
    origcurrency: "The Original Currency",
    origprojsum: "Original Estimated Amount",
    projremark: "Remarks",
    inputPlaceholder: "Please Enter The Content",
    signuser: "Review Department",
    },
  stockresultlist: {
    billno: "Procurement Result Code",
    resultname: "Procurement Result Name",
    applyusername: "Applicant",
    applydate: "Application Date",
    },
  stockresultload: {
    void: "Cancel",
    bigtitle: "PROCUREMENT RESULT",
    baseinfo: "Basic Information",
    rowbigtitle: "SUCCESSFUL VENDOR",
    thirdbigtitle: "ASSOCIATED INFORMATION",
    inputPlaceholder: "Please Enter The Content",
    billid: "Document Id",
    billno: "Procurement Result Code",
    resultname: "Procurement Result Name",
    companycode: "Company Code",
    planid: "Procurement Plan ID",
    planno: "Procurement Plan Code",
    planname: "Procurement Plan Name",
    stockmethod: "Procurement Methods",
    fundsource: "Source Of Requirement",
    currency: "Transaction Currency",
    fxrate: "Exchange Rate",
    basecurrency: "Functional Currency",
    stocktaxsum: "Total Tax",
    resultcostsum: "Procurement Total Amount  (VAT Exclusive)",
    resultrecsum: "Procurement Total Amount (VAT Inclusive )",
    contractuserid: "Contract Drafter",
    validmanuflag: "Stream Label - No Valid Vendor",
    resultdesc: "Explanation Of Submitted Decision-Making Content",
    itemdesc: "A Brief Introduction To Procurement Project",
    billstatus: "Document Status",
    sourcesys: "Source System",
    applyareacode: "Application Unit",
    applyuserid: "Procurement Administrator",
    applydeptid: "Application Department",
    applydept: "Application Department",
    applydate: "Creation Time",
    applytel: "Procurement Administrator'S Contact Number",
    applyemail: "Procurement Administrator Mailbox",
    alluserid: "All Who Have Handled",
    status: "Process status, default 1 Drafting",
    manurowid: "Vendor Line Item Id",
    manuid: "Vendor ID",
    manuno: "Vendor Code",
    manuname: "Vendor Name",
    manurecsum: "Purchase S /A.",
    sugpurmethod: "Recommended Procurement Method",
    itemcode: "Project Code",
    itemname: "Project Name",
    projcode: "Subproject Code",
    projname: "Subproject Name",
    projsum: "Procurement Amount (VAT Inclusive)",
    number: "S/N",
    costcenter: "Cost Center",
    demandcode:"PR Code",
    smallpurch: "Trigger A Simple PO",
    crtcontract: "Trigger Contract Generation",
    voidtitle: "PO Cancellation",
    voidreason: "Please input reasons for cancellation",
    checkboxT: "Remarks",
    resultrecsum_bw: "Functional Currency Amount",
    resultrecsumcapital: "Total Purchases VAT inclusive (Capitalization)",
    origcurrency: "The Original Currency",
    origprojsum: "Original Estimated Amount",
    remark: "Remarks",
    stockamount_nottax: "Procurement Amount  (VAT Exclusive)",
    taxrate: "Tax Rate",
    tax: "Tax Amount",
    projsumtip: "2 decimal places that can be estimated according to the price tax",
    zbnoticename: "Tender Announcement Title",
    xjnoticename: "RFQ Announcement Title",
    dxnoticename: "Targeted Negotiation Title",
    itemsum: "Procurement Amount (VAT Inclusive)",
    signmode: "Signing Mode",
    signuser: "Review Department",
    },
  stocktenderinvitelist: {
    billno: "Bidding Entrustment Code",
    billname: "Name Of Procurement Bidding Entrustment",
    applyusername: "Applicant",
    applydate: "Application Date"
    },
  stocktenderinviteload: {
    inputPlaceholder: "Please Enter The Content",
    bigtitle: "PROCUREMENT BIDDING ENTRUSTMENT",
    baseinfo: "Basic Information",
    billid: "Document Id",
    billno: "Bidding Entrustment Code",
    billname: "Name Of Bidding Entrustment",
    planid: "Procurement Plan ID",
    planno: "Procurement Plan Code",
    planname: "Procurement Plan Name",
    projcode: "Procurement Project Code",
    projname: "Procurement Project Name",
    invitemanuno: "Bidding Agent Code",
    invitemanuname: "Bidding Agent Name",
    inviteuserid: "Contact Person Of Bidding Agent",
    inviteusertel: "Contact Number",
    invitedate: "Date Of Entrustment",
    publishflag: "Release Or Not",
    remark: "Entrusted Content",
    applyareacode: "Application Unit",
    applyuserid: "Applicant",
    applydeptid: "Application Department",
    applydept: "Application Department",
    applydate: "Creation Time",
    applytel: "Telephone Number Of The Applicant",
    applyemail: "Procurement Administrator Mailbox",
    alluserid: "All Who Have Handled",
    status: "Process status, default 1 Drafting",
    approvedate_begin: "Approval Start Time",
    approvedate_end: "Approval Of End Time",
    createtime: "Creation Time",
    lastupdatetime: "Time Of Latest Update",
    },
  stocknoticelist:{
    billno: "Document Encoding",
    billname: "Document Name",
    applyusername: "Applicant",
    applydate: "Application Date",
    notselbilltype: "Please select announcement type.",
    chbilltype: "Announcement Type",
    },
  stockinquiryload: {
    inputPlaceholder: "Please Enter The Content",
    bigtitle: "REQUEST FOR QUOTATION DOCUMENT",
    baseinfo: "Basic Information",
    billno: "Request For Quote Document Code",
    billname: "Rfq Document Title",
    planid: "Procurement Plan ID",
    planno: "Procurement Plan Code",
    planname: "Procurement Plan Name",
    projcode: "Procurement Project Code",
    projname: "Procurement Project Name",
    noticetitle: "ORIGINAL ANNOUNCEMENT TITLE",
    inquirytype: "Rfq Method",
    qualificattype: "Qualification Review Method",
    drafttime: "Draft Time",
    publicitytime: "Procurement Publicity Time",
    to1: "To",
    inquirytransferendtime: "Request For Quotation Document Submission Deadline",
    authorscope: "Authorization Scope",
    authorizedmanuno: "Authorised Party Code",
    authorizedmanuname: "Authorized Party Name",
    inquiryuserid: "Inquirer",
    construction: "Construction Unit",
    rfqtext: "The Body Of The Rfq Announcement",
    },
  stockprequalificatload: {
    inputPlaceholder: "Please Enter The Content",
    bigtitle: "PREQUALIFICATION",
    baseinfo: "Basic Information",
    billno: "Document Code",
    billname: "Pre-Qualification Document Title",
    projname: "Procurement Project Name",
    noticetitle: "ORIGINAL ANNOUNCEMENT TITLE",
    stockmethod: "Procurement Methods",
    agencyflag: "Entrusted Agency Or Not",
    agencyname: "Agency",
    undertagsum: "The Object Amount (RMB)",
    moneysource: "Sources Of Funds",
    drafttime: "Draft Time",
    publicitytime: "Pre-Qualification Documents Release Time",
    to1: "To",
    inquirytransferendtime: "Deadline For The Submission Of Pre-Qualification Documents",
    authorscope: "Authorization Scope",
    authorizedmanuno: "Authorised Party Code",
    authorizedmanuname: "Authorized Party",
    stockmanager: "Procurement Administrator",
    stockmanagertel: "Mobile Phone",
    stockmanagermail: "E-Mail",
    remark: "Description Of Prequalification Documents",
    rfqtext: "Text Of Pre-Qualification Announcement",
    },
  stocksinglesourceload: {
    inputPlaceholder: "Please Enter The Content",
    bigtitle: "SINGLE-SOURCE DOCUMENT",
    baseinfo: "Basic Information",
    billno: "Purchase Document Code",
    billname: "Purchase Document Title",
    planno: "Procurement Plan Code",
    planname: "Procurement Plan Name",
    projcode: "Procurement Project Code",
    projname: "Procurement Project Name",
    invitemanuno: "Subproject Code",
    invitemanuname: "Subproject Name",
    remark: "Remarks",
    drafttime: "Draft Time",
    publicitytime: "Procurement Publicity Time",
    to1: "To",
    authorscope: "Authorization Scope",
    authorizedmanuno: "Authorised Party Code",
    authorizedmanuname: "Authorized Party Name",
    rfqtext: "Single-Source Procurement Publicity Text",
    stockmethod: "Procurement Methods",
    agencyflag: "Entrusted Agency Or Not",
    agencyname: "Bidding Agency",
    undertagsum: "The Object Amount/control Price",
    moneysource: "Sources Of Funds",
    stockmanager: "Procurement Administrator",
    stockmanagertel: "Mobile Phone",
    stockdeptid: "Procurement Office",
    stockmanagermail: "E-Mail",
    },
  stockselectionload: {
    inputPlaceholder: "Please Enter The Content",
    bigtitle: "COMPARE AND SELECT",
    baseinfo: "Basic Information",
    billno: "Comparison Document Code",
    billname: "Comparison Document Title",
    noticetitle: "ORIGINAL ANNOUNCEMENT TITLE",
    stockmethod: "Comparison Method",
    qualificattype: "Qualification Review Method",
    planno: "Procurement Plan Code",
    planname: "Procurement Plan Name",
    projcode: "Procurement Project Code",
    projname: "Procurement Project Name",
    invitemanuno: "Subproject Code",
    invitemanuname: "Subproject Name",
    remark: "Remarks",
    drafttime: "Draft Time",
    publicitytime: "Comparison Document Release Time",
    to1: "To",
    inquirytransferendtime: "Deadline For Submission Of Comparison Documents",
    authorscope: "Authorization Scope",
    authorizedmanuno: "Authorised Party Code",
    authorizedmanuname: "Authorized Party Name",
    selecttype: "Comparison Method",
    agencyflag: "Entrusted Agency Or Not",
    agencyname: "Bidding Agency",
    undertagsum: "The Object Amount/control Price",
    moneysource: "Sources Of Funds",
    stockmanager: "Procurement Administrator",
    stockmanagertel: "Mobile Phone",
    stockdeptid: "Procurement Office",
    stockmanagermail: "E-Mail",
    pastperioddiff: "Differences And Changes With Previous Projects",
    specificatdiff: "Differences And Changes With Text Template",
    number: "S/N",
    packagerow: "Standard Pack Information",
    packagename: "The Name Of The Standard Pack",
    manuname: "Vendor",
    rowfile: "Operation"
    },
  stockcompetenegotiatload: {
    inputPlaceholder: "Please Enter The Content",
    bigtitle: "COMPETITIVE NEGOTIATIONS",
    baseinfo: "Basic Information",
    billno: "Negotiation Document Code",
    billname: "Title Of Competitive Negotiation Document",
    noticetitle: "ORIGINAL ANNOUNCEMENT TITLE",
    negotiating: "Negotiation Method",
    qualificattype: "Qualification Review Method",
    planno: "Procurement Plan Code",
    planname: "Procurement Plan Name",
    projcode: "Procurement Project Code",
    projname: "Procurement Project Name",
    invitemanuno: "Subproject Code",
    invitemanuname: "Subproject Name",
    undertagsum: "The Object Amount/control Price",
    moneysource: "Sources Of Funds",
    drafttime: "Draft Time",
    agencyflag: "Entrusted Agency Or Not",
    agencyname: "Bidding Agency",
    publicitytime: "Selling Time Of Competitive Negotiation Documents Release Date",
    to1: "To",
    inquirytransferendtime: "Deadline For The Submission Of Competitive Negotiation Documents",
    authorscope: "Authorization Scope",
    authorizedmanuname: "Authorized Party Name",
    stockmanager: "Procurement Administrator",
    stockmanagertel: "Mobile Phone",
    stockdeptid: "Procurement Office",
    remark: "Remarks",
    pastperioddiff: "Differences And Changes With Previous Projects",
    specificatdiff: "Differences And Changes With Text Template",
    number: "S/N",
    packagerow: "Standard Pack Information",
    packagename: "The Name Of The Standard Pack",
    manuname: "Vendor",
    rowfile: "Operation"
    },
  stockpoollist:{
    applyareacode: "PR Organization",
    applydeptid: "PR Department",
    applyuserid: "PR Applicant",
    docreatestockplan: "Initiate Procurement Plans",
    docreatestockresult: "Initiate Procurement Results",
    docreatestockorder: "PO Contract",
    billno : "Document Encoding",
    demandname : "Requirement Name",
    rownum: "Line",
    fundsource: "Source Of Requirement",
    currency: "Transaction Currency",
    stockuserid: "Purchaser",
    applydept: "Requesting Department",
    applyuser: "Procurement Requirement Applicant",
    confirm: "OK",
    cancel: "Cancel",
    selstockusermsg: "Confirm The Modification of The Current Purchaser?",
    selstockusertip: "Reminding",
    seldiffsource: "The selected line item is not consistent with the company code, the procurement requisition type or the requirement source that have been selected, so the billing can not be initiated at the same time. Please select again!",
    selalldiffsource: "The company code, the purchase requisition type and the requirement source are not consistent. Billing can not be initiated, and please choose again!",
    seldemandinfo: "Please select a row of data.",
    operate: "Operation",
    backtostockuserid: "Return",
    backtostocksuccessmsg: "Successful Return",
    backtostockfailmsg: "Failed Return",
    reqtype: "PR Type",
    reqtypemsg: "Tip: You have both the to-dos of procurement requirements and inventory preparation requirements to be handled! You can select the type of the procurement requirements to handle separately.",
    dohunt: "Sourcing",
    selkjhuntmsg: "Cannot sourse for the blanket agreement",
    returntiptitle: "RETURN REQUIREMENT INITIATOR",
    returnmsg: "Return Reason",
    seldemandusermsg: "Please select the requirement initiator first",
    inputreturnreasonmsg: "Please enter the reason for the return before the operation",
    doassigned: "Batch Assignment",
    assigntiptitle: "ASSIGNING A REQUIREMENT INITIATOR",
    seldemanduser: "Please select the assigned person first",
    companycode: "Company Code",
    itemcode: "Project Code",
    itemname: "Project Name",
    projcode: "Subproject Code",
    projname: "Subproject Name",
    costcenter: "Cost Center",
    projremark: "Remarks",
    projsum: "Estimated Amount",
    checkboxT: "Select",
    applytype: "Purchase Requisition Type",
    },
  stockfundload: {
    bigtitle: "REQUIREMENT MATERIAL INFORMATION",
    demandrowinfo: "Requirement Line Item Information",
    listnum: "Line",
    billno: "Requirement Code",
    listinfo: "Related List This Time",
    materialcode: "Material Code",
    materialname: "Material Name",
    spec: "Model",
    chunit: "UOM",
    itemcode: "Project Code",
    itemname: "Project Name",
    projcode: "Subproject Code",
    projname: "Subproject Name",
    costcenter: "Cost Center",
    applynum: "Quantity",
    framecode: "Framework Agreement Quotation No.",
    framecontractcode: "Framework Agreement Code",
    framename: "Framework Agreement Quotation Name",
    chmaterialtype: "Type Of Purchase",
    tipmsg1: "No associated information",
    tipmsg2: "Only allow the same framework quote agreement is allowed",
    },
  BatchMatchDemandInfo: {
    title: "SELECT BLANKET AGREEMENT MATERIAL INFORMATION",
    noseldemandmsg: "Please select the requirements information on the left",
    confirm: "OK",
    cancel: "Cancel",
    clear: "Clear",
    operaterow: "Operation",
    checkboxT: "Select",
    rownum: "Line",
    billno: "Requirement Code",
    itemcode: "Project Code",
    itemname: "Project Name",
    projcode: "Subproject Code",
    projname: "Subproject Name",
    costcenter: "Cost Center",
    framecode: "Framework Agreement Quotation No.",
    framecontractcode: "Framework Agreement Code",
    framename: "Framework Agreement Quotation Name",
    materialname: "Material Name",
    materialcode: "Material Code",
    manuno: "Vendor",
    sobkz: "Stock Type",
    applynum: "Quantity",
    spec: "Model",
    chunit: "Unit",
    status: "Status",
    placeholder: "Enter Keyword to Search",
    nomsg: "No Data Available",
    manuname: "Vendor",
    price: "Unit Price",
    batchmatchbtore: "Match Framework Agreement Materials",
    choosestore: "Please select the requirements",
    choosebilldemandList: "Please Select The Requirement List To Match The Materials",
    chooseselectmaterialrow: "Please select requirement information.",
    selectbstore: "Please select inventory information.",
    chmaterialtype: "Type Of Purchase",
    },
  stockresultchainlist: {
    manuname: "Vendor Name",
    manuno: "Vendor Code",
    billno: "Procurement Result Code",
    resultname: "Procurement Result Name",
    itemcode: "Project Code",
    itemname: "Project Name",
    costcenter: "Cost Center",
    projsum: "Project Allocation Amount",
    sumbit: "Contract Drafting",
    diffmanumsg: "Only initiate contracts according to the same vendor!",
    choosestockresult : "Please select procurement result line item information",
    chfundsource : "Source Of Requirement",
    seldiffsource: "The source of the blanket agreement cannot trigger the contract with other sources!",
    queryTips: "Click the line below to query"
    },
  expertspeclist:{
    speccode: "Professional Coding",
    chspec: "Professional Name",
    speccode2: "Sub-major Code",
    chspec2: "Sub-major Name",
    upspeccode: "Major Code",
    upchspec: "Major Name",
    status: "Whether To Enable",
    operate: "Operation",
    addbut: "Add Major",
    edit: "Edit",
    addnext: "New Sub-Discipline",
    yes: "Yes",
    no: "No",
    },
  expertspecload:{
    bigtitle: "PROFESSIONAL CLASSIFICATION",
    baseinfo: "Basic Information",
    speccode: "Professional Coding",
    chspec: "Professional Name",
    upspeccode: "Superior Discipline Code",
    upchspec: "Superior Discipline Name",
    status: "Whether To Enable",
    remark: "Remarks"
    },
  expertapplylist:{
    billno: "Document Encoding",
    username: "Expert Name",
    unit: "Work Company",
    enspec: "Classification of Declaration",
    sourceflag: "Expert Source",
    expertname: "Expert Name",
    applyusername: "Applicant",
    applydate: "Application Date",
    approvedate: "Approval Date",
    status: "Process Status"
    },
  expertapplyload:{
    bigtitle: "EXPERT INBOUND APPROVAL FORM",
    baseinfo: "Basic Information",
    billno: "Bill No.",
    applyusername: "Applicant",
    applydate: "Application Date",
    applydept: "Application Department",
    approveusername: "Approver",
    approvedate: "Approval Date",
    sourceflag: "Expert Source",
    expertname: "Expert Name",
    sex: "Gender",
    idcard: "Id Number",
    birthday: "Date of Birth",
    health: "Physical Condition",
    learning: "Degree",
    school: "Graduate From",
    specialty: "Major",
    unit: "Work Company",
    address: "Work Address",
    joinworkdate: "Work Date",
    technicalpost: "Title",
    incumbent: "Current Position",
    phone2: "Mobile Phone",
    phone1: "Fixed Telephone",
    fax: "Fax",
    email: "E-Mail",
    enspec: "Declaration Of Profession",
    specialtyyear: "Years Of Relevant Professional Work",
    achievement: "Relevant Professional Performance",
    fileup: "Attachment"
    },
  framelist: {
    framecode: "Framework Agreement Quotation No.",
    framename: "Framework Agreement Quotation Name",
    applyusername: "Applicant",
    applydate: "Application Date",
    attachframe: "Collateral Framework Agreement Or Not",
    },
  framequerylist: {
    framecode: "Framework Agreement Quotation No.",
    framename: "Framework Agreement Quotation Name",
    applydate: "Application Date",
    chattachframe: "Collateral Framework Agreement Or Not",
    createtime: "Date Created",
    remark: "Remarks",
    rownotes: "Line Item Remarks",
    framecontractcode: "Framework Agreement Code",
    billno_exact: "Bill No.",
    showdetail: "Details",
    chcompany: "Company Code",
    applydeptname: "Created by",
    currstatus: "Document Status",
    currname: "Current Handler",
    applyusername: "Applicant",
    remark2: "Remarks",
    materialcode: "Material Code",
    materialname: "Material Name",
    },
  framechglist: {
    framecode: "Framework Agreement Quotation No.",
    framename: "Framework Agreement Quotation Name",
    applyusername: "Applicant",
    applydate: "Application Date",
    attachframe: "Collateral Framework Agreement Or Not",
    tochg: "Change",
    tofrozen: "Frozen",
    tovoid: "Cancel",
    tothaw: "Unfreeze",
    tochgtab: "To-change List",
    tothawtab: "To-unfreeze List",
    todotab: "Change List",
    chgtype: "Change Type",
    currstatus: "Process Status",
    },
  framemainload: {
    bigtitle: "FRAMEWORK AGREEMENT QUOTATION",
    baseinfo: "Basic Information",
    rowbigtitle: "MATERIAL DETAILS",
    manubigtitle: "MASTER VENDOR SERVICE DETAILS",
    agreebigtitle: "LIST OF SERVICE AND SHIPPING PREMIUM QUOTES",
    number: "Line",
    frametype: "Framework Agreement Type",
    attachframe: "Collateral Framework Agreement Or Not",
    framecode: "Framework Agreement Quotation No.",
    framename: "Framework Agreement Quotation Name",
    framecategory: "Framework Agreement Share Category",
    companycode: "Issuing Office",
    framecontractcode: "Framework Agreement Code",
    framecontractname: "Framework Agreement Name",
    manuno: "Vendor",
    manuname: "Vendor Name",
    sourcegoods: "Supply Channels",
    currency: "Transaction Currency",
    origmanu: "Original Manufacturer",
    extendedtype: "Agreement Performance Period",
    signenddate: "Signing Date Of Agreement",
    signdate: "Effective Date Of Agreement",
    enddate: "Termination Date Of Agreement",
    framescope: "Scope Of Contracting Party",
    payratio: "Payment Proportion",
    stockmanager: "Procurement Administrator",
    basisbackground: "Basis And Background Of The Contract",
    contoverview: "Contract Overview",
    remark: "Remarks",
    agreestate: "Quotation Status",
    approvedate_begin: "Approval Start Time",
    approvedate_end: "Approval Of End Time",
    belongregion: "Region",
    visiblescope: "Visible Range",
    visiblekey: "Visible Role",
    row_copy: "Copy",
    row_materialcode: "Material Code",
    row_materialname: "Material Name",
    row_spec: "Material Specifications",
    row_unitid: "UOM",
    row_framecategory: "Framework Agreement Share Category",
    row_materialtype: "Type Of Purchase",
    row_origmanuname: "Original Manufacturer",
    row_origmanuprod: "Original Manufacturer’S Product Specification Model",
    row_origmanudesc: "Product Description Of Original Manufacturer",
    row_origmanumaterial: "Original Manufacturer’S Product Name",
    row_weightuint: "Unit Weight (Kg/M or Kg/Piece)",
    row_weightcopper: "Copper Weight Coefficient (Kg/M)",
    row_costprice: "Price",
    row_taxrate: "Tax Rate %",
    row_taxprice: "Tax Charge",
    row_price: "Cross Amount (Including Tax)",
    row_sharecontrol: "Share Control (Yes/No)",
    row_currency: "Transaction Currency",
    row_state: "Status",
    row_rowremark: "Line Item Remarks",
    manu_demandunit: "Requirement Unit",
    manu_costname: "Expense Name",
    manu_frameshare: "Framework Agreement Share Category",
    manu_manuname: "Vendor",
    manu_feetype: "Expense Type",
    manu_pricetype: "Pricing Method",
    manu_rate: "Rate %",
    manu_unit: "UOM",
    manu_price: "Price",
    manu_taxrate: "Tax Rate",
    agree_demandunit: "Requirement Unit",
    agree_costname: "Expense Name",
    agree_feetype: "Expense Type",
    agree_frameshare: "Framework Agreement Share Category",
    agree_manuname: "Vendor",
    agree_pricetype: "Pricing Method",
    agree_rate: "Rate %",
    agree_unit: "UOM",
    agree_price: "Price",
    agree_disrate: "Discount Rate (%)",
    agree_taxrate: "Tax Rate (%)",
    agree_taxcharge: "Tax Charge",
    agree_totalprice: "Cross Amount (Including Tax)",
    agree_enableflag: "Enabling/Disabling",
    agree_optionflag: "Optional/Required",
    agree_remark: "Remarks",
    selectsubframe: "Select A Subsidiary Agreement",
    extendedterms:"Is there any extension clause",
    postponeddate:"Deferred Date",
    agree_catalogprice: "Catalog Price",
    tipoptionflagmsg: "The same fee type must be selected if there is, other can not be used!",
    tipoptionflagmsg1: "Only one of the same expense type, the same pricing method, the enable disable can exist!",
    tipoptionflagmsg2: "Only one of the same region can exist!",
    },
  framesubload: {
    bigtitle: "FRAMEWORK AGREEMENT QUOTATION",
    baseinfo: "Basic Information",
    rowbigtitle: "MATERIAL DETAILS",
    manubigtitle: "MASTER VENDOR SERVICE DETAILS",
    agreebigtitle: "LIST OF SERVICE AND SHIPPING PREMIUM QUOTES",
    number: "Line",
    frametype: "Framework Agreement Type",
    attachframe: "Collateral Framework Agreement Or Not",
    framecode: "Framework Agreement Quotation No.",
    framename: "Framework Agreement Quotation Name",
    framecategory: "Framework Agreement Share Category",
    companycode: "Issuing Office",
    framecontractcode: "Framework Agreement Code",
    framecontractname: "Framework Agreement Name",
    manuno: "Vendor",
    manuname: "Vendor Name",
    sourcegoods: "Supply Channels",
    currency: "Transaction Currency",
    origmanu: "Original Manufacturer",
    compledeadline: "Agreement Performance Period",
    signdate: "Signing Date Of Agreement",
    effectdate: "Effective Date Of Agreement",
    terminatdate: "Termination Date Of Agreement",
    framescope: "Scope Of Contracting Party",
    payratio: "Payment Proportion",
    stockmanager: "Procurement Administrator",
    basisbackground: "Basis And Background Of The Contract",
    contoverview: "Contract Overview",
    remark: "Remarks",
    agreestate: "Quotation Status",
    approvedate_begin: "Approval Start Time",
    approvedate_end: "Approval Of End Time",
    belongregion: "Region",
    visiblescope: "Visible Range",
    visiblekey: "Visible Role",
    row_materialcode: "Material Code",
    row_materialname: "Material Name",
    row_spec: "Material Specifications",
    row_unitid: "UOM",
    row_framecategory: "Framework Agreement Share Category",
    row_materialtype: "Type Of Purchase",
    row_origmanuname: "Original Manufacturer",
    row_origmanuprod: "Original Manufacturer’S Product Specification Model",
    row_origmanudesc: "Product Description Of Original Manufacturer",
    row_origmanumaterial: "Original Manufacturer’S Product Name",
    row_weightuint: "Unit Weight (Kg/M or Kg/Piece)",
    row_weightcopper: "Copper Weight Coefficient (Kg/M)",
    row_costprice: "Price",
    row_taxrate: "Tax Rate %",
    row_taxprice: "Tax Charge",
    row_price: "Cross Amount (Including Tax)",
    row_sharecontrol: "Share Control (Yes/No)",
    row_currency: "Transaction Currency",
    row_state: "Status (1 Enable/0 Disabled)",
    row_rowremark: "Line Item Remarks",
    manu_demandunit: "Requirement Unit",
    manu_costname: "Expense Name",
    manu_frameshare: "Framework Agreement Share Category",
    manu_manuname: "Vendor",
    manu_feetype: "Expense Type",
    manu_pricetype: "Pricing Method",
    manu_rate: "Rate %",
    manu_unit: "UOM",
    manu_price: "Price",
    agree_demandunit: "Requirement Unit",
    agree_costname: "Expense Name",
    agree_feetype: "Expense Type",
    agree_frameshare: "Framework Agreement Share Category",
    agree_manuname: "Vendor",
    agree_pricetype: "Pricing Method",
    agree_rate: "Rate %",
    agree_unit: "UOM",
    agree_price: "Price",
    agree_disrate: "Discount Rate",
    agree_taxrate: "Tax Rate (%)",
    agree_taxcharge: "Tax Charge",
    agree_totalprice: "Cross Amount (Including Tax)",
    agree_enableflag: "Enabling/Disabling",
    agree_optionflag: "Optional/Required",
    agree_remark: "Remarks",
    agree_catalogprice: "Catalog Price",
    tipdisratemsg: "Please fill in the number between 0-1 for the discount rate",
    },
  stockprecastlist:{
    billno: "Premade Order Code",
    billname: "Premade Order Name",
    applyusername: "Creator",
    applydate: "Creation Time",
    contractcode: "Contract Code",
    },
  stockprecastload:{
    baseinfo: "Basic Information",
    otherinfo: "Blanket Agreement Related Contract",
    framecontractcode: "Framework Agreement Code",
    framecontractname: "Framework Agreement Name",
    manuno: "Vendor Code",
    manuname: "Vendor Name",
    signcode: "Contract Initiation Code",
    toorderht: "Trigger Order Contract",
    bigtitle: "PRE-MADE PURCHASE REQUISITION FORM",
    rowbigtitle: "GOODS ARRIVAL TIME MANAGEMENT",
    thirdbigtitle: "MATERIAL DETAILS",
    number: "Line",
    inputPlaceholder: "Please Enter The Content",
    billno: "Premade Order Code",
    billname: "Premade Order Name",
    companycode: "Company Code",
    fundsource: "Source Of Requirement",
    applytype: "Purchase Requisition Type",
    stocktaxsum: "Order Total Tax",
    stockcostsum: "Total Purchase Price (VAT exclusive)",
    stockrecsum: "Order Total Amount (VAT Inclusive)",
    currency: "Transaction Currency",
    fxrate: "Exchange Rate",
    basecurrency: "Functional Currency",
    standard_stocktaxsum: "Total Order Tax of Functional Currency",
    standard_stockcostsum: "Total Purchase Price Of This Currency (VAT exclusive)",
    standard_stockrecsum: "Order Total Amount of Functional Currency (VAT Inclusive)",
    applyarea: "Our Party",
    applyareaname: "Purchase Requisition Organization",
    applyprovincecode: "Province Of Creation",
    applyuserid: "Creator",
    applydeptid: "Created by",
    applydept: "Created by",
    applydate: "Creation Time",
    applytel: "Telephone Of The Operator",
    alluserid: "All Who Have Handled",
    status: "Process Status",
    billstatus: "Document Status",
    genorderstatus: "Order Generation Status",
    applystatus: "Purchase Requisition Status",
    remark: "Remarks",
    arrival_frameno: "Framework Agreement Quotation Code",
    arrival_framename: "Framework Agreement Quotation Name",
    arrival_framecontractcode: "Framework Agreement Code",
    arrival_framecontractname: "Framework Agreement Name",
    arrival_arrivalremark: "Delivery Commitment",
    arrival_arrivaldate: "Appointed Date Of Arrival",
    row_materialcode: "Material Code",
    row_materialname: "Material Name",
    row_frameno: "Framework Agreement Code",
    row_framecontractcode: "Framework Agreement Code",
    row_framename: "Framework Agreement Quotation Name",
    row_materialtype: "Type Of Purchase",
    row_spec: "Material Specifications",
    row_unitid: "UOM",
    row_currency: "Transaction Currency",
    row_fxrate: "Exchange Rate",
    row_costprice: "Unit Price of Equipment (VAT Exclusive)",
    row_price: "Unit Price of Equipment and Service (VAT Exclusive)",
    row_taxrate: "Tax Rate %",
    row_stocknum: "Purchase Quantity",
    row_costsum: "Subtotal Of Material Expense",
    row_taxsum: "Subtotal of Material Taxes",
    row_recsum: "Subtotal Of Total Materials Price VAT inclusive",
    row_demandid: "PR ID",
    row_demandrowid: "PR Line Item ID",
    row_demandcode: "PR Code",
    row_demandname: "PR Name",
    row_demanduser: "Requirement Applicant",
    row_manuid: "Vendor ID",
    row_manuno: "Vendor Code",
    row_manuname: "Vendor Name",
    row_orimanuname: "Original Manufacturer",
    row_orimanuprodname: "Original Manufacturer’S Product Name",
    row_orimanuspec: "Original Manufacturer Specification Model",
    row_orimanudrip: "Product Description Of Original Manufacturer",
    row_recareacode: "Delivery Area",
    row_recaddr: "Consignee Address",
    row_recuser: "Consignee",
    row_rectel: "Telephone Of Consignee",
    row_type: "Project Engineering Type",
    row_itemid: "Project Id",
    row_itemcode: "Project Code",
    row_itemname: "Project Name",
    row_projid: "Subproject Id",
    row_projcode: "Subproject Code",
    row_projname: "Subproject Name",
    row_projsum: "Estimated Amount",
    row_costcenter: "Cost Center",
    row_projmanager: "Subproject Manager",
    row_inventoryaddress: "Storage Location",
    row_orderstatus: "Processing Status",
    row_orderuserid: "Handler",
    row_feerate_1: "Tariff Rate",
    row_feerate_2: "Agency Fee Rate",
    row_feerate_3: "Logistics Expense Rate",
    row_feerate_4: "Test Fee Rate",
    row_feerate_5: "System Integration Expense Rate",
    row_feerate_6: "Installation Supervision Expense Rate",
    row_feerate_7: "Storage Fee Rate",
    row_feerate_8: "Terminal Delivery Expense Rate",
    row_feerate_9: "Freight/Customs Clearance Agency Fee Rate",
    row_feerate_10: "Service Fee Rate",
    row_feerate_11: "Other Fees Rate",
    row_feerate_12: "Other Fees Rate of Customs Clearance",
    row_price_1: "Tariff price",
    row_price_2: "Agent Price",
    row_price_3: "Logistics Price",
    row_price_4: "Test Price",
    row_price_5: "System Integration Price",
    row_price_6: "Installation Supervision Price",
    row_price_7: "Warehousing Price",
    row_price_8: "Terminal Delivery Price",
    row_price_9: "Freight/Customs Agent Price",
    row_price_10: "Service Price",
    row_price_11: "Other Expenses Price",
    row_price_12: "Customs Clearance Miscellaneous Price",
    row_manuno_1: "Tariff Agent",
    row_manuno_2: "Dealer",
    row_manuno_3: "Logistics Agent",
    row_manuno_4: "Test Agent",
    row_manuno_5: "System Integrator",
    row_manuno_6: "Installation and Supervision Agent",
    row_manuno_7: "Warehouser",
    row_manuno_8: "Terminal Distributor",
    row_manuno_9: "Freight/Customs Agents",
    row_manuno_10: "Service Provider",
    row_manuno_11: "Other Fees Agent",
    row_manuno_12: "Customs Clearance Miscellaneous Agent",
    row_taxrate_1: "Tariff Rate",
    row_taxrate_2: "Agent Tax Rate",
    row_taxrate_3: "Logistics Tax Rate",
    row_taxrate_4: "Test tax rate",
    row_taxrate_5: "System Integration Tax Rate",
    row_taxrate_6: "Installation Supervision Tax Rate",
    row_taxrate_7: "Warehousing Tax Rate",
    row_taxrate_8: "Terminal Distribution Tax Rate",
    row_taxrate_9: "Freight/Customs Agent Tax Rate",
    row_taxrate_10: "Service Tax Rate",
    row_taxrate_11: "Other Expenses Tax Rate",
    row_taxrate_12: "Customs Clearance Miscellaneous Rate",
    row_currency_1: "Tariff Currency",
    row_currency_2: "Agent Currency",
    row_currency_3: "Logistics Currency",
    row_currency_4: "Test Currency",
    row_currency_5: "System Integration Currency",
    row_currency_6: "Installation Supervision Currency",
    row_currency_7: "Warehousing Currency",
    row_currency_8: "Terminal Delivery Currency",
    row_currency_9: "Freight/Customs Agent Currency",
    row_currency_10: "Service Currency",
    row_currency_11: "Other Expense Currency",
    row_currency_12: "Customs Clearance Miscellaneous Currency",
    selfundsourcemsg: "Please select the source of the requirement first",
    errormsg1: "There is also related information for an order contract that is not generated, please trigger it before submitting!",
    errormsg2: "Only match a single framework agreement!",
    },
  stockorderchglist:{
    checkboxT: "Remarks",
    toybTab: "Archive Orders",
    tochgtodoTab: "Change List",
    orderno: "PO Number",
    ordername: "PO Name",
    stocktype: "Purchase Material Type",
    toselect:"Please Select",
    indexMethod: "Line",
    orderchgtitle: "ORDER CHANGES",
    chgreason: "Update Reason",
    chgorder: "Initiating A Change",
    inputchgreasonmsg: "Please enter the reason for change",
    applydate: "Initializing time",
    applyusername: "Change Initiator",
    chbtype: "Type of Variation",
    currstatus: "Change Status",
    htonwaymsg: "There is a contract change in transit, please submit the contract change before the order change!",
    shonwaymsg: "There is a goods receipt form in transit. Please make order change after the goods receipt is submitted!",
    },
  role:{
    inputPlaceholder: "Please Enter The Content",
    title:"ROLE EDITOR",
    cancel:"Cancel",
    add:"Add",
    query:"Query",
    delete:"Delete",
    confirm:"OK",
    home:"Homepage",
    permission:"Authority Configuration",
    roleConfig:"Role Configuration",
    baseInfo:"Basic Information",
    rolename:"Role Name",
    rolecode:"Role Code",
    itemList:"Line Item List",
    roledesc:"Role Description",
    roletype:"Role Type",
    },
  roleload:{
    title:"ROLE INFORMATION",
    rolecode: "Role Code",
    rolename: "Role Name",
    roledesc: "Role Description",
    sysflag: "The Built-In Role Of System Or Not",
    suitflag: "Applicable To The Whole Region Or Not",
    selectedPlaceholder: "Please Select",
    inputPlaceholder: "Please Enter The Content",
    save:"Save",
    personInfo:"Personnel Information",
    deptInfo:"Department Information",
    roleuserid:"Primary Key ID",
    userid:"User ID",
    username:"User Name",
    index:"S/N",
    roledeptid:"Primary Key ID",
    areacode:"Region Id",
    deptid:"Department ID",
    deptname:"Department",
    areaname:"Region",
    },
  modutree:{
    inputPlaceholder: "Please Enter The Content",
    save:"Save",
    basiInfo:"Basic Information",
    add:"Add",
    delete:"Delete",
    moduid:"Module Code",
    moduname:"Module Name",
    modusystem:"Corresponding control system",
    ifrulecontrol:"Authority Control Or Not",
    menuname:"Corresponding Control Menu",
    modutype:"Module Type",
    rightlevel:"Default Authority Type",
    queryLevel:"Default Query Level",
    areaname:"Region",
    checkrightid:"Primary Key ID",
    areacode:"Region Id",
    roleid:"Role ID",
    rolecode:"Role Code",
    rolename:"Role Name",
    roledesc:"Role Description",
    checkright:"Special Authority",
    defaultCheckright:"Default Authority"
    },
  organize:{
    billdetail:"Document Information",
    num:"S/N",
    deptcode:"Department Code",
    pdeptname:"Superior Department",
    deptname:"Department",
    deptname_en:"Department (English)",
    deptname_ph:"Department (Philippines)",
    disport:"Sorting",
    depttype:"Department Type",
    status:"Validity",
    bmzz:"Department Chief",
    bmfz:"Department Deputy",
    save:"Save",
    cancel:"Cancel",
    add:"Add",
    query:"Query",
    delete:"Delete",
    userid:"Account Number",
    username:"Username",
    username_en:"User Name (English)",
    username_ph:"User Name (Philippines)",
    gender:"Gender",
    mobile:"User Tel",
    email:"User mailbox",
    userstatus:"Status",
    islock:"Whether To Lock",
    company:"Company",
    title:"DUTIES",
    deptselect:"Select Department",
    deleteConfig:"Are you sure to delete?"
    },
  sendscene:{
    orderno:"PO Number",
    contractcode:"Legal Order Code",
    stockusername:"Procurement Administrator",
    query:"Query",
    ordername:"PO Name",
    orderdate:"Order Date",
    startdate:"Start Date",
    enddate:"End Date",
    reset:"Reset",
    order:"Line",
    manuname:"Vendor",
    oper:"Operation",
    view:"View",
    billno:"Document Encoding",
    applydate:"Billing Date",
    chstore:"Storage Location",
    accountdate:"Posting Date",
    del:"Delete",
    tosendscene:"To Be Delivered Directly",
    sendscene:"Direct Delivery Site",
    todo:"Transact",
    tosendsceneback:"Pending Goods Return of Direct Delivery to Site",
    sendsceneback:"Return Of Direct Delivery Site"
    },
  sendscenebill:{
    plandate:"Delivery Date",
    storedate:"Posting Date",
    planuserid:"Billing Clerk",
    orderno:"PO Number",
    storeid:"Storage Location",
    manuname:"Vendor Name",
    ordername:"PO Name",
    remark:"Remarks",
    listinfo:"List Information",
    listnum:"Line",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    chunit:"Unit",
    stocknum:"Purchase Quantity",
    recnum:"Remaining Quantity",
    plannum:"Quantity Delivered",
    storenum:"Actual Quantity Received",
    price:"Unit Price",
    recsum:"Amount",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    investflag:"Subproject Goods Issue Type",
    zstrp:"Input Tax Transfer-Out Type",
    execunitname:"Construction Vendor",
    execteamid:"Construction Team",
    notes:"Remarks",
    serialno:"Inventory Batch",
    orimanuname:"Original Manufacturer",
    orimanuprodname:"Original Manufacturer’S Product Name",
    orimanuspec:"Original Manufacturer Specification Model",
    orimanudrip:"Product Description Of Original Manufacturer",
    billno:"Document Encoding",
    checknumtip: "The actual delivered quantity of the line item cannot be greater than the delivered quantity!",
    checkrecnumtip: "The delivered quantity of the line item cannot be greater than the remaining quantity！",
    title:"RECEIPT FROM THE SPOT",
    baseinfo:"Basic Information",
    backtitle:"DIRECT DELIVERY SITE GOODS RETURN FORM",
    backstoreid:"Goods Return Warehouse",
    backstocknum:"Quantity Delivered",
    backonlinenum:"Retired Quantity",
    backrecnum:"Refundable Quantity",
    backstorenum:"Actual Quantity Returned",
    costcenter: "Cost Center",
    chouttype2: "Usage Category"
    },
  rec:{
    orderno:"PO Number",
    contractcode:"Contract Code",
    stockusername:"Procurement Administrator",
    query:"Query",
    ordername:"PO Name",
    orderdate:"Order Date",
    startdate:"Start Date",
    enddate:"End Date",
    reset:"Reset",
    order:"Line",
    manuname:"Vendor",
    oper:"Operation",
    view:"View",
    billno:"Document Encoding",
    applydate:"Billing Date",
    chstore:"Storage Location",
    accountdate:"Posting Date",
    del:"Delete",
    torec:"Pending Order Goods Receipt",
    rec:"Receipt Form",
    todo:"Transact",
    outmanuname: "Entrusted Vendor",
    belongeregion: "Region",
    speccode:"Major"
    },
  recbill:{
    plandate:"Delivery Date",
    storedate:"Posting Date",
    planuserid:"Material Coordinator",
    orderno:"PO Number",
    storeid:"Storage Location",
    manuname: "Vendor Name",
    manuno: "Vendor Code",
    ordername:"PO Name",
    remark:"Remarks",
    listinfo:"List Information",
    listnum:"Line",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    chunit:"Unit",
    stocknum:"Purchase Quantity",
    recnum:"Remaining Quantity",
    plannum:"Quantity Delivered",
    storenum:"Actual Quantity Received",
    price:"Unit Price",
    recsum:"Amount",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    investflag:"Subproject Goods Issue Type",
    zstrp:"Input Tax Transfer-Out Type",
    execunitname:"Construction Vendor",
    execteamid:"Construction Team",
    notes:"Remarks",
    serialno:"Inventory Batch",
    orimanuname:"Original Manufacturer",
    orimanuprodname:"Original Manufacturer’S Product Name",
    orimanuspec:"Original Manufacturer Specification Model",
    orimanudrip:"Product Description Of Original Manufacturer",
    billno:"Document Encoding",
    checknumtip: "The actual delivered quantity of the line item cannot be greater than the delivered quantity!",
    checkrecnumtip: "The delivered quantity of the line item cannot be greater than the remaining quantity！",
    title: "RECEIPT FORM",
    title2: "GR TO ENTRUSTED VENDOR FORM",
    title3: "ENTRUSTED MATERIALS GOODS RECEIVE FORM",
    title4: "ENTRUSTED MATERIALS GR AND TO ENTRUSTED VENDOR FORM",
    baseinfo:"Basic Information",
    editesn:"Input Serial Code",
    viewesn:"View String Code",
    oper:"Operation",
    currency : "Transaction Currency",
    outmanuname:"Entrusted Vendor",
    duties_total:"Total Tariff",
    customs_total:"Total Freight and Miscellaneous Charges",
    recsum_total:"Total Amount",
    recsum_goods:"Cargo Amount",
    duties:"Tariff Amount",
    customs:"Freight and Other Fees of Customs Clearance",
    price_goods:"Unit Price",
    sn:"Physical Serial Number",
    assetclass:"Asset Classification",
    assetcodeno:"Assets Card No.",
    taxsum:"Tax Amount",
    costcenter:"Cost Center",
    checkapplynumtip:"The delivered quantity of the line item cannot be greater than the remaining quantity！",
    reqoutmanunoTips: "Please select an entrustment vendor!",
    changeoutmanunoTips: "Please Clear The Selected Material Requirement Details and Replace The Entrustment vendor!",
    fileup:"Upload Attachment",
    ifjngs:"DITO Pays Tariff or not",
    ebelp:"Line Item Number",
    localrecsum: "Amount of Functional Currency",
    localrecsum_total: "Total Amount of Functional Currency",
    ukurs:"Exchange Rate",
    belongeregion:"Region",
    contractcode:"Contract Code",
    contractname:"Contract Name"
    },
  expexcel : {
    msg : "Exported succesfully! Please click to download:",
    tiptitle : "PROMPT",
    confirm : "OK",
    cancel : "Cancel",
    cancelmsg : "Operation Canceled",
    download : "Download"
    },
  stockcommonreport : {
    msg : "Are you sure to delete the document?",
    tiptitle : "PROMPT",
    confirm : "OK",
    cancel : "Cancel",
    cancelmsg : "Operation Canceled",
    choosedelbill : "Please select the document to delete.",
    chooseapplydept : "Please select the application Dept.",
    choosecompanycode : "Please Select Company Code"
    },
  materialdatalist:{
    billno : "Document Encoding",
    billname : "Document Name",
    applyusername : "Applicant",
    applydate : "Application Date"
    },
    materialdataload:{
      bigtitle : "MATERIAL MASTER DATA",
      officebigtitle : "OFFICE MATERIAL MASTER DATA",
      officesuppliesbigtitle : "OFFICE SUPPLIES MASTER DATA",
      baseinfo:"Basic Information",
      applyareaname:"Application  Office",
      applydeptname:"Application Department",
      applyusername : "Applicant",
      applydate : "Application Date",
      billno : "Document Encoding",
      billname : "Application Document Name",
      mobile : "Telephone Number Of The Applicant",
      rowbigtitle : "Bom Information",
      officerowbigtitle : "Office  Asset Information",
      materialtypename: "Material Group",
      materialtypecode: "Material Group Code",
      first: "First Material Group",
      second: "Second Material Group",
      third: "Third Material Group",
      materialname : "Material Name",
      materialcode : "Material Code (Automatically Generated When Archived)",
      materialtype : "Material Type",
      spec : "Model",
      materialdesc : "Material Description",
      unitid : "UOM",
      bussinessdesc : "Business Description",
      expandmaterialname : "Recommended Material Name",
      expandmaterialcode : "Recommended Material Code",
      expandspec : "Recommended Material Specification Model",
      ifserial : "Instantiate Management Or Not",
      evalclass : "Evaluation Class Name",
      itemevaltype : "Assessment Classification Of Project Inventory",
      itemevaltypename : "Project Inventory Evaluation Class Name",
      ifmianmaterial :"Main Auxiliary Material Or Not",
      checkMaterialExistTips1: "The ",
      checkMaterialExistTips2: " Duplicate Material In Line, Please Re-enter!",
      zwtgc: "Generate Card Or Not",
      zcml: "Asset Catalog",
      zobj_type: "Corresponding Resource Specification Code",
      zobj_type_name: "Corresponding Resource Specification Description",
      zmanu: "Manufacturer",
      zbrma: "Brand of Manufacturer",
      officeassetclass : "Office  Asset Class  Code",
      assetclass : "Asset Classification",
      sapmsg : "Error"
      },
  materialtypedatalist:{
    billno : "Document Encoding",
    applytypename : "Application Type",
    applyusername : "Applicant",
    applydate : "Application Date",
    billname : "Document Name"
    },
    materialtypedataload:{
      bigtitle : "MATERIAL GROUP APPLICATION FORM",
      officesuppliesbigtitle: "OFFICE SUPPLIES CLASSIFICATION FORM",
      officebigtitle : "OFFICE ASSET CLASSIFICATION  FORM",
      baseinfo:"Basic Information",
      applyareaname:"Application  Office",
      applydeptname:"Application Department",
      applyusername : "Applicant",
      applydate : "Application Date",
      billno : "Document Encoding",
      billname : "Document Name",
      mobile : "Telephone Number Of The Applicant",
      rowbigtitle : "Material Classification List Information",
      officerowbigtitle : "Office Asset  Classification List Information",
      pmaterialtypecode : "Parent Classification Code",
      pmaterialtypename : "Parent Classification Name",
      materialtypecode : "Sub-Classification Code (Automatically Generated When Archived)",
      materialtypename : "Sub-Classification Name",
      evalclass : "Evaluation Class Name",
      qklas : "Project Stock Valuation Class",
      status : "Status",
      choosematerialtype : "Select Material Group",
      firstmaterialtypewarn : "The primary node of the master data of the material catalog is currently created. Do you want to continue",
      parentofficeassetclass : "Parent Office  Asset Class  Code",
      officeassetclass : "Office  Asset Class  Code",
      assetclass : "Asset Classification",
      checkMaterialtypeExistTips1: "The ",
      checkMaterialtypeExistTips2: " Duplicate Sub-Classification Name In Line, Please Re-enter!",
      sapmsg : "Error"
      },
      vendorbanklist:{
        vendorbanklist : "Vendor Bank",
        vendorbankdatalist : "Vendor Bank Application",
        bankcode: "Bank Code",
        bankswift : "Bank SWIFT Code",
        bankname : "Bank Name",
        applytypename : "Application Type",
        applyusername : "Applicant",
        applydate : "Application Date",
        chooseopertype : "Please Select Application Type!",
        countryname : "Country",
        bankaddress : "Bank Address",
        tochange : "Changed",
        addBank : "Create Bank Information",
        rowbigtitle : "Vendor Bank Log"
      },
      vendorbankload:{
        bigtitle : "Vendor Bank",
        baseinfo:"Basic Information",
        bankswift : "Bank SWIFT Code",
        bankcode : "Bank Code",
        bankname : "Bank Name",
        country : "Country",
        belongregion : "Region",
        city : "City",
        bankgroup : "Bank Group",
        bankaddress : "Bank Address",
        applydate : "Application Date",
        applytype: "Application Type" ,
        voidflag : "Cancel Or Not"
      },
  materialdatachglist:{
    billno : "Document Encoding",
    applytype : "Application Type",
    applytypename : "Application Type",
    applyusername : "Applicant",
    applydate : "Application Date",
    opertype : "Application Type",
    chooseopertype : "Please Select Application Type!"
    },
  materialdatachgload:{
    bigtitle : "MATERIAL CHANGE APPLICATION",
    baseinfo:"Basic Information",
    applyareaname:"Application Unit",
    applydeptname:"Application Department",
    applyusername : "Applicant",
    applydate : "Application Date",
    billno : "Application Number",
    applytype: "Application Type",
    mobile : "Telephone Number Of The Applicant",
    rowbigtitle : "FREEZE/UNFREEZE MATERIAL INFORMATION",
    materialtypename : "Material Group",
    materialname : "Material Name",
    materialcode : "Material Code",
    spec : "Model",
    unitid : "UOM",
    reason : "Reason For Freezing/Unfreezing",
    sapmsg : "Error"
    },
  BatchMatchBstoreInfo: {
    title: "SELECT INVENTORY INFO",
    confirm:"OK",
    cancel:"Cancel",
    clear:"Clear",
    operaterow: "Operation",
    checkboxT: "Select",
    rownum:"Line",
    materialname: "Name",
    materialcode: "Code",
    sobkz:"Stock Type",
    applynum : "Quantity",
    spec: "Model",
    chunit: "Unit",
    status: "Status",
    placeholder:"Enter Keyword to Search",
    nomsg :"No Data Available",
    materialnameqct: "Name (Accurate)",
    storedate : "Stock-In Time",
    storenum_que : "Available Inventory Quantity",
    storenum : "Inventory Quantity",
    onlinenum : "In-Transit Occupancy",
    thisbillstorenum : "Sole Occupancy",
    serialno : "Batch Number",
    projcode : "Subproject Code",
    chstore : "Warehouse",
    manuname : "Vendor",
    orimanuname : "Original Manufacturer",
    orimanuprodname : "Original Manufacturer’S Product Name",
    orimanuspec : "Original Manufacturer’S Product Specification Model",
    orimanudrip : "Product Description Of Original Manufacturer",
    chifserial : "Instantiate Management Or Not",
    plannum : "Quantity Of This Bill",
    price : "Unit Price",
    batchmatchbtore : "Match Own Inventory",
    choosestore : "Please select warehouse.",
    choosebilldemandList : "Please Select The Requirement List To Match The Inventory",
    chooseselectmaterialrow : "Please select requirement information.",
    plannumgreaterthanzero : "Billing quantity must be greater than 0!",
    plannumgtusablestorenum : "The Line Item Bill Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    thisbillstorenumgtusablestorenum : "The Occupied Quantity of This Order Is Greater Than The Available Inventory Quantity. It Cannot Be Matched Again!",
    selectbstore : "Please select inventory information.",
    usablestorenumequalzero : "Available Stock Quantity Is 0, No More Matching!",
    thispendingnumltzero : "The quantity to be processed has all been matched, and the matched materials need to be readjusted!"
    },
  selectMaterial: {
    title: "SELECT MATERIAL INFORMATION",
    operaterow: "Operation",
    checkboxT: "Select",
    rownum:"Line",
    materialname: "Name",
    materialcode: "Code",
    spec: "Model",
    unitid: "Unit",
    status: "Status",
    clear:"Clear",
    query:"Query",
    placeholder:"Enter Keyword to Search",
    confirm:"OK",
    cancel:"Cancel",
    nomsg :"No Data Available",
    vmaterialnameqct: "Name (Accurate)",
    vismodel: "Framework Agreement Or Not",
    vstatus: "Material Status",
    vmaterialtypename: "Material Catalog Selected",
    },
  stockserviceload: {
    materialcode: "Material Code",
    materialname: "Material Name",
    manuname: "Service Providers",
    chfeetype: "Expense Type",
    feerate: "Rate (%)",
    taxrate: "Service Tax Rate (%)",
    inputPlaceholder: "Please Enter",
    serviceTitle: "DETAILED INFORMATION OF THE COST OF MATERIAL AND SERVICE PROCUREMENT",
    savebtn: "Save",
    pricemode: "Pricing Method",
    costprice: "Unit Price",
    costsum: "Total Service Fee (VAT Exclusive)",
    currency: "Transaction Currency",
    checkidxmsg: "Line{}:",
    checknotnullmsg: "Can't be empty!",
    },
  flow: {
    btype:"Business Type",
    curruser:"Current Handler",
    currstatus:"Current Processing Step",
    receivetime:"Received Time",
    billno:"File No",
    title:"TITLE",
    operlimitdate:"Handling Time",
    status:"Handling Steps"
    },
  sstorelist:{
    storecode : "Warehouse Code",
    chstore : "Warehouse Name",
    storetype : "Assigned Warehouse",
    storeproperty : "Warehouse Level",
    storeclass : "Warehouse Type",
    tel : "Contact Number",
    address : "Warehouse Address",
    chstatus : "Warehouse Status",
    applyareaname : "Region",
    sstore_main_imp : "Warehouse Information Import",
    sstore_row_imp : "Administrator Information Import",
    },
  sstoreload:{
    bigtitle : "STOREHOUSE ALLOCATION",
    storeuserbigtitle : "WAREHOUSE OFFICER",
    planuserbigtitle : "MATERIAL COORDINATOR",
    baseinfo:"Basic Information",
    storecode : "Warehouse Code",
    storeid_sap : "SAP Warehouse Code",
    storeid_crm : "CRM Warehouse Code",
    chstore : "Warehouse Name",
    storetype : "Assigned Warehouse",
    storeproperty : "Warehouse Level",
    linkuser : "Contacts",
    storeclass : "Warehouse Type",
    tel : "Contact Number",
    address : "Warehouse Address",
    chstatus : "Warehouse Status",
    storeuserid : "Warehouse Officer ID",
    storeusername : "Warehouse Officer Name",
    storeuserdept : "Department",
    storeusertel : "Contact Number",
    storeuserstatus : "Validity",
    planuserid : "Material Coordinator Id",
    planusername : "Material Coordinator Name",
    planuserdept : "Department",
    planusertel : "Contact Number",
    planuserstatus : "Validity",
    accountuserid : "Accounting Clerk ID",
    accountusername : "Accounting Clerk Name",
    accountuserdept : "Department",
    accountusertel : "Contact Number",
    accountuserstatus : "Validity",
    storegroup : "Warehouse Group"
    },
  accountdatecfglist:{
    queryoperlog : "Operation Log Query",
    setautoswitchtime : "Automaticly Switching The Time Point of Accounting period",
    accountdate : "Account Date",
    status : "Status",
    operate : "Operation",
    areaconfig : "Company Account Period Configuration",
    reopenaccountdate : "Reopen Account",
    closeaccountdate : "Close Account",
    switchaccountdateerror : "Account Period Configuration Switch Failed",
    executionfrequency : "Execution Frequency",
    monthly : "Monthly",
    executiondate : "Execution Date",
    executiontime : "Execution time",
    disabled : "Prohibit or not",
    checkexecutiondateerror : "Execution date cannot be empty!",
    checkexecutiontimeerror : "Execution time cannot be empty!"
    },
  accountdatecfgload:{
    bigtitle : "ACCOUNT PERIOD CONFIGURATION",
    areaconfigTitle : "COMPANY ACCOUNT PERIOD CONFIGURATION",
    areaname : "Company",
    baseinfo:"Basic Information",
    accountdate : "Account Date",
    status: "Whether To Enable",
    notes : "Remarks",
    remark : "Remarks"
    },
  accountdateoperloglist:{
    choper_type : "Operation Type",
    oper_username : "Operator Name",
    oper_user : "Operator Account",
    accountdate_before:"Account Period Before Modification",
    accountdate_after : "Account Period After Modification",
    createtime: "Operation Time"
    },
  smateriallist:{
    rownum : "S/N",
    materialtypecode : "Material Group Code",
    materialtypename : "Material Group",
    bigmaterialtypename : "Material Group Category",
    materialname : "Material Name",
    materialcode : "Material Code",
    spec : "Model",
    evalclass : "Assessment Type And Name",
    itemevaltypename : "Project Evaluation Class And Name",
    chstatus : "Status",
    choosematerialtype : "Please select the material group"
    },
    smaterialload:{
      bigtitle : "MATERIAL DISPLAY INFORMATION",
      officebigtitle: "OFFICE MATERIAL DISPLAY INFORMATION",
      officesuppliesbigtitle: "OFFICE SUPPLIES MATERIAL DISPLAY INFORMATION",
      baseinfo:"Basic Information",
      applyusername : "Applicant",
      createtime : "Application Date",
      rowbigtitle : "MATERIAL STATUS CHANGE LOG",
      materialname : "Material Name",
      materialcode : "Material Code",
      materialtypecode : "Material Group Code",
      materialtypename : "Material Group",
      chmaterialtype : "Material Type",
      spec : "Model",
      unitname : "UOM",
      evalclassname : "Evaluation Class Name",
      text : "Material Description",
      bussinessdesc : "Business Description",
      expandmaterialcode : "Recommended Material Code",
      expandmaterialname : "Recommended Material Name",
      expandspec : "Recommended Material Specification Model",
      chifmianmaterial : "Main Auxiliary Material Or Not",
      chzwtgc : "Generate Card Or Not",
      zcml : "Asset Catalog",
      zobj_type : "Corresponding Resource Specification Code",
      zobj_type_name : "Corresponding Resource Specification Description",
      assetclass: "Asset Classification",
      officeassetclass: "Office Asset Class",
      rownum : "S/N",
      chstatus : "Status",
      changeuser:"Changer",
      changedate : "Change Time",
      reason : "Reason for blocking/unblocking",
      applytypename : "Post-Change Status",
      beforestatus : "Pre-Change Status"
      },
  movedemandlist:{
    rownum : "S/N",
    billno : "Document Encoding",
    createtime : "Application Date",
    createtime_begin : "Start Date",
    createtime_end : "End Date",
    movetypename : "Initiated By",
    calltypename : "Allocation Type",
    storetypename : "Warehouse Type",
    applyusername : "Applicant",
    brecbillno : "Official Document Code",
    chdemandstatus : "Requirement Status",
    choosedemandtype : "Please select the requirement type.",
    chooseusetype : "Please Select Application Type!",
    notexistdemandtype : "Requirement Type Does Not Exist",
    choosemovetype : "Please Select The Initiator"
    },
  movedemandload:{
    bigtitle : "WAREHOUSE TRANSFER REQUIREMENT FORM",
    unit : "Unit",
    baseinfo:"Basic Information",
    billno:"Application Number",
    applyusername : "Applicant",
    applydeptname:"Application Department",
    applyareaname : "Application Region",
    createtime : "Application Date",
    applyuser_tel : "Telephone Number Of Applicant",
    rowbigtitle : "MATERIAL DETAILS",
    materialname : "Material Name",
    materialcode : "Material Code",
    spec : "Model",
    unitname : "UOM",
    uploadfile : "Attachment",
    rownum : "Line",
    movetypename : "Initiated By",
    calltypename : "Allocation Type",
    sourcetype : "Source Of Requirement",
    remark : "Remarks",
    price : "Estimated Unit Price",
    currency : "Transaction Currency",
    recsum : "Estimated Amount",
    applynum : "Application Quantity",
    linkaddress : "Shipping Address",
    linkuser : "Receiving Contact",
    linktel : "Receiving Contact Number",
    jh_linkaddress : "Delivery Address",
    jh_linkuser : "Delivery Contact",
    jh_linktel : "Delivery Contact Number",
    notes : "Remarks",
    backusername : "Requirement Return Person",
    backnum : "Return Quantity",
    backreason : "Return Reason",
    chstore_out : "Move Out Of Warehouse",
    chstore_in : "Move Into Warehouse",
    logistics_cost_borne : "Logistics Cost Payer",
    expected_logistics_recsum : "Estimated Logistics Fee",
    storeSameTips : "Please Select Different Transfer-out Warehouse and Transfer-in Warehouse!"
    },
  demandlist:{
    rownum : "Line",
    billno : "Document Encoding",
    createtime : "Prepared Date",
    createtime_begin : "Start Date",
    createtime_end : "End Date",
    demandtypename : "Requirement Type",
    projcode : "Subproject Code",
    projname : "Subproject Name",
    outprojname : "Entrustment Subproject Name",
    outprojcode : "Entrustment Subproject Code",
    outmanuno: "Entrusted Vendor Code",
    outmanuname : "Entrusted Vendor",
    applyusername : "Applicant",
    brecbillno : "Official Document Code",
    chdemandstatus : "Requirement Status",
    choosedemandtype : "Please select the material service type.",
    chooseusetype : "Please Select Application Type!",
    notexistdemandtype : "Requirement Type Does Not Exist",
    demandlistTab: "Material Requisition Application"
    },
    inventorythresholdcfglist:{
      rownum : "S/N",
      billno : "Document Encoding",
      createtime : "Application Date",
      createtime_begin : "Start Date",
      createtime_end : "End Date",
      applyusername : "Applicant",
      chdemandstatus : "Requirement Status",
      materialcode: "Material Code"
    },
    inventorythresholdcfgload:{
      bigtitle : "INVENTORY THRESHOLD SETTING",
      baseinfo:"Basic Information",
      billno:"Document Encoding",
      applyusername : "Applicant",
      applydeptname:"Application Department",
      applyareaname : "Application Region",
      createtime : "Application Date",
      applyuser_tel : "Telephone Number Of Applicant",
      rowbigtitle : "MATERIAL DETAILS",
      materialname : "Material Name",
      materialcode : "Material Code",
      rownum : "S/N",
      remark : "Remarks",
      notes : "Remarks",
      storeid : "Warehouse",
      voidflag : "Cancel Or Not",
      plannum : "Warning Quantity",
      stocknum : "Quantity",
      dealstatus:"Mode Of Handling ",
      submitbtn : "Submit",
      noticeuser : "Early Warning Notifier",
      noticetel : "Telephone Number Of Early Warning Notifier"
    },
    officeassetmanagercfg:{
      bigtitle : "Office Asset Manager Configuration",
      baseinfo:"Basic Information",
      usertype : "Customer Type",
      userid:"Administrator ID",
      username : "Manager Name",
      deptname:"Department",
      voidflag : "Cancel Or Not"
    },
  materialgetlist:{
    toget : "Pending Orders",
    get : "Official Requisiton Form",
    rownum : "Line",
    billno : "Official Document Code",
    demandbillno:"Requirement Document Code",
    createtime : "Application Date",
    createtime_begin : "Start Date",
    createtime_end : "End Date",
    demandtypename : "Requirement Type",
    projcode : "Subproject Code/Entrusted Vendor Code/Cost Center",
    projname : "Subproject Name",
    applyusername : "Applicant",
    operate : "Operation",
    todo : "Transact",
    batchtodo : "Batch Processing",
    choosedemand : "Please select material requisition requirement.",
    execunitname : "Construction Vendor",
    receivedate : "Time To Task Pool",
    plandate : "Billing Date",
    startdate : "Start Time",
    enddate : "End Time",
    storeid:"Warehouse",
    chcompanycode : "Company Code",
    demandtypeerror : "Please Select The Same Requirement Source Line Item!",
    sourcetypeerror : "Please Select The Same Requirement Source Line Item!",
    chbelongeregion:"Region",
    projcodeerror : "Please Select The Same Subproject Code/Entrusted Vendor Code/Cost Center Line Item!",
    execunitcodeerror : "Please Select The Same Constructor Line Item.",
    storeiderror : "Please Select The Same Subwarehouse Line Item",
    companycodeerror : "Please Select The Same Company Code Line Item.",
    belongeregionerror : "Please select the same region"
    },
  itemmaterialgetbillload:{
    plandate:"Billing Date",
    storedate:"Posting Date",
    planusername:"Material Coordinator",
    storeusername:"Warehouse Officer",
    orderno:"PO Number",
    chstore:"Warehouse",
    manuname:"Vendor Name",
    ordername:"PO Name",
    remark:"Remarks",
    demandinfo:"List Of Requirements",
    listinfo:"Delivery List",
    listnum:"Line",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    chunit:"UOM",
    applynum : "Application Quantity",
    donenum : "Quantity Of The Processed Orders",
    applysum : "Application Amount",
    plannum:"Billing Quantity",
    storenum:"Actual Quantity",
    price:"Unit Price",
    recsum:"Amount",
    projcode_out:"Subproject Code",
    projname_out:"Subproject Name",
    outprojname : "Entrustment Subproject Name",
    outprojcode : "Entrustment Subproject Code",
    investflag:"Subproject Goods Issue Type",
    costcenter:"Cost Center",
    zstrp:"Input Tax Transfer-Out Type",
    execunitname:"Construction Vendor",
    notes:"Remarks",
    serialno:"Inventory Batch",
    orimanuname:"Original Manufacturer",
    orimanuprodname:"Original Manufacturer’S Product Name",
    orimanuspec:"Original Manufacturer Specification Model",
    orimanudrip:"Product Description Of Original Manufacturer",
    billno:"Document Encoding",
    baseinfo:"Basic Information",
    unit : "Unit",
    bigtitle : "DELIVERY OF MATERIAL REQUISITION",
    chexecunitflag : "Construction Management Or Not",
    applyareaname : "Material Requisition Unit",
    proj_status : "Project Status",
    ifstoremanage : "Physical Stock Management Or Not",
    orgdemandbillno : "Material Requisition Form No.",
    chzstrp : "Input Tax Transfer-Out Type",
    evalclassname : "Valuation Class",
    storenum_que : "Available Inventory Quantity",
    onlinenum : "In-Transit Occupied Quantity",
    chinvestflag : "Project Goods Issue Type",
    tomatchstore : "Match Own Inventory",
    checknumtip:"The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    checkplannumtip:"The Line Item Bill Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    checkdemandnumtip : "The Bill quantity of this time + the processed quantity cannot be greater than the requirement application quantity",
    emptyrowlist : "This delivery list cannot be empty!",
    chcurrency : "Transaction Currency",
    chouttype2 : "Usage Category",
    belongeregion:"Region",
    outmanuno: "Entrusted Vendor Code",
    outmanuname : "Entrusted Vendor",
    aufnr: "Internal Order No"
    },
  othermaterialgetbillload:{
    plandate:"Billing Date",
    storedate:"Posting Date",
    planusername:"Material Coordinator",
    storeusername:"Warehouse Officer",
    orderno:"PO Number",
    storeid:"Warehouse",
    manuname:"Vendor Name",
    ordername:"PO Name",
    remark:"Remarks",
    demandinfo:"List Of Requirements",
    listinfo:"Delivery List",
    listnum:"Line",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    chunit:"UOM",
    applynum : "Application Quantity",
    donenum : "Quantity Of The Processed Orders",
    applysum : "Application Amount",
    plannum:"Billing Quantity",
    storenum:"Actual Quantity",
    price:"Unit Price",
    recsum:"Amount",
    projcode_out:"Subproject Code",
    projname_out:"Subproject Name",
    investflag:"Subproject Goods Issue Type",
    zstrp:"Input Tax Transfer-Out Type",
    execunitname:"Construction Vendor",
    notes:"Remarks",
    serialno:"Inventory Batch",
    orimanuname:"Original Manufacturer",
    orimanuprodname:"Original Manufacturer’S Product Name",
    orimanuspec:"Original Manufacturer Specification Model",
    orimanudrip:"Product Description Of Original Manufacturer",
    billno:"Document Encoding",
    baseinfo:"Basic Information",
    unit : "Unit",
    bigtitle : "DELIVERY OF MATERIAL REQUISITION",
    chexecunitflag : "Construction Management Or Not",
    applyareaname : "Material Requisition Unit",
    proj_status : "Project Status",
    ifstoremanage : "Physical Stock Management Or Not",
    orgdemandbillno : "Material Requisition Form No.",
    chzstrp : "Input Tax Transfer-Out Type",
    evalclassname : "Valuation Class",
    storenum_que : "Available Inventory Quantity",
    onlinenum : "In-Transit Occupied Quantity",
    chinvestflag : "Project Goods Issue Type",
    tomatchstore : "Match Own Inventory",
    checknumtip:"The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    checkplannumtip:"The Line Item Bill Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    checkdemandnumtip : "The Bill quantity of this time + the processed quantity cannot be greater than the requirement application quantity",
    emptyrowlist : "This delivery list cannot be empty!",
    chcurrency : "Transaction Currency"
    },
  itemdemandload:{
    bigtitle : "MATERIAL REQUISITION FORM",
    unit : "Unit",
    baseinfo:"Basic Information",
    billno:"Application Number",
    applyusername : "Applicant",
    applydeptname:"Application Department",
    applyareaname : "Application Region",
    createtime : "Prepared Date",
    applyuser_tel : "Telephone Number Of Applicant",
    rowbigtitle : "MATERIAL DETAILS",
    materialname : "Material Name",
    materialcode : "Material Code",
    spec : "Model",
    unitname : "UOM",
    uploadfile : "Attachment",
    rownum : "Line",
    demandtype : "Requirement Type",
    sourcetype : "Source Of Requirement",
    remark : "Remarks",
    price : "Estimated Unit Price",
    currency : "Transaction Currency",
    recsum : "Estimated Amount",
    applynum : "Application Quantity",
    projname : "Subproject Name",
    projcode : "Subproject Code",
    outprojname : "Entrustment Subproject Name",
    outprojcode : "Entrustment Subproject Code",
    execunitname : "Construction Vendor",
    investflag : "Project Goods Issue Type",
    zxslx : "Equivalent Sales Type",
    zstrp : "Input Tax Transfer-Out Type",
    linkaddress : "Shipping Address",
    linkuser : "Receiving Contact",
    linktel : "Receiving Contact Number",
    orimanuname : "Original Manufacturer",
    orimanuprodname : "Original Manufacturer’S Product Name",
    orimanuspec : "Original Manufacturer’S Product Specification Model",
    orimanudrip : "Product Description Of Original Manufacturer",
    notes : "Remarks",
    backusername : "Requirement Return Person",
    backnum : "Return Quantity",
    store_out : "Warehouse",
    planusername : "Material Coordinator",
    backreason : "Return Reason",
    execunitflag : "Management Of Construction Vendor Or Not",
    costcenter : "Cost Center",
    execunitcodeerror : "When the answer is“Yes” for whether to be the constractor, then the constractor must be filled in.",
    chouttype2: "Usage Category",
    belongeregion: "Region",
    outmanuname: "Entrusted Vendor",
    aufnr: "Internal Order No"
    },
  otherdemandload:{
    bigtitle : "MATERIAL REQUISITION FORM",
    unit : "Unit",
    baseinfo:"Basic Information",
    billno:"Application Number",
    applyusername : "Applicant",
    applydeptname:"Application Department",
    applyareaname : "Application Region",
    createtime : "Prepared Date",
    applyuser_tel : "Telephone Number Of Applicant",
    rowbigtitle : "MATERIAL DETAILS",
    materialname : "Material Name",
    materialcode : "Material Code",
    spec : "Model",
    unitname : "UOM",
    uploadfile : "Attachment",
    rownum : "S/N",
    demandtype : "Requirement Type",
    sourcetype : "Source Of Requirement",
    remark : "Remarks",
    price : "Estimated Unit Price",
    currency : "Transaction Currency",
    recsum : "Estimated Amount",
    applynum : "Application Quantity",
    projname : "O&M Project Name",
    projcode : "O&M Project Code",
    execunitname : "Construction Vendor",
    investflag : "Project Goods Issue Type",
    zxslx : "Equivalent Sales Type",
    zstrp : "Input Tax Transfer-Out Type",
    linkaddress : "Shipping Address",
    linkuser : "Receiving Contact",
    linktel : "Receiving Contact Number",
    orimanuname : "Original Manufacturer",
    orimanuprodname : "Original Manufacturer’S Product Name",
    orimanuspec : "Original Manufacturer’S Product Specification Model",
    orimanudrip : "Product Description Of Original Manufacturer",
    notes : "Remarks",
    store_out : "Warehouse",
    planusername : "Material Coordinator",
    backusername : "Requirement Return Person",
    backnum : "Return Quantity",
    backreason : "Return Reason",
    execunitflag : "Management Of Construction Vendor Or Not",
    costcenter : "Cost Center",
    usetype : "Usage Category",
    netelemname : "Network Element"
    },
    selectAufnrInfo:{
      title : "Select Internal Order",
      orderCode : "Internal Order No",
      remark : "Description",
      controlRange : "Control Range",
      orderType : "Purchase Order Type",
      profitsCenter : "Profit Center",
      orderCurrency : "PO Currency",
      reqstorematerialTips : "Please Select Internal Order Information"
    },
  serviceconfirm:{
    title:"SERVICE CONFIRMATION",
    baseinfoTab:"Basic Information",
    toserviceconfirmTab:"Service Confirmation Order Query",
    serviceconfirmTab:"Service Confirmation Document Query",
    orderno:"PO Number",
    ordername:"PO Name",
    manuname:"Vendor",
    stockusername:"Procurement Administrator",
    billno:"Bill No.",
    plandate:"Billing Date",
    storedate:"Posting Date",
    demandtype:"Requirement Type",
    remark:"Remarks",
    fileup:"Upload Attachment",
    listinfo:"List Information",
    manuno2:"Service Provider Code",
    manuname2:"Service Provider Name",
    materialcode:"Service Code",
    materialname:"Service Name",
    stocknum:"Purchase Quantity",
    price:"Unit Price",
    recnum:"Remaining Quantity",
    stockrecsum:"Order Amount",
    confirmedscale:"Proportion (%) - Issued Billing",
    confirmscale:"Proportion (%) - Current Billing",
    finsum:"Amount - Issued",
    recsum:"Amount - Current Billing",
    donlinenum:"Quantity - Issued",
    plannum:"Quantity - Current Billing",
    isfinish:"Final Receiving Finished Or Not",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    zstrp:"Input Tax Transfer-Out Type",
    notes:"Remarks",
    plannumMaxTips:"The Current Billing Quantity Cannot Be Greater Than The Receivable Quantity",
    reqplannumTips:"Please Enter The Value In The Input Box of The Bill Quantity of This Time",
    contractcode:"Legal Order Code",
    orderdate:"Order Date",
    startdate:"Start Date",
    enddate:"End Date",
    rececompleteflag:"Confirmed Or Not",
    onlinenum:"Quantity - In-Transit Billing",
    onlinesum:"Amount - In-Transit Billing",
    onlineconfirmscale:"Proportion (%) - In-Transit Billing",
    plannumMinTips:"The Bill Quantity Of This Time Cannot Be Greater Than The Already Issued Bill Quantity"
    },

    //===================================
    //人力系统公用
  hrcommon:{
    currstatus:"Handling Steps",
    curruser:"Current Handler",
    submitbtn: "Submit",
    copysucceed: "Copy Success",
    imgtypelimit:"Upload profile pictures only in {0} format!",
    uploadtip1:"The attachment is empty",
    uploadtip3:"Upload Fail",
    askifsumbit:"Whether to continue to submit？",
    },
    //组织管理
    //部门创建
  deptload:{
    deptadd :"DEPARTMENT CREATION APPLICATION",
    deptchange :"DEPARTMENT INFORMATION CHANGE APPLICATION",
    deptstop :"DEPARTMENT CANCELLATION APPLICATION",
    billno :"Document Number",
    applyuserid :"Applicant",
    contact :"Contact Information",
    applydate :"Application Date",
    compid :"Company",
    deptcode :"Department Code",
    deptname :"Department",
    deptshortname :"Department Abbreviation",
    pdeptid :"Higher Level Organization",
    deptcreatetime:"Establishment Time",
    effectivetime:"Effective Date",
    stopbillid :"Department Code",
    stopdate:"Deactivation Date",
    remark:"Remarks",
    inputPlaceholder:"Please Enter",
    prechange :"Department Information Before Change",
    aftchange :"Department Information After Change",
    deptinfo :"Department Information",

    changeMsg:"The dept is in the process of Change.",
    stopMsg:"The dept is in the process of Cancellation.",
    isRepeat:"Duplicate Department Code",
    beforeSelectDept:"Please Select Company",
    beforeSelectPost:"Please select department",
    },
  deptlist:{
    indexMethod:"S/N",
    billno:"Document Number",
    applydate:"Application Date",
    compid:"Company Name",
    deptshortname:"Department Abbreviation",
    deptname:"Department",
    deptcode:"Department Code",
    pdeptid:"Higher Level Organization",
    effectivetime:"Effective Date",

    curruserid:"Current Approver",

    tab1:"Department Creation Form",
    tab2:"Archiving Documents"
    },
    //部门变更
  deptchangeload:{
    deptchange :"DEPARTMENT INFORMATION CHANGE APPLICATION",
    billno :"Document Number",
    applyuserid :"Applicant",
    contact :"Contact Information",
    applydate :"Application Date",
    compid :"Company",
    deptcode :"Department Code",
    deptname :"Department",
    deptshortname :"Department Abbreviation",
    pdeptid :"Higher Level Organization",
    deptcreatetime:"Establishment Time",
    effectivetime:"Effective Date",
    stopbillid :"Department Code",
    remark:"Remarks",
    inputPlaceholder:"Please Enter",
    prechange :"Department Information Before Change",
    aftchange :"Department Information After Change",
    deptinfo :"Department Information",
    },
  deptchangelist:{
    indexMethod:"S/N",
    billno:"Document Number",
    applydate:"Application Date",
    predeptname:"Department Name Before Change",
    deptname:"Department Name After Change",
    compid:"Company Name",
    pdeptid:"Higher Level Organization",
    effectivetime:"Effective Date",

    curruserid:"Current Approver",

    tab1:"Department Change Form",
    tab2:"Archiving Documents"
    },
    //部门停用
  deptstopload:{
    deptstop :"DEPARTMENT CANCELLATION APPLICATION",
    billno :"Document Number",
    applyuserid :"Applicant",
    contact :"Contact Information",
    applydate :"Application Date",
    compid :"Company",
    deptcode :"Department Code",
    deptname :"Department",
    deptshortname :"Department Abbreviation",
    pdeptid :"Higher Level Organization",
    deptcreatetime:"Establishment Time",
    effectivetime:"Effective Date",
    stopdate:"Deactivation Date",
    remark:"Remarks",
    inputPlaceholder:"Please Enter",
    deptinfo :"Department Information",
    },
  deptstoplist:{
    indexMethod:"S/N",
    billno:"Document Number",
    applydate:"Application Date",
    compid:"Company Name",
    deptname:"Department",
    deptcode:"Department Code",
    pdeptid:"Higher Level Organization",
    stopdate:"Deactivation Date",

    curruserid:"Current Approver",

    tab1:"Department Cancellation Form",
    tab2:"Archiving Documents"
    },
    //公司创建
  companyload:{
    companyadd :"COMPANY CREATION APPLICATION",
    billno :"Document Number",
    applyuserid :"Applicant",
    contact :"Contact Information",
    applydate :"Application Date",
    compname :"Company Name",
    compshortname :"Company Abbreviation",
    compno :"Company Code",
    effectivetime :"Effective Date",
    porgid :"Superior Company",
    stopbillid :"Company Code",
    busiaddr:"Business Address",
    remark:"Remarks",
    inputPlaceholder:"Please Enter",
    companyinfo :"Corp. Information",

    changeMsg:"The company is in the process of change.",
    stopMsg:"The company is in the process of cancellation.",
    isRepeat:"Duplicate Company Code",
    },
  companylist:{
    indexMethod:"S/N",
    billno:"Document Number",
    applydate:"Application Date",
    compname:"Company Name",
    compshortname:"Company Abbreviation",
    compno:"Company Code",
    porgid:"Superior Company",
    effectivetime:"Effective Date",

    curruserid:"Current Approver",

    tab1:"Company Creation Form",
    tab2:"Archiving Documents"
    },
    //公司变更
  companychangeload:{
    companychange :"COMPANY CHANGE APPLICATION",
    billno :"Document Number",
    applyuserid :"Applicant",
    contact :"Contact Information",
    applydate :"Application Date",
    compname :"Company Name",
    compshortname :"Company Abbreviation",
    compno :"Company Code",
    effectivetime :"Effective Date",
    porgid :"Higher Level Organization",
    stopbillid :"Company Code",
    busiaddr:"Business Address",
    remark:"Remarks",
    inputPlaceholder:"Please Enter",
    prechange :"Company Information Before Industrial And Commercial Registration Change",
    aftchange :"Company Information After Industrial And Commercial Registration Change",
    companyinfo :"Corp. Information",
    },
  companychangelist:{
    billno:"Document Number",
    indexMethod:"S/N",
    applydate:"Application Date",
    precompname:"Company Name Before Change",
    compname:"Company Name After Change",
    compno:"Company Code",
    porgid:"Superior Company",
    effectivetime:"Effective Date",

    curruserid:"Current Approver",

    tab1:"Company Change Form",
    tab2:"Archiving Documents"
    },
    //公司停用
  companystopload:{
    companystop :"COMPANY CANCELLATION APPLICATION",
    billno :"Document Number",
    applyuserid :"Applicant",
    contact :"Contact Information",
    applydate :"Application Date",
    compname :"Company Name",
    compshortname :"Company Abbreviation",
    compno :"Company Code",
    effectivetime :"Effective Date",
    porgid :"Higher Level Organization",
    stopdate:"Deactivation Date",
    busiaddr:"Business Address",
    remark:"Remarks",
    inputPlaceholder:"Please Enter",
    companyinfo :"Corp. Information",
    },
  companystoplist:{
    indexMethod:"S/N",
    billno:"Document Number",
    applydate:"Application Date",
    compname:"Company Name",
    compshortname:"Company Abbreviation",
    compno:"Company Code",
    porgid:"Superior Company",
    stopdate:"Deactivation Date",

    curruserid:"Current Approver",

    tab1:"Company Cancellation Form",
    tab2:"Archiving Documents"
    },
    //岗位创建
  positionload:{
    position :"NEW POSITION",
    companyid :"Company",
    deptid :"Department",
    positionno :"Position Code",
    positionname :"Position Name",
    dutyname :"Job Title",
    positionseq :"Position Sequence",
    positionlevel :"Post Hierarchy",
    positionshortname :"Position Name Abbreviation",
    createtime :"Creation Time",
    positiongrade :"Post Grades",
    remark :"Remarks",
    inputPlaceholder:"Please Enter",

    changeMsg:"The position is in the process of change.",
    stopMsg:"The position is in the process of cancellation.",
    isRepeat:"Position Code Duplicate",
    isleader:"Department Leader or No",
    checkleadtip:"This Department Has Set Department Leader Under {0} Position, Please Reselect!"
    },
  positionlist:{
    indexMethod:"S/N",
    applydate:"Application Date",
    deptid:"Department Name",
    positionshortname:"Position Name Abbreviation",
    positionname:"Position Name",
    positionno:"Position Code",
    positionseq:"Position Sequence",

    curruserid:"Current Approver",

    tab1:"Position Creation Form",
    tab2:"Archiving Documents"
    },
    //岗位变更
  positionchangeload:{
    position :"POSITON CHANGE",
    companyid :"Company",
    deptid :"Department",
    positionno :"Position Code",
    prepositionname :"Original Position Name",
    predutyname :"Original Job Title",
    prepositionseq :"Original Position Sequence",
    positionname :"Current Position Name",
    dutyname :"Current Job Title",
    positionseq :"Current Position Sequence",
    positionlevel :"Current Position Level",
    positionshortname :"Current Position Name Abbrev.",
    createtime :"Creation Time",
    positiongrade :"Current Position Grade",
    remark :"Remarks",
    inputPlaceholder:"Please Enter"
    },
  positionchangelist:{
    indexMethod:"S/N",
    applydate:"Application Date",
    deptid:"Department Name",
    prepositionname:"Original Position Name",
    positionname:"Current Position Name",
    positionno:"Position Code",
    positionseq:"Current Position Sequence",

    curruserid:"Current Approver",

    tab1:"Position Change Form",
    tab2:"Archiving Documents"
    },
    //岗位停用
  positionstopload:{
    position :"POSITION CANCELLATION",
    companyid :"Company",
    deptid :"Department",
    positionno :"Position Code",
    positionname :"Position Name",
    dutyname :"Job Title",
    positionseq :"Position Sequence",
    positionlevel :"Post Hierarchy",
    positionshortname :"Position Name Abbreviation",
    stopdate:"Deactivation Date",
    positiongrade :"Post Grades",
    remark :"Remarks",
    inputPlaceholder:"Please Enter"
    },
  positionstoplist:{
    indexMethod:"S/N",
    applydate:"Application Date",
    deptid:"Department Name",
    positionname:"Position Name",
    positionno:"Position Code",
    positionseq:"Position Sequence",
    stopdate:"Deactivation Date",

    curruserid:"Current Approver",

    tab1:"Position Suspension",
    tab2:"Archiving Documents"
    },
    //人事管理
  SelectStaffInfo:{
    title :"PERSONNEL SELECTION",
    rownum:"S/N",
    username : "Username",
    account:"Account Number",
    deptname:"Department",
    clear:"Clear",
    query:"Query",
    placeholder:"Enter Keyword to Search",
    confirm:"OK",
    cancel:"Cancel",
    nomsg :"No Data Available",

    },
  SelectPostInfo:{
    title :"POST SELECTION",
    rownum:"S/N",
    positionname : "Position Name",
    positionno:"Positon Number",
    deptname:"Department",
    clear:"Clear",
    query:"Query",
    placeholder:"Enter Keyword to Search",
    confirm:"OK",
    cancel:"Cancel",
    nomsg :"No Data Available",
    nullmsg:"Please input the information",
    },
    //员工入职
  staffentrybaseinfo:{
    baseTitle:"Basic Information",
    midname:"Middle Name",
    fielphto:"ID Photo",
    delImage:"Delete Photos",
    famname:"Last Name",
    name:"First Name",
    gender:"Gender",
    birthday:"Date of Birth",
    age:"Age",
    insource:"Source of Entry into the Company",
    incomptime:"Entry Time",
    marstatus:"Marital Status",
    mobile:"Mobile Number",
    phone:"Fixed Telephone",
    openbank:"Deposit Bank",
    remitbank:"Remittance Bank",
    bankcardnum:"Bank Account Number",
    payeeaddress:"Payee Address",
    accounttype:"Account Type",

    height:"Height",
    religion:"Religion",
    weight:"Weight",
    language:"Language / Dialect",
    peraddr:"Permanent Address",
    peraddrtype:"Permanent Address Type",
    curraddr:"Current Address",
    curraddrtype:"Current Address Type",
    taxnum:"Tax Identification Number",
    sssnum:"SSS Number",
    pagibignum:"PAG-IBIG  Number",
    phno:"PHILHEALTH Number",
    emercontact:"Emergency Contact Name",
    emerelation:"Relationship (Emergency Contact)",
    emeraddr:"Address (Emergency Contact)",
    emermobile:"Mobile Number（Emergency Contact）",
    emerphone:"Fixed Telephone (Emergency Contact)",
    prcnum:"PRC LICENSE NO",
    prcexpirydate:"Valid Until (PRC LICENSE NO.)",

    email:"Work E-Mail",
    personalemail:"Personal E-mail",
    nationality:"Nationality",
    appellation:"Appellation",
    suffix:"Suffix",
    mailaddress:"Mail Address (Emergency Contact)",
    emailaddress:"E-mail Address (Emergency Contact)",
    staffadmin:"Personnel Administrator",

    technical:"Special Skill",
    mapfile:"Residential Map Annex",

    delscuphotip:"Delete Photo Successfully",
    delfailrphotip:"Photo Deletion Failed",
    },
  staffentryeduinfo:{
    entryeduinfo:"Education Experience",
    indexMethod:"S/N",
    edubegintime:"Enrollment Date",
    eduendtime:"Graduation Date",
    eduschooltype:"School Type",
    edubackgrounp:"Degree",

    edumajor:"University/College/School",
    eduschool:"School Type",
    eduawards:"Awards / Honors",
    },
  staffentryfamilyinfo:{
    familyinfo:"Family Information",
    indexMethod:"S/N",
    fappellation:"Title",

    fmemname:"Family Member Name",
    fbirth:"Date of Birth",
    foccupation:"Occupation",
    },
  staffentrytraininginfo:{
    traininginfo:"Trained Experience",
    indexMethod:"S/N",

    trabegintime:"Start Time",
    traendtime:"End Time",
    trattitle:"Title",
    tragrantor:"Grantor",
    },
  staffentryofficialexaminfo:{
    officialexaminfo:"Official Examination Information",
    indexMethod:"S/N",

    examname:"Government Exams Taken",
    examdate:"Date Taken",
    examgrade:"Grade",
    },
  staffentrycommunityinfo:{
    communityinfo:"Community Information",
    indexMethod:"S/N",

    communityname:"Past or Current Work Organization or any Club / Association / Business / Labor Union",
    communitypost:"Position",
    communitybegintime:"Start Time",
    communityendtime:"End Time",
    },
  staffentrylanginfo:{
    langinfo:"Language Ability",
    indexMethod:"S/N",
    languages:"Languages",
    lanlevel:"Language Level",
    lanproficiency:"Language Proficiency",
    },
  staffentrycontractinfo:{
    contractinfo:"Contract Info",
    indexMethod:"S/N",
    contbegintime:"Start Date",
    contendtime:"End Date",
    contno:"Contract Number",
    conttype:"Contract Type",
    contvalidate:"Expiry Date",
    contworkplace:"Working Place",
    contprobation:"Probation Period",
    },
  staffentrylist:{
    tab1:"Employment Application Form",
    tab2:"Archiving Documents",
    billno:"Document Number",
    indexMethod:"S/N",
    applydate:"Application Date",
    applydept:"Application Department",
    applyuser:"Applicant",
    currstatus:"Handling Steps",
    },
  staffentryload:{
    staffentry:"ONBOARDING",
    },
  staffentryresumeinfo:{
    resumeinfo:"Resume Record",
    indexMethod:"S/N",
    resumebegintime:"Resume Start Date",
    resumeendtime:"Resume End Date",
    workposition:"Position",

    workcompany:"Company",
    leavereason:"Reason for Leaving",
    salary:"Salary",
    superleader:"Superior Leader Name",
    superleaderrelate:"Relationship (With Superior Leader)",
    superleaderpost:"Position (Superior Leader)",
    superleadercontact:"Contact Information",
    },
  staffentryworkinfo:{
    workinfo:"Work Information",
    company:"Company",
    personscope:"Personnel Area",
    personno:"Personnel Coding",
    persontype:"Employee Group",
    subpersontype:"Employee Subgroup",
    duty:"Job",
    deptid:"Department",
    position:"Position Name",
    positiongrade:"Post Grades",
    positionlevel:"Post Hierarchy",
    positionseq:"Position Sequence",
    },
    //员工借调
  secondedlist:{
    tab1:"Employee Secondment Form",
    tab2:"Archiving Documents",
    billno:"Document Number",
    indexMethod:"S/N",
    applydate:"Application Date",
    applydept:"Application Department",
    applyuser:"Applicant",
    username:"Personnel Name",
    usercode:"Personnel Coding",
    postname:"Position Name",
    deptname:"Department",
    dutyname:"Job Title",
    idcard:"Id Number",
    gender:"Gender",
    secunit:"Secondment Company",
    checkintime:"Registration Date",
    currstatus:"Handling Steps",
    curruser:"Current Handler"
    },
  secondedload:{
    title:"SECONDMENT APPLICATION",
    billno:"Document Number",
    applyuser:"Applicant",
    applydate:"Application Date",
    tabtitle:"Secondment Information",
    secbegintime:"Secondment Start Time",
    secendtime:"End Date of Secondment",
    staffunit:"Seconded Employee",
    contact:"Contact Information",
    checkintime:"Registration Date",
    contactuser:"Contacts",
    secresson:"Reason for Secondment"
    },
  secondedbaseinfo:{
    baseTitle:"Basic Information",
    fullname:"Full Name",
    midname:"Middle Name",
    fielphto:"ID Photo",
    delImage:"Delete Photos",
    famname:"Last Name",
    name:"First Name",
    idcard:"Id Number",
    gender:"Gender",
    birthday:"Date of Birth",
    age:"Age",
    birthplace:"Native Place",
    nationality:"Nationality",
    insource:"Source of Entry into the Company",
    worktime:"Time/Date of starting to work",
    incomptime:"Entry Time",
    health:"Physical Condition",
    marstatus:"Marital Status",
    email:"E-Mail",
    familyaddr:"Home Address",
    mobile:"Mobile Phone",
    phone:"Fixed Telephone",
    workage:"Social Work Age",
    compworkage:"Work Age Of This Company",
    emercontacttele:"Emergency Contact Number",
    emercontactuser:"Emergency Contact Name",
    openbank:"Deposit Bank",
    remitbank:"Remittance Bank",
    bankcardnum:"Bank Card Number",
    },
  secondedworkinfo:{
    workinfo:"Work Information",
    company:"Company",
    personscope:"Personnel Area",
    subpersonscope:"Personnel Subareas",
    salaryscope:"Payroll Area",
    workplan:"Scheduling Plan",
    costcenter:"Cost Center",
    personno:"Personnel Coding",
    persontype:"Employee Group",
    subpersontype:"Personnel Subcategory",
    duty:"Job",
    deptid:"Department",
    position:"Position Name",
    positiongrade:"Post Grades",
    positionlevel:"Post Hierarchy",
    positionseq:"Position Sequence",
    },
    //人员档案查询
  filemanage:{
    username:"Personnel Name",
    usercode:"Personnel Coding",
    postname:"Position Name",
    deptname:"Department",
    dutyname:"Job Title",
    idcard:"Id Number",
    gender:"Gender",
    filemanageload:"EMPLOYEE FILE"
    },
    //人员维护信息
  staffmaintain:{
    tab1:"Employee Information Maintenance Form",
    tab2:"Archiving Documents",
    username:"Personnel Name",
    usercode:"Personnel Coding",
    postname:"Position Name",
    deptname:"Department",
    dutyname:"Job Title",
    idcard:"Id Number",
    gender:"Gender",
    currstatus:"Handling Steps",
    curruser:"Current Handler",
    transfer:"Appointment and Dismissal Information",
    begintime:"Start Date",
    endtime:"End Date",
    postgrade:"Post Grades",
    postlevel:"Post Hierarchy",
    postseq:"Position Sequence",
    reson:"Reason for Appointment",
    remark:"Remarks",
    dept:"Department",
    post:"Position",
    traninginfo:"Professional Training Record",
    trattitle:"Training Activity Name",
    trabegintime:"Training Start Date",
    traendtime:"Training End Date",
    tratype:"Training Category",
    traway:"Training Mode",
    tratarget:"Training Objectives",
    tracontent:"Training Content",
    learnresult:"Evaluation of Learning Level",
    behaviorresult:"Performance Evaluation",
    hostunit:"Sponsor Unit",
    trahours:"Training Hours",
    awarddate:"Award Date",
    tracertiname:"Training certificate name",
    travalidity:"Validity Period",
    certilevel:"Certificate Level",
    tracertino:"Training Certificate Number",
    traaddr:"Training Location",
    traremark:"Remarks",
    trialinfo:"Probation Situation",
    tritype:"Probation Type",
    tribegintime:"Start Date",
    triendtime:"End Date",
    tritime:"Date of Employment Confirmation",
    triresult:"Result of Probation",
    tribillend:"End or not",
    triremark:"Remarks",
    savetip:"Please Select the Maintenance Personnel Before Saving.",
    selectusertip:"This User Has In-Transit Maintenance Documents, Please Select Again.",
    selectuser:"Personnel Selection",
    staffmaintainload:"PERSONNEL INFORMATION MAINTENANCE",
    },
    //员工调动
  transferlist:{
    indexMethod:"S/N",

    tranferusername:"Personnel Name",
    tranferuserid:"Personnel Coding",
    positionname:"Position Name",
    transferdeptname:"Department",
    dutyname :"Job Title",
    idcard: "Id Number",
    sex: "Gender",
    effectivetime:"Effective Time of Transfer",

    curruserid:"Current Approver",

    tab1:"Employee Transfer Form",
    tab2:"Archiving Documents"
    },
  transferload:{
    save:"Save",
    inputPlaceholder:"Please Enter",
    selectedPlaceholder: "Please Select",

    transferload:"TRANSFER APPLICATION",
    personInfo:"Personnel Information",
    preInfo:"Information Before Transfer",
    aftInfo:"Information after Transfer",

    billno:"Document Number",
    applyuserid:"Applicant",
    applydate:"Application Date",

    tranferuserid:"Transfer Personnel",
    tranferusercode:"Transfer Personnel Code",
    tranferreason:"Transfer Reason",
    effectivetime:"Effective Date of Transfer",
    tranferremark:"Transfer Description",

    precompanyid:"Company",
    predeptid:"Department",
    preusertype:"Employee Group",
    prepdeptid:"Higher Level Organization",
    preposition:"Position",
    prepositionseq:"Position Sequence",
    prepositonleavel:"Post Hierarchy",
    prepositiongrade:"Post Grades",
    prepersonscope:"Personnel Area",
    presubpersontype:"Employee Subgroup",
    prestaffadmin:"Personnel Administrator",

    companyid:"Company",
    deptid:"Department",
    usertype:"Employee Group",
    position:"Position",
    pdeptid:"Higher Level Organization",
    positionseq:"Position Sequence",
    positionlevel:"Post Hierarchy",
    positiongrade:"Post Grades",
    workreason:"Reason for Appointment",
    isprobation:"Trial Or Not",
    probbegintime:"Start Time of Probation",
    probendtime:"End Time of Probation",
    remark:"Remarks",
    personscope:"Personnel Area",
    subpersontype:"Employee Subgroup",
    staffadmin:"Personnel Administrator",

    isTransferring: "The person is under transfer",
    },
    //员工转正
  regularlist:{
    indexMethod:"S/N",

    regularusername:"Personnel Name",
    regularuserid:"Personnel Coding",
    positionname:"Position Name",
    regulardeptname:"Department",
    dutyname :"Job Title",
    idcard: "Id Number",
    sex: "Gender",
    regulartime:"Employment Confirmation Date",

    curruserid:"Current Approver",

    tab1:"Employment Confirmation Form",
    tab2:"Archiving Documents"
    },
  regularload:{
    save:"Save",
    inputPlaceholder:"Please Enter",
    selectedPlaceholder: "Please Select",

    regularload:"APPLICATION FOR CORRECTION",
    personInfo:"Personnel Information",
    preInfo:"Information Before Employment Confirmation",
    aftInfo:"Information After Employment Confirmation",

    billno:"Document Number",
    applyuserid:"Applicant",
    applydate:"Application Date",

    regularuserid:"Right Person",
    trialtype:"Probation Type",
    trialbegintime:"Start Time of Probation",
    trialendtime:"End Time of Probation",
    trialresult:"Result of Probation",
    extregulartime:"Extension of Probation Period",
    remark:"Description",

    precompanyid:"Company",
    predeptid:"Department",
    preusertype:"Employee Group",
    preuserduty:"Job",
    prepdeptid:"Higher Level Organization",
    prepositionseq:"Position Sequence",
    preposition:"Position",
    prepositonleavel:"Post Hierarchy",
    prepositiongrade:"Post Grades",
    prepersonscope:"Personnel Area",
    presubpersontype:"Employee Subgroup",
    prestaffadmin:"Personnel Administrator",

    companyid:"Company",
    deptid:"Department",
    usertype:"Employee Group",
    userduty:"Job",
    pdeptid:"Higher Level Organization",
    positionseq:"Position Sequence",
    position:"Position",
    positionlevel:"Post Hierarchy",
    positiongrade:"Post Grades",
    salaryadvice:"Salary Proposal",
    personscope:"Personnel Area",
    subpersontype:"Employee Subgroup",
    staffadmin:"Personnel Administrator",

    isRegulating: "The person is under employment confirmation",
    isNotTrial: "The person is not on probation",
    hasRegular: "The emplyment of the employee has been confirmed",
    hasStopContract: "The person has terminated the contract",
    },
    //员工离职
  resignlist:{
    indexMethod:"S/N",

    resignusername:"Personnel Name",
    resignuserid:"Personnel Coding",
    positionname:"Position Name",
    resigndeptname:"Department",
    dutyname :"Job Title",
    resigntype :"Resignation Type",
    idcard: "Id Number",
    sex: "Gender",
    effectivetime:"Effective Date of Resignation",

    curruserid:"Current Approver",

    tab1:"Employee Resignation Form",
    tab2:"Archiving Documents"
    },
  resignload:{
    save:"Save",
    resignapply:"RESIGNATION APPLICATION",
    billno:"Document Number",
    applyuserid:"Applicant",
    applydate:"Application Date",
    resigninfo:"Resignation Information",
    resignuserid:"Resignation Personnel",
    resigncompany:"Company",
    resigndeptid:"Department",
    resignpdeptid:"Higher Level Organization",
    preusertype:"Staff Group Before Resignation",
    aftusertype:"Staff Group After Resignation",
    resigntype:"Business Type of Resignation",
    effectivetime:"Effective Date of Resignation",
    proresigntime:"The Submission Date of Resignation Application",
    remark:"Remarks",
    inputPlaceholder:"Please Enter",
    selectedPlaceholder: "Please Select",

    isResigning: "The person is under resignation",
    },
    //人员入职
    //人员入职
  onboardinglist:{
    newnotice:"New Employee Onboarding Notice",

    famname:"Last Name",
    midname:"Middle Name",
    name:"First Name",
    email:"E-Mail",
    ifrejected :"Status",
    reject :"Offer Rejected",
    askreject :"Whether to refuse staff or not？",

    personname:"Personnel Name",
    personno:"Personnel Coding",
    positionname:"Position Name",
    deptid:"Department",
    dutyname :"Job",
    gender:"Gender",

    curruserid:"Current Approver",

    tab1:"New Employee Onboarding Notice",
    tab2:"Onboarding Management",
    tab3:"Archiving Documents"
    },
  onboardingemailload:{
    baseTitle:"NEW EMPLOYEE ONBOARDING NOTICE",

    send:"Send",
    email:"E-Mail",
    famname:"Last Name",
    midname:"Middle Name",
    name:"First Name",

    copypersonaddr:"Generate External Net Address",
    title:"Title",
    },
  onboardingload:{
    baseTitle:"ONBOARDING",
    ifsubmit:"Do you want to submit? Cannot edit again after submitting!"
    },
    //试用期评估
  evaluationlist:{
    emailnotice:"Email Notification",
    evaluationlaunch:"Initiate Onboarding Evaluation",

    famname:"Last Name",
    midname:"Middle Name",
    name:"First Name",
    email:"E-Mail",
    personnelcode:"Personnel Coding",

    billno:"Document Number",
    applydate:"Application Date",
    personno:"Name of the Evaluated",
    deptid:"Department of the Evaluated Person",
    examresults:"Onboarding Exam Result",
    evaresults:"Assessment Result",

    curruserid:"Current Approver",

    tab1:"Email Notification",
    tab2:"Probation Evaluation",
    tab3:"Archiving Documents",
    },
  evaluationemailload:{
    send:"Send",
    person:"Personnel",

    title:"Title",
    },
  evaluationload:{
    evaluationapply:"NEW EMPLOYEE ONBOARDING EVALUATION",

    billno:"Document Number",
    applyuserid:"Applicant",
    applydate:"Application Date",
    personno:"Evaluated Person",
    deptid:"Department",
    examresults:"Onboarding Exam Result",
    evaresults:"Assessment Result",

    traininfo:"Onboarding Infomation",
    trabegintime:"Start Time",
    traendtime:"End Time",
    trainitem:"Training Events",
    trainperson:"Training Staff",
    trainresult:"Training Results",
    trainidea:"Training Opinion",

    hridea:"HR Specialist‘s Comment",
    leadidea:"Department Leader’s Evaluation Comment",

    isEvaluating: "The person is being evaluated",
    },
  commonlist:{
    msg : "Are you sure to delete the document?",
    tiptitle : "PROMPT",
    confirm : "OK",
    cancel : "Cancel",
    cancelmsg : "Operation Canceled",
    choosedelbill : "Please select the document to delete.",
    chooseapplydept : "Please select the application Dept."
    },
    //===================================
  givedemand:{
    title:"GIFT REQUISITION FORM",
    baseinfoTab:"Basic Information",
    applyareaname : "Application Region",
    applydeptname:"Application Department",
    applyusername : "Applicant",
    billno : "Application Number",
    applyuser_tel : "Telephone Number Of Applicant",
    createtime:"Application Date",
    givesource:"Gift Source",
    invoiceno:"Invoice",
    taxrate:"Comprehensive Tax Rate",
    manuno:"Vendor Code",
    manuname:"Vendor Name",
    remark:"Remarks (Within 200 Chinese Characters)",
    fileup:"Upload Attachment",
    materialWrap:"Material Requirement Details",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    unitid:"UOM",
    price:"Unit Price",
    applynum:"Quantity",
    recsum:"Fair Value / Amount",
    notes:"Remarks (Within 200 Chinese Characters)",
    backusername : "Requirement Return Person",
    backnum : "Return Quantity",
    backreason : "Return Reason",
    billno2 : "Document Encoding",
    brecbillno : "Official Document Code",
    chdemandstatus : "Requirement Status",
    startdate:"Start Date",
    enddate:"End Date",
    remark2:"Remarks",
    currency:"Transaction Currency"
    },
  bkdemand:{
    title:"INVENTORY PREPARATION REQUISITION FORM",
    baseinfoTab:"Basic Information",
    applyareaname : "Application Region",
    applydeptname:"Application Department",
    applyusername : "Applicant",
    billno : "Application Number",
    applyuser_tel : "Telephone Number Of Applicant",
    createtime:"Application Date",
    remark:"Purchase Reason / Purchase Details",
    fileup:"Upload Attachment",
    materialWrap:"Material Requirement Details",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    unitid:"UOM",
    price:"Estimated Unit Price",
    applynum:"Application Quantity",
    recsum:"Estimated Amount",
    notes:"Remarks",
    backusername : "Requisition Return Person",
    backnum : "Return Quantity",
    backreason : "Return Reason",
    billno2 : "Document Encoding",
    brecbillno : "Official Document Code",
    chdemandstatus : "Requirement Status",
    startdate:"Start Date",
    enddate:"End Date",
    receiveaddress:"Shipping Address",
    receivecontacts:"Receiving Contact",
    receivecontactphone:"Receiving Contact Number",
    chplanuserid_in:"Material Coordinator",
    stockamount:"Procurement Budget",
    currtype:"Functional Currency",
    store_out:"Warehouse",
    stockuserid:"Procurement Administrator",
    costcenter:"Cost Center"
    },
  impEsn:{
    title:"IMPORTING STRING CODE",
    imp4excel:"Excel Import",
    imp4txt:"Txt File Import",
    imp4write:"Scanning Or Manual Entry",
    impTemplate:"Import Excel Template",
    clickDownload:"Click Here To Download The Excel Template",
    excelFileImp:"Excel Import",
    browse: "Browsing",
    import: "Import",
    isOverwriteImp:"Overwrite Import Or Not",
    over: "Cover",
    append: "Append",
    reqfileTips:"Please Click to Browse and Select the Import File!",
    esn:"Serial Number",
    imperrormsg:"Import Status",
    close:"Close",
    save:"Save",
    errormsg:"Error Alert",
    saveEsnSuccedTips:"The string code has been saved. To save again, select the data to import first!",
    saveEsnSuccTips:"String code saved successfully!",
    impingTips:"Importing. Please Import Later!",
    impErrorMsg1:"In the import result, the",
    impErrorMsg2:"There is an error in the line. Please handle the error line of the import result, and then save it!",
    deleteEsnConfig:"Are you sure to delete?",
    txtFileImp:"Txt File Import",
    reqfileTips2:"Please Click to Browse, and Select the Import File or Enter String Code Data Manually!",
    esntext:"String Code (Press 'Enter' to split and enter one string code each line.)",
    reqesntextTips:"Please enter the string code first!"
    },
  selectstorematerial:{
    title:"SELECT INVENTORY MATERIAL",
    storedate:"Stock-In Time",
    materialname:"Material Name",
    materialcode:"Material Code",
    spec:"Model",
    chunit:"Unit",
    storenum:"Inventory Quantity",
    usablestorenum:"Available Inventory Quantity",
    onlinenum:"In-Transit Occupied Quantity",
    orderno:"Order Number",
    serialno:"Batch",
    price:"Batch Price",
    proj:"Subproject",
    chstore:"Warehouse",
    degree:"Inventory Attribute",
    sobkz:"Stock Type",
    manuno:"Vendor",
    projcode:"Subproject Code",
    chstoreuser:"Warehouse Officer",
    recbillremark:"Remarks",
    applynum:"Application Quantity",
    confirm:"OK",
    reqstorematerialTips:"Please select inventory material!",
    reqapplynumTips:"Please enter the application quantity!",
    checkapplynumTips1:"The",
    checkapplynumTips2:"The Application Quantity of The Line Cannot Be Greater Than The Available Inventory Quantity!",
    reqstoreTips:"Please select warehouse.",
    chcurrency:"Transaction Currency",
    checkapplynumTips3:"The Available Inventory Quantity of The Line Is 0, Unable To be Selected!"
    },
  discarddemand:{
    title:"SCRAPPING REQUISITION FORM",
    baseinfoTab:"Basic Information",
    applyareaname : "Application Region",
    applydeptname:"Application Department",
    applyusername : "Applicant",
    billno : "Application Number",
    applyuser_tel : "Telephone Number Of Applicant",
    createtime:"Application Date",
    chstore_out: "Warehouse",
    remark:"Scrap Reason",
    fileup:"Upload Attachment",
    materialWrap:"Material Requirement Details",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec : "Model",
    unitid:"UOM",
    price:"Unit Price",
    currency : "Transaction Currency",
    applynum : "Scrap Quantity",
    recsum : "Total Amount",
    degree:"Inventory Attribute",
    serialno:"Inventory Batch",
    billno2 : "Document Encoding",
    brecbillno : "Official Document Code",
    chdemandstatus : "Requirement Status",
    startdate:"Start Date",
    enddate:"End Date",
    remark2:"Scrap Reason",
    ifabnormallosses:"Abnormal Loss Or Not",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    checkapplynumtip:"The Line Item Scrap Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    costcenter: "Cost Center"
    },
  materialmove:{
    title:"WAREHOUSE TRANSFER APPLICATION FORM",
    baseinfoTab:"Basic Information",
    tomaterialmoveTab:"Pending Orders",
    materialmoveTab:"Official Warehouse Transfer Application Form",
    choosedemand : "Please select warehouse transfer requirement.",
    billno:"Bill No.",
    plandate:"Billing Date",
    storedate:"Posting Date",
    planusername:"Material Coordinator",
    storeid:"Move Out Of Warehouse",
    storeuserid:"Warehouse Officer Of Goods Issue",
    storeid_in:"Move Into Warehouse",
    storeuserid_in:"Warehouse Officer Of Goods Receipt",
    logistics_cost_borne:"Logistics Cost Payer",
    expected_logistics_recsum:"Estimated Logistics Fee",
    sourcetype:"Source Of Requirement",
    remark:"Remarks",
    demandlistinfo:"List Of Requirements",
    orgdemandbillno:"Warehouse Transfer Requisiton Form No",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    unitid:"UOM",
    price:"Unit Price",
    currency:"Transaction Currency",
    donenum:"Issued Order Quantity",
    applynum:"Application Quantity",
    recsum:"Amount",
    notes:"Remarks",
    listinfo:"Goods Transfer-Out List This Time",
    storenum_que:"Available Inventory Quantity",
    onlinenum:"In-Transit Occupied Quantity",
    plannum:"Billing Quantity",
    storenum:"Actual Quantity",
    recsum2:"Amount",
    serialno:"Inventory Batch",
    notes2:"Remarks",
    orimanuname:"Original Manufacturer",
    manuname:"Vendor",
    orimanuspec:"Product Model Of Original Manufacturer",
    degree:"Inventory Attribute",
    demandbillno:"Requirement Document Code",
    applyusername:"Applicant",
    createtime:"Application Date",
    receivedate:"Time To Task Pool",
    calltypename:"Allocation Type",
    movetypename:"Initiated By",
    startdate:"Start Date",
    enddate:"End Date",
    recbillno:"Official Document Code",
    checknumtip:"The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    emptyrowlist:"This transfer-out list cannot be empty!",
    checkplannumtip:"The Line Item Bill Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    checkdemandnumtip:"The Bill quantity of this time + the processed quantity cannot be greater than the requirement application quantity",
    orgdemandbillno2: "Application Number"
    },
  materialmovein:{
    title:"WAREHOUSE TRANSFER RECEIPT FORM",
    baseinfoTab:"Basic Information",
    tomaterialmoveTab:"To Be Confirmed Goods Issuance Form",
    materialmoveTab:"Receipt Goods Issuance Form",
    chooseRecbill : "Please select a out-warehouse form",
    billno:"Bill No.",
    plandate:"Billing Date",
    storedate:"Posting Date",
    storeid_in:"Move Into Warehouse",
    planuserid:"Material Coordinator of Goods Receipt",
    storeuserid_in:"Warehouse Officer Of Goods Receipt",
    storeid:"Move Out Of Warehouse",
    logistics_cost_borne:"Logistics Cost Payer",
    expected_logistics_recsum:"Estimated Logistics Fee",
    sourcetype:"Source Of Requirement",
    remark:"Remarks",
    listinfo:"Goods Transfer-In List This Time",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    unitid:"UOM",
    price:"Unit Price",
    currency:"Transaction Currency",
    applynum:"Quantity Removed",
    donenum:"Issued Order Quantity",
    plannum:"Billing Quantity",
    storenum:"Actual Quantity",
    recsum2:"Amount",
    degree:"Inventory Attribute",
    notes2:"Remarks",
    orimanuname:"Original Manufacturer",
    manuname:"Vendor",
    orimanuspec:"Product Model Of Original Manufacturer",
    orgdemandbillno:"Transfer Odd Numbers",
    serialno:"Inventory Batch",
    orgrecbillno:"Transfer Out Document No",
    planusername:"Issued by",
    receivedate:"Time To Task Pool",
    startdate:"Start Date",
    enddate:"End Date",
    recbillno:"Official Document Code",
    checknumtip:"The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    orgrecbillno2: "Transfer out form No.",
    orgdemandbillno2: "Application Number"
    },
  transferdemand:{
    title:"TRANSFER REQUISITON FORM",
    baseinfoTab:"Basic Information",
    applyareaname :"Application Region",
    applydeptname:"Application Department",
    applyusername : "Applicant",
    billno:"Application Number",
    applyuser_tel : "Telephone Number Of Applicant",
    createtime:"Application Date",
    transfertype: "Transfer Type",
    chstore_out: "Out Of Warehouse",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    projcode2:"Transfered Out Subproject Code",
    projname2:"Transfered Subproject Name",
    remark:"Remarks",
    fileup:"Upload Attachment",
    materialWrap:"Material Requirement Details",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec : "Model",
    unitid:"UOM",
    price:"Unit Price",
    currency : "Transaction Currency",
    usablestorenum:"Available Inventory Quantity",
    onlinenum:"In-Transit Occupied Quantity",
    applynum:"Application Quantity",
    recsum:"Amount",
    degree:"Inventory Attribute",
    serialno:"Inventory Batch",
    notes:"Remarks",
    billno2:"Document Encoding",
    brecbillno:"Official Document Code",
    chdemandstatus:"Requirement Status",
    startdate:"Start Date",
    enddate:"End Date",
    remark2:"Remarks",
    reqtransfertypeTips:"Please select the material transfer type!"
    },
  materialtransfer:{
    title:"TRANSFER FORM",
    baseinfoTab:"Basic Information",
    tomaterialtransferTab:"Pending Orders",
    materialtransferTab:"Official Transfer Requisition Form",
    choosedemand : "Please select the material transfer requirement!",
    billno:"Bill No.",
    plandate:"Billing Date",
    storedate:"Posting Date",
    transfertype:"Transfer Type",
    applyusername : "Applicant",
    applydeptname:"Application Department",
    createtime:"Application Date",
    storeid: "Out Of Warehouse",
    planusername:"Material Coordinator of Goods Transfer",
    storeuserid:"Warehouse Officer of Goods Transfer",
    remark:"Remarks",
    listinfo:"List Of Current Transfer",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    unitid:"UOM",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    price:"Unit Price",
    applynum:"Application Quantity",
    donenum:"Issued Order Quantity",
    storenum_que:"Available Inventory Quantity",
    onlinenum:"In-Transit Occupied Quantity",
    plannum:"Billing Quantity",
    storenum:"Actual Quantity",
    recsum2:"Amount",
    degree:"Inventory Attribute",
    notes2:"Remarks",
    serialno:"Inventory Batch",
    demandbillno:"Requirement Document Code",
    receivedate:"Time To Task Pool",
    startdate:"Start Date",
    enddate:"End Date",
    recbillno:"Official Document Code",
    checknumtip:"The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    plannumMaxTips:"The Line Item Billing Quantity Cannot Be Greater Than The Transferable Quantity!",
    orgdemandbillno2: "Application Number"
    },
  handindemand:{
    title:"SURPLUS MATERIALS RETURN REQUISITION FORM",
    baseinfoTab:"Basic Information",
    applyareaname :"Application Region",
    applydeptname:"Application Department",
    applyusername : "Applicant",
    billno:"Application Number",
    applyuser_tel : "Telephone Number Of Applicant",
    createtime:"Application Date",
    sourcetype:"Source Of Requirement",
    handintype:"Refund Type",
    ifstoremanage:"Physical Stock Management Or Not",
    store_out:"Material Return Warehouse",
    remark:"Remarks",
    fileup:"Upload Attachment",
    materialWrap:"Material Requirement Details",
    materialcode:"Material Code",
    materialname:"Material Name",
    price:"Unit Price",
    currency : "Transaction Currency",
    applynum:"Applied Quantity of Return",
    recsum:"Applied Amount of Return",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    linkaddress:"Shipping Address",
    linkuser:"Receiving Contact",
    linktel:"Receiving Contact Number",
    jh_linkaddress:"Delivery Address",
    jh_linkuser:"Delivery Contact",
    jh_linktel:"Delivery Contact Number",
    orimanuname:"Original Manufacturer",
    orimanuprodname:"Original Manufacturer’S Product Name",
    orimanuspec:"Original Manufacturer’S Product Specification Model",
    orimanudrip:"Product Description Of Original Manufacturer",
    notes:"Remarks",
    costcenter: "Cost Center",
    handintransferflag:"Return To General Warehouse Or Not",
    orgbillno:"Original Picking No.",
    storenum:"Picked Quantity",
    handinnum:"Refundable Quantity",
    degree:"Inventory Attribute",
    serialno:"Inventory Batch",
    billno2:"Document Encoding",
    brecbillno:"Official Document Code",
    chdemandstatus:"Requirement Status",
    startdate:"Start Date",
    enddate:"End Date",
    remark2:"Remarks",
    demandtype:"Requirement Type",
    reqdemandtypeTips:"Please select the requirement type.",
    reqhandintypeTips:"Please select the goods return to warehouse type.",
    chouttype2 : "Usage Category"
    },
  selectgetbill: {
    title: "SELECT MATERIAL REQUISITION FORM",
    billno: "Requisition Form Number",
    materialname: "Material Name",
    materialcode: "Material Code",
    spec: "Model",
    chunit: "Unit",
    projname: "Subproject Name",
    chcostcenter: "Cost Center",
    price: "Unit Price",
    chstore: "Warehouse",
    serialno: "Batch Number",
    storedate: "Batch Warehousing Time",
    notes: "Line Item Remarks",
    storenum: "Picked Quantity",
    handinnum: "Quantity To Be Returned",
    confirm: "OK",
    projcode: "Subproject Code",
    applynum: "Application Quantity",
    reqgetbillTips: "Please select material requisition form.",
    reqapplynumTips: "Please enter the application quantity!",
    checkapplynumTips1: "The",
    checkapplynumTips2: "The Application Quantity of The Line Cannot Be Greater Than The Hand-in Quantity!",
    chcurrency: "Transaction Currency",
    checkapplynumTips3: "The Hand-in Quantity of The Line Is 0, Unable To Select!",
    reqcostcenterTips: "Please Fill In The material requisition Form Number or the Cost Center Query Criteria, and Then Click The Query Button!",
    reqprojcodeTips: "Please Fill In The material requisition Form Number or Sub Item Code Query Criteria, and Then Click The Query Button!",
    checkapplynumtip: "The Line Item Application Quantity Cannot Be Greater Than Returnable Quantity!",
    pleaseclickseach: "Please Click Search Button"
    },
  materialhandin: {
    title: "SURPLUS MATERIAL RETURN ORDER",
    baseinfoTab: "Basic Information",
    tomaterialmoveTab: "Pending Orders",
    materialmoveTab: "Surplus Material Return Order",
    billno: "Bill No.",
    plandate: "Billing Date",
    storedate: "Posting Date",
    sourcetype: "Source Of Requirement",
    storeid: "Warehouse",
    planuserid: "Material Coordinator",
    storeuserid: "Warehouse Officer",
    remark: "Remarks",
    listinfo: "Goods Return-to-warehouse List This Time",
    materialcode: "Material Code",
    materialname: "Material Name",
    price: "Unit Price",
    currency: "Transaction Currency",
    applynum: "Quantity Of Return Application",
    donenum: "Issued Order Quantity",
    plannum: "Billing Quantity",
    storenum: "Quantity Of The Return",
    recsum2: "Amount Of The Return",
    degree: "Inventory Attribute",
    notes2: "Remarks",
    orgdemandbillno: "Requisition No.",
    orgbillno: "Original Picking No.",
    projcode: "Subproject Code",
    projname: "Subproject Name",
    costcenter: "Cost Center",
    demandbillno: "Requirement Document Code",
    applyusername: "Applicant",
    createtime: "Application Date",
    demandtype: "Requirement Type",
    receivedate: "Time To Task Pool",
    startdate: "Start Date",
    enddate: "End Date",
    handintype: "Refund Type",
    chstore: "Warehouse",
    chsourcetype: "Source Of Requirement",
    projcode2: "Subproject Code/Cost Center",
    handintransferflag: "Return To General Warehouse Or Not",
    recbillno: "Official Document Code",
    checknumtip: "The Line Item Hand-in Quantity Cannot Be Greater Than The Bill Quantity!",
    choosedemand: "Please select the requirement of returning surplus materials to warehouse!",
    samecompanycodeTips: "Please Select The Same Company Code!",
    samedemandtypeTips: "Please Select The Same Requirement Type!",
    samehandintypeTips: "Please Select The Same Return Type!",
    samecompanyflagTips: "Please Select The Same Company Type!",
    samestoreidTips: "Please select the same warehouse!",
    samesourcetypeTips: "Please Select The Same Requirement Source!",
    sameprojcodeTips: "Please Select The Same Subproject Code / Cost Center!",
    samehandintransferflagTips: "Please Select The Same General Warehouse of Return!",
    orgdemandbillno2: "Application Number",
    projcode_out: "Subproject Code",
    chouttype2 : "Usage Category"
    },
  materialdiscard: {
    title: "SCRAPPING FORM",
    baseinfoTab: "Basic Information",
    tomaterialdiscardTab: "Pending Orders",
    materialdiscardTab: "Scrapping Form",
    choosedemand: "Please select the scrap requirement.",
    billno: "Bill No.",
    plandate: "Billing Date",
    storedate: "Posting Date",
    applyusername: "Applicant",
    applydeptname: "Application Department",
    createtime: "Application Date",
    storeid: "Warehouse",
    planusername: "Material Coordinator",
    storeuserid: "Warehouse Officer",
    remark: "Scrap Reason",
    listinfo: "Scrap List This Time",
    materialcode: "Material Code",
    materialname: "Material Name",
    ifabnormallosses: "Abnormal Loss Or Not",
    costcenter: "Cost Center",
    price: "Unit Price",
    applynum: "Scrap Quantity",
    donenum: "Issued Order Quantity",
    storenum_que: "Available Inventory Quantity",
    onlinenum: "In-Transit Occupied Quantity",
    plannum: "Billing Quantity",
    storenum: "Actual Quantity",
    recsum2: "Total Amount",
    degree: "Inventory Attribute",
    notes2: "Remarks",
    demandbillno: "Requirement Document Code",
    receivedate: "Time To Task Pool",
    startdate: "Start Date",
    enddate: "End Date",
    recbillno: "Official Document Code",
    checknumtip: "The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    orgdemandbillno2: "Application Number"
    },
  materialdemandclose: {
    demandReturn: "Returned Requirement",
    choosedemand: "Please select the requirement to be returned.",
    reqrendertype: "Please configure the business type of the requirement  return.",
    submitbtn: "Submit",
    backreason: "Return Reason",
    billno: "Document Encoding",
    applydate: "Application Date",
    applyusername: "Applicant",
    chcompanycode: "Company Code",
    projcodeout: "Subproject Code/Cost Center",
    materialcode: "Material Code",
    materialname: "Material Name",
    spec: "Model",
    chunit: "UOM",
    price: "Unit Price",
    applynum: "Application Quantity",
    donenum: "Quantity Of The Processed Orders",
    canbacknum: "Returnable Quantity",
    reqbackdemandrow: "Return requirement list cannot be empty.",
    checkcanbacknumTips1: "The",
    checkcanbacknumTips2: "The returnable quantity of the line is 0, cannot be returned!"
    },
  demandbacklist: {
    demandbacklistTab: "Returned Requirement List",
    choosebackdemand: "Please select the Return Requirement.",
    reqrendertype: "Please configure the business type.",
    billno: "Document Encoding",
    title: "TITLE",
    createtime: "Application Date",
    applyusername: "Applicant",
    chcompanycode: "Company Code",
    chdemandtype: "Requirement Type",
    sumfee: "Total Amount",
    showdetail: "View Details",
    applydate: "Application Date",
    projcodeout: "Subproject Code/Cost Center",
    materialcode: "Material Code",
    materialname: "Material Name",
    spec: "Model",
    chunit: "UOM",
    price: "Unit Price",
    applynum: "Application Quantity",
    donenum: "Quantity Of The Processed Orders",
    backnum: "Return Quantity",
    backreason: "Return Reason",
    deletebtn: "Void",
    reqbillrowidTips: "Please select the record to cancel.",
    deletemsg: "Are you sure to make the selected returned materials invalid?",
    deletemsg2: "Are you sure to make the selected return requirement invalid?",
    dellist: "Void List",
    endlist: "Archived",
    chbackuser: "Deleted By",
    recreatebtn: "To Resubmit",
    choosebackdemand2: "Please Select The Documents To Be Resubmitted.",
    reqloadRouterPathTips: "Please configure the resubmitted route",
    onlyrecreatedemand: "Only One Resubmitted Document Can Be Selected.",
    samebillidTips: "Please select the same document!",
    choosebackdemand3: "Please Select The Document Line Item To Resubmit",
    backdemandtoapplybtn: "Return",
    reqbackbillidTips: "Current Doc bill ID Cannot Be Empty!",
    backdemandToApplymsg: "Are You Sure You Want To Return This Document?",
    backsuccmsg: "Successful Return",
    backerrormsg: "The Current Document has Related Documents and Cannot Be Returned!"
    },
  materialgive: {
    title: "GIFT DOCUMENT",
    baseinfoTab: "Basic Information",
    tomaterialgiveTab: "Pending Orders",
    materialgiveTab: "Gift Document",
    choosedemand: "Please Select the gift requirement.",
    billno: "Bill No.",
    plandate: "Billing Date",
    storedate: "Posting Date",
    applyusername: "Applicant",
    createtime: "Application Date",
    givesource: "Gift Source",
    storeid: "Warehouse",
    planuserid: "Material Coordinator",
    storeusername: "Warehouse Officer",
    invoiceno: "Invoice",
    taxrate: "Comprehensive Tax Rate",
    manuname: "Vendor",
    remark: "Remarks",
    listinfo: "Goods Receipt List This Time",
    materialcode: "Material Code",
    materialname: "Material Name",
    price: "Unit Price",
    applynum: "Application Quantity",
    donenum: "Issued Order Quantity",
    plannum: "Billing Quantity",
    storenum: "Actual Quantity",
    recsum2: "Fair Value / Amount",
    notes2: "Remarks",
    orgdemandbillno: "Requisition No.",
    serialno: "Inventory Batch",
    demandbillno: "Requirement Document Code",
    receivedate: "Time To Task Pool",
    startdate: "Start Date",
    enddate: "End Date",
    recbillno: "Official Document Code",
    checknumtip: "The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    orgdemandbillno2: "Application Number"
    },
  itemsearchlist:{
    indexMethod: "S/N",
    itemcode: "Project Code",
    itemname: "Project Name",
    applyuser: "Creator",
    currstatus:"Current Processing Step",
    curruser:"Current Handler",
    title:"Project Approval",
    investyear:"Investment Year",
    itemleader:"Project Approval Administrator",
    constructunit:"Construction Unit",
    itemspeccode:"Major",
    investtype:"Investment Channels",
    expList: "Export",
    reset:"Reset",
    query:"Query",
    buscate:"Business Category"
    },
  materialstzgtransfer: {
    title: "ENTRUSTED SELF MANAGEMENT TRANSFER FORM",
    baseinfoTab: "Basic Information",
    applydeptname: "Application Department",
    applyusername: "Applicant",
    billno: "Application Number",
    plandate: "Billing Date",
    storedate: "Posting Date",
    transfertype: "Transfer Type",
    chstore_out: "Out Of Warehouse",
    planusername: "Material Coordinator of Goods Transfer",
    storeuserid: "Warehouse Officer of Goods Transfer",
    projcode_out: "Transfered Out Subproject Code",
    projname_out: "Transfered Subproject Name",
    projcode: "Subproject Code",
    projname: "Subproject Name",
    projcode2: "Transfered Out Subproject Code",
    projname2: "Transfered Subproject Name",
    remark: "Remarks",
    materialWrap: "Material Requirement Details",
    materialcode: "Material Code",
    materialname: "Material Name",
    price: "Unit Price",
    usablestorenum: "Available Inventory Quantity",
    onlinenum: "In-Transit Occupied Quantity",
    plannum: "Billing Quantity",
    storenum: "Actual Quantity",
    recsum: "Amount",
    degree: "Inventory Attribute",
    notes: "Remarks",
    billno2: "Document Encoding",
    startdate: "Start Date",
    enddate: "End Date",
    remark2: "Remarks",
    reqtransfertypeTips: "Please select the material transfer type!",
    checkapplynumtip: "The Line Item Bill Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    changeprojTips: "Please Clear The Selected Material Demand Details and Replace The Transfer Out Sub Item Code!",
    reqprojcodeTips: "Please Select Transfer Out Sub Item Code!",
    checknumtip: "The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    title1: "ENTRUSTED SELF MANAGEMENT TRANSFER FORM",
    title2: "ENTRUSTED SELF MANAGEMENT TRANSFER FORM",
    title3: "ENTRUSTED SELF MANAGEMENT TRANSFER FORM"
    },
  backdemand:{
    title: "GOODS RETURN REQUIREMENT FORM",
    baseinfoTab: "Basic Information",
    tobackdemandTab: "Pending Goods Return Order",
    backdemandTab: "Goods Return Requisition",
    orderno:"PO Number",
    ordername:"PO Name",
    manuname:"Vendor",
    stockusername:"Procurement Administrator",
    contractcode:"Legal Order Code",
    orderdate:"Order Date",
    startdate:"Start Date",
    enddate:"End Date",
    rectype:"Goods Receipt Type",
    chooseorder: "Please select an order",
    applyareaname :"Application Region",
    applydeptname:"Application Department",
    applyusername : "Applicant",
    billno:"Application Number",
    applyuser_tel : "Telephone Number Of Applicant",
    createtime:"Application Date",
    remark:"Remarks",
    fileup:"Upload Attachment",
    store_out:"Goods Return Warehouse",
    materialWrap:"Material Requirement Details",
    materialcode:"Material Code",
    materialname:"Material Name",
    price:"Unit Price",
    currency : "Transaction Currency",
    applynum:"Applied Quantity of Return",
    recsum:"Total Amount",
    projcode:"Subproject Code",
    projname:"Subproject Name",
    usablestorenum:"Available Inventory Quantity",
    onlinenum:"In-Transit Occupied Quantity",
    degree:"Inventory Attribute",
    serialno:"Inventory Batch",
    notes:"Remarks",
    checkapplynumtip:"The Line Item Return Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    existsRowlistTips:"Order Material List Has Been Selected, Please Delete the Line Item material First!",
    billno2 : "Document Encoding",
    brecbillno : "Official Document Code",
    chdemandstatus : "Requirement Status",
    donenum: "Issued Order Quantity"
    },
  selectbackorder:{
    title:"SELECT GOODS RETURN ORDER INFORMATION",
    orderno:"PO Number",
    materialname:"Material Name",
    materialcode:"Material Code",
    spec:"Model",
    chunit:"Unit",
    price:"Unit Price",
    stocknum:"Purchase Quantity",
    recnum:"Received Quantity",
    recnumonline:"Quantity In Transit",
    canbacknum:"Refundable Quantity",
    searchstore:"Query Stock",
    applynum:"Goods Return Quantity This Time",
    projname:"Subproject Name",
    chcurrency:"Transaction Currency",
    chstore:"Warehouse",
    serialno:"Batch",
    storenum:"Inventory Quantity",
    chdegree:"Inventory Attribute",
    usablestorenum:"Available Inventory Quantity",
    onlinenum:"In-Transit Occupied Quantity",
    confirm:"OK",
    reqselectedOrderrowids:"Please select the specific information!",
    reqorderid:"Order ID cannot be empty!",
    reqstoreid:"Please select a return warehouse!",
    reqstorematerialTips:"Please Click The Query Inventory Button To Query The Inventory Materials!",
    reqapplynumTips:"Please enter the goods quantity of this return!",
    checkapplynumTips1:"The",
    checkapplynumTips2:"The Current Return Quantity of The Line Cannot Be Greater Than The Returnable Quantity!",
    checkapplynumTips3:"The Available Inventory Quantity of The Line Is 0, Unable To be Selected!",
    searchbillrow:"Query Receiving Goods Line Item",
    mstorenum:"Quantity Delivered",
    usablestorenum2:"Refundable Quantity",
    onlinenum2:"Retired Quantity"
    },
  materialwwlyreg: {
    title: "ENTRUSTED REQUISITION REGISTRATION FORM",
    baseinfoTab: "Basic Information",
    applydeptname: "Application Department",
    applyusername: "Applicant",
    billno: "Application Number",
    chstore_out: "Warehouse",
    remark: "Remarks",
    materialWrap: "Material Requirement Details",
    serialno: "Requisition Batch Number",
    materialcode: "Material Code",
    materialname: "Material Name",
    projcode: "Subproject Code",
    projname: "Subproject Name",
    price: "Unit Price",
    plannum: "Number of Requisition",
    recsum: "Total Amount",
    currency: "Transaction Currency",
    orderno: "Purchase Order No.",
    manuno: "Vendor Code",
    manuname: "Vendor Name",
    notes: "Remarks",
    billno2: "Document Encoding",
    createtime: "Application Date",
    startdate: "Start Date",
    enddate: "End Date",
    remark2: "Remarks",
    checkapplynumtip: "The Line Item Requisition Quantity Cannot Be Greater Than The Available Quantity!",
    usablestorenum: "Available Quantity",
    outmanuno: "Entrusted Vendor Code",
    outmanuname: "Entrusted Vendor Name"
    },
  selectmaterialserialdoc: {
    title: "SELECT MATERIAL BATCH",
    materialname: "Material Name",
    materialcode: "Material Code",
    spec: "Model",
    chunit: "Unit",
    mstorenum: "Quantity",
    orderno: "Order Number",
    stockno: "Document Encoding",
    serialno: "Batch",
    price: "Batch Price",
    manuname: "Vendor",
    outmanuname: "Entrusted Vendor",
    chstore: "Warehouse",
    manuno: "Vendor Code",
    outmanuno: "Entrusted Vendor Code",
    applynum: "Application Quantity",
    confirm: "OK",
    reqstorematerialTips: "Please select material batch!",
    reqapplynumTips: "Please enter the application quantity!",
    checkapplynumTips1: "The",
    checkapplynumTips2: "The Application Quantity Of The Line Cannot Be Greater Than The Available Quantity!",
    reqstoreTips: "Please select warehouse.",
    chcurrency: "Transaction Currency",
    checkapplynumTips3: "The Available Quantity Of The Line Is 0 And Cannot Be Selected!",
    usablestorenum: "Available Quantity",
    onlinenum: "Occupied Quantity",
    outproj: "Entrustment Subproject"
    },
  materialback: {
    title: "GOODS RETURN FORM",
    baseinfoTab: "Basic Information",
    tomaterialbackTab: "Pending Orders",
    materialbackTab: "GOODS RETURN FORM",
    choosedemand: "Please select the goods return requirement.",
    billno: "Bill No.",
    plandate: "Billing Date",
    storedate: "Posting Date",
    applyusername: "Applicant",
    applydeptname: "Application Department",
    orderno:"PO Number",
    ordername:"PO Name",
    manuno: "Vendor Code",
    manuname: "Vendor Name",
    createtime: "Application Date",
    storeid: "Warehouse",
    planusername: "Material Coordinator",
    storeuserid: "Warehouse Officer",
    remark: "Remarks",
    listinfo: "Goods Return List This Time",
    materialcode: "Material Code",
    materialname: "Material Name",
    price: "Unit Price",
    applynum: "Applied Quantity of Return",
    donenum: "Issued Order Quantity",
    storenum_que: "Available Inventory Quantity",
    onlinenum: "In-Transit Occupied Quantity",
    plannum: "Billing Quantity",
    storenum: "Actual Quantity Returned",
    recsum2: "Refund Amount",
    degree: "Inventory Attribute",
    notes2: "Remarks",
    demandbillno: "Requirement Document Code",
    receivedate: "Time To Task Pool",
    startdate: "Start Date",
    enddate: "End Date",
    recbillno: "Official Document Code",
    checknumtip: "The Line Item Actual Returned Quantity Cannot Be Greater Than The Bill Quantity!",
    orgdemandbillno2: "Application Number"
    },
  materialgzlyreg: {
    title: "OFFICE ASSETS REGISTRATION FORM",
    baseinfoTab: "Basic Information",
    tomaterialgzlyregTab: "Pending Requisition",
    materialgzlyregTab: "Requisition Registration Form",
    choosegz: "Please Select Office Assets To Be Collected",
    orderno: "PO Number",
    ordername: "PO Name",
    manuno: "Vendor Code",
    manuname: "Vendor Name",
    assetclass: "Asset Classification",
    assetcodeno: "Assets Card No.",
    sn: "Physical Serial Number",
    materialcode: "Material Code",
    materialname: "Material Name",
    spec: "Model",
    unit: "UOM",
    price: "Purchse Price",
    addlyreginfo: "Add Requisition Information",
    billno: "Application Number",
    applyusername: "Applicant",
    applydeptname: "Application Department",
    listinfo: "Requisition List This Time",
    description: "Explanation",
    macaddr: "MAC Address",
    opersystem: "Operating System",
    warrantyinfo: "Warranty Information(End Date)",
    adaptercode: "Adapter Code",
    sourcedoc: "Source Document",
    recsum: "Purchse Price",
    assignuserid: "Requestor",
    assigntime: "Requesting Date",
    plannum: "Requesting quantity",
    mstoreuserid: "Material Administrator",
    useuserid: "Assignee Name",
    usedeptid: "Assignee Dept.",
    senduserid: "Deliverer",
    notes2: "Remarks",
    slbillno: "Receipt Code",
    billno2: "Document Encoding",
    createtime: "Application Date",
    startdate: "Start Date",
    enddate: "End Date",
    updateassetbtn: "Update Asset Card",
    updateassetSuccTips: "Update Asset Card Successfully",
    sendsapflag: "Update Asset Status",
    transaptip: "The line item asset status has not been updated successfully. Please click the [Update Asset Card] button!",
    costcenter:"Cost Center",
    mstoredeptid:"Management Department of Physical Material",
    estimareplacedate: "Estimated Date of Replacement",
    ifcapitalizable: "Capitalizable or Not",
    sameifcapitalizableTips: "Please Select the Same Office Assets That Are Capitalized Or Not!",
    assetmodifyflagTips: "SAP has not Sent Back Feedback and cannot be Saved, Please Refresh the Page and Try Again!"
    },
  materialstorelist: {
    orderno: "PO Number",
    query: "Query",
    ordername: "PO Name",
    plandate: "Billing Date",
    startdate: "Start Date",
    enddate: "End Date",
    reset: "Reset",
    order: "S/N",
    manuname: "Vendor",
    oper: "Operation",
    view: "View",
    billno: "Document Encoding",
    applyusername: "Prepared By",
    applydate: "Billing Date",
    chstore: "Warehouse",
    accountdate: "Posting Date",
    tostorelist: "Pending Recording on Account",
    storelist: "Entered Account",
    chdemandtype:"Requirement Type",
    chprojcode_out:"Project Code/Cost Center"
    },
  materialsdmsgetaccount: {
    title: "GOODS ISSUE VERIFICATION FORM",
    baseinfoTab: "Basic Information",
    tomaterialsdmsgetaccountTab: "Pending Settlement",
    materialsdmsgetaccountTab: "Goods Issue Settlement Form",
    choosedemand: "Please select the requirement to be settled!",
    samecompanycodeTips: "Please Select The Same Company Code!",
    samecompanyflagTips: "Please Select The Same Company Type!",
    samestoreidTips: "Please select the same warehouse!",
    sameprojcodeTips: "Please Select The Same Cost Center!",
    billno: "Bill No.",
    plandate: "Billing Date",
    storedate: "Posting Date",
    storeid: "Warehouse",
    projcode_out: "Cost Center Code",
    projname_out: "Cost Center Name",
    remark: "Remarks",
    addsdmsgetaccount: "Add",
    listinfo: "Delivery List",
    materialcode: "Material Code",
    materialname: "Material Name",
    price: "Unit Price",
    plannum: "Quantity",
    recsum: "Amount",
    notes2: "Remarks",
    chouttype2: "Usage Category",
    serialno: "Inventory Batch",
    recbillno: "Official Document Code",
    startdate: "Start Date",
    enddate: "End Date",
    orgdemandbillno2: "Application Number",
    createtime: "Application Date",
    spec: "Model",
    serialno1: "Batch Number",
    billno2: "Document Encoding",
    planusername: "Material Coordinator",
    storeuserid: "Warehouse Officer"
    },
  materialtohandin: {
    title: "TERMINAL MATERIAL RETURN FORM",
    baseinfoTab: "Basic Information",
    tomaterialtohandinTab: "Pending Materials Return",
    materialtohandinTab: "Terminal Material Return Form",
    choosedemand: "Please select the material return requirement!",
    samecompanycodeTips: "Please Select The Same Company Code!",
    samecompanyflagTips: "Please Select The Same Company Type!",
    samestoreidTips: "Please select the same warehouse!",
    sameprojcodeTips: "Please Select The Same Cost Center!",
    billno: "Bill No.",
    plandate: "Billing Date",
    storedate: "Posting Date",
    storeid: "Warehouse",
    projcode_out: "Cost Center Code",
    projname_out: "Cost Center Name",
    remark: "Remarks",
    addtohandin: "Add",
    listinfo: "Goods Return-to-warehouse List This Time",
    materialcode: "Material Code",
    materialname: "Material Name",
    price: "Unit Price",
    plannum: "Quantity",
    recsum: "Amount",
    notes2: "Remarks",
    chouttype2: "Usage Category",
    serialno: "Inventory Batch",
    recbillno: "Official Document Code",
    startdate: "Start Date",
    enddate: "End Date",
    orgdemandbillno2: "Application Number",
    createtime: "Application Date",
    spec: "Model",
    serialno1: "Batch Number",
    billno2: "Document Encoding",
    planuserid: "Material Coordinator",
    storeuserid: "Warehouse Officer",
    orgbillno: "Original Picking No."
    },
  materialcheck: {
    title: "INVENTORY CHECK RESULT",
    baseinfoTab: "Basic Information",
    billno: "Bill No.",
    plandate: "Billing Date",
    storedate: "Posting Date",
    storeid: "Warehouse",
    planuserid: "Material Coordinator",
    storeusername: "Warehouse Officer",
    fileup: "Upload Attachment",
    checktype: "Inventory Check Type",
    remark: "Remarks",
    materialWrap: "Material Requirement Details",
    materialcode: "Material Code",
    materialname: "Material Name",
    price: "Unit Price",
    plannum: "Billing Quantity",
    storenum: "Actual Quantity",
    recsum: "Total Amount",
    currency: "Transaction Currency",
    costcenter: "Cost Center",
    usablestorenum: "Available Inventory Quantity",
    onlinenum: "In-Transit Occupied Quantity",
    degree: "Inventory Attribute",
    billno2: "Document Encoding",
    startdate: "Start Date",
    enddate: "End Date",
    remark2: "Remarks",
    reqchecktypeTips: "Please select the inventory check type",
    checkapplynumtip: "The Line Item Bill Quantity Cannot Be Greater Than The Available Inventory Quantity!",
    checknumtip: "The Line Item Actual Quantity Cannot Be Greater Than The Bill Quantity！",
    notes2:"Remarks"
    },
  demandquery: {
    chcompany: "Company",
    billno: "Document Encoding",
    applydeptname: "Department",
    chsourcetype: "Source Of Requirement",
    createtime: "Application Date",
    startdate: "Start Date",
    enddate: "End Date",
    billno_exact: "Bill No. (Accurate)",
    remark: "Master Form Remarks",
    rownotes: "Line Item Remarks",
    orderno: "Order Number(Accurate)",
    projcode: "Project Code",
    projcode2: "Subproject Code",
    projname: "Subproject Name",
    costcenter: "Cost Center",
    orgbillno: "Related Material Bill No.",
    demandstatus: "Document Status",
    applydept: "Application Department",
    applyuserid: "Applicant",
    curruserid: "Current Handler",
    outtype2: "Usage Category",
    backflag: "Return or not",
    currname: "Current Handler",
    remark2: "Master Form Remarks",
    showdetail: "Display Details"
    },
  bstorequerylist: {
    exact : "Accurate",
    chcompany: "Company",
    billno: "Document Encoding",
    sobkz: "Stock Type",
    materialcode:"Material Code",
    materialname:"Material Name",
    spec:"Model",
    storedate:"Stock-In Time",
    serialno: "Inventory Batch",
    manuname:"Vendor",
    orderno: "PO Number",
    contractcode: "Contract Code",
    projcode: "Subproject Code",
    orimanuname : "Original Manufacturer",
    orimanuprodname : "Original Manufacturer’S Product Name",
    orimanuspec : "Product Model Of Original Manufacturer",
    orimanudrip : "Product Description Of Original Manufacturer",
    chstore : "Warehouse Name",
    chunit : "UOM",
    storenum : "Inventory Quantity",
    recsum : "Amount",
    onlinenum : "In-transit Inventory",
    usablestorenum : "Available Inventory",
    storeusername : "Warehouse Keeper",
    z_itext : "Remarks",
    ztlsm : "Material Return Remarks",
    chgivesource : "Gift Source",
    chooseprintitem : "Please Select The Inventory Line Item To Be Printed"
    },
    warehousestocklist: {
      exact : "Accurate",
      companycode : "Company Code",
      chcompany: "Company",
      materialcode:"Material Code",
      materialname:"Material Description",
      lgort : "Storage Location",
      chlgort : "Description",
      chunit : "UOM",
      storenum : "Quantity",
      materialgroup : "Material Group"
    },
    stockonpostingdatelist: {
      exact : "Accurate",
      companycode : "Company Code",
      chcompany: "Company",
      materialcode:"Material Code",
      materialname:"Material Description",
      storedate : "Posting Date",
      lgort : "Storage Location",
      mblnr:"Material Document",
      zeile:"Line Item",
      erfmg : "Quantity",
      bwart : "Movement Type",
      erfme : "UOM",
      stockon : "Stock On",
      totalreceipts : "Total Receipts",
      totalissu : "Total Issues",
      fillmaterialinfo : "Query Item Material Code/Material Description Cannot Be Empty!"
    },
  sdmsgetaccount: {
    title: "VERIFICATION REQUIREMENT FORM",
    baseinfoTab: "Basic Information",
    applyareaname: "Application Region",
    applydeptname: "Application Department",
    applyusername: "Applicant",
    billno: "Application Number",
    createtime: "Application Date",
    chstore_out: "Warehouse",
    materialWrap: "Material Requirement Details",
    materialcode: "Material Code",
    materialname: "Material Name",
    price: "Unit Price",
    applynum: "Application Quantity",
    recsum: "Amount",
    currency: "Transaction Currency",
    costcenter: "Cost Center",
    chouttype2: "Usage Category",
    donenum: "Issued Order Quantity",
    usablestorenum: "Available Inventory Quantity",
    onlinenum: "In-Transit Occupied Quantity",
    degree: "Inventory Attribute",
    serialno: "Inventory Batch"
    },
  billquery: {
    billno_exact: "Bill No. (Accurate)",
    rendertype: "BOM Type",
    plandate: "Billing Date",
    storeid: "Warehouse",
    storeuserid: "Warehouse Officer",
    planuserid: "Material Coordinator",
    accoutedate: "Closing Month",
    storedate: "Posting Date",
    materialcode: "Material Code",
    materialname: "Material Name",
    spec: "Model",
    evalclasscode: "Valuation Class",
    costcenter: "Cost Center",
    outtype2: "Usage Category",
    serialno: "Batch Number",
    billstatus: "BOM Status",
    orderno: "Order Number(Accurate)",
    contractcode: "Contract Code(Accurate)",
    projcode: "Project Code",
    chcompany: "Company",
    billno: "Bill of materials number",
    applydeptname: "Application Department",
    orgbillno: "Related Form No.",
    applyuser_demand: "Requirement Applicant",
    applydept_demand: "Requirement Applicant Department",
    chsourcetype: "Source Of Requirement",
    applyuserid: "Applicant",
    planusername: "Material Coordinator",
    storeusername: "Warehouse Officer",
    remark: "Master Form Remarks",
    price: "Unit Price",
    plannum: "Billing Quantity",
    storenum: "Actual Quantity",
    recsum: "Amount",
    chstatus: "Status",
    rownotes: "Line Item Remarks",
    projcode2: "Subproject Code",
    projname: "Subproject Name",
    currname: "Current Handler",
    showdetail: "Display Details"
    },
  materialmodel: {
    title: "MODEL MATERIAL MAINTENANCE",
    baseinfoTab: "Basic Information",
    materialcode: "Model Material Code",
    materialname: "Model Material Name",
    spec: "Model",
    chunit: "Unit",
    createtime: "Completion Date",
    applyusername: "Prepared By",
    remark: "Remarks",
    materialWrap: "Detailed Material",
    submaterialcode: "Detailed Material Code",
    rowmaterialname: "Detailed Material Name",
    rowspec: "Model",
    rowchunit: "Unit",
    plannum: "Quantity",
    price: "Unit Price",
    pricescale: "Price Proportion (%)",
    calpricescalebtn: "Proportion Calculation",
    enablebtn: "Take Effect",
    modifybtn: "Adjustment",
    enablesuccess: "Come Into Effect",
    ifvalid: "Confirm to take effect or not",
    pricescalesumTips: "The total value of the price proportions shall be 100%!",
    reqmaterialcodeTips: "Please select model material code!",
    changemodelmaterialTips: "Please clear the selected detailed materials, and then select the model material code!"
    },
  porecquery: {
    manuname: "Vendor Name",
    stocknum: "Quantity",
    price: "Unit Price (VAT Exclusive)",
    costprice: "Price (VAT Exclusive)",
    recsum: "Total Price (Incl. Tax)",
    rectotalnum: "Quantity Delivered",
    outtotalnum: "Entrustment Quantity",
    occupytotalnum: "Use Quantity",
    recbillno: "Goods Receipt Form Number",
    recdate: "Goods Receipt Date",
    recserialno: "Goods Receipt Batch",
    recnum: "Quantity Delivered",
    outdate: "Entrustment Date",
    outnum: "Entrusted Quantity",
    occupynum: "Use Quantity"
    },
  materialcarry: {
    title: "CARRY-FORWARD BILL"
    },
  outbillquery: {
    manuname: "Vendor Name",
    belongeregion: "Region",
    outtotalnum: "Entrustment Quantity",
    price: "Unit Price (VAT Exclusive)",
    recsum: "Amount",
    occupytotalnum: "Use Quantity",
    occupynum: "Use Quantity"
    },
  materialofficely: {
    title: "OFFICE SUPPLIES REQUISITION FORM",
    plannum: "Number of Requisition",
    checkapplynumtip: "The requisition quantity of the line item can not be greater than available inventory quantity!",
    checknumtip: "The actual quantity of the line item cannot be greater than the requisition quantity！"
    },
  officelydemand: {
    demandlistTab: "Material Requisition Application",
    title: "OFFICE SUPPLIES REQUIREMENT FORM"
    },
  materialofficelybl: {
    title:"OFFICE SUPPLIES APPLICATION FORM",
    tomaterialofficelyblTab:"Pending Orders",
    materialofficelyblTab:"Official Requisiton Form",
    choosedemand : "Please Select Application Requirements For Office Supplies",
    orgdemandbillno : "Office Supplies Application Bill Code"
    },
  paramcfgload: {
    paramkey: "Parameter Name",
    paramval: "Parameter Value",
    title_officeaassets: "OFFICE ASSETS BASIC SETTINGS",
    oa_assetsamount: "Capitalizable Threshold For Office Assets (PHP)",
    oa_poamount: "Threshold Amount For Purchases Requiring Purchase Order(PHP)",
    title_officesupplies: "OFFICE SUPPLIES BASIC SETTINGS",
    os_poamount: "Threshold Amount For Purchases Requiring Purchase Order(PHP)"
  },
  materialgzydreg: {
    title: "RECORDING OFFICE ASSET RESERVATION FORM",
    tomaterialgzydregTab: "To Be Reservation",
    materialgzydregTab: "Reservation Recording Form",
    addydreginfo: "Add Reservation Information",
    choosegz: "Please Select the Office Assets to be Reserved",
    listinfo: "This Reservation List",
    plannum: "Reservation Quantity",
    useuserid: "Reservation Person",
    usedeptid: "Reservation Department",
    officeassetcode: "Card No. of Office Asset",
    materialgzyd2lyTab: "Reservation for Collection",
    materialgzhs2lyTab: "Recycling for Collection",
    materialgzwx2lyTab: "Repair for Collection"
  },
  materialgzhsreg: {
    title: "RECORDING OFFICE ASSETS RETURN FORM",
    listinfo: "This Recycling List"
  },
  materialgzwxreg: {
    title: "RECORDING OFFICE ASSET REPAIR FORM",
    listinfo: "This Repair List"
  },
  materialgzbfreg: {
    title: "RECORDING OFFICE ASSET SCRAPPING FORM",
    listinfo: "This Scrapping List"
  },
  materialgzzyreg: {
    title: "RECORDING TRANSFER OF OFFICE ASSET FORM",
    listinfo: "This Transfer List",
    oriuseusername: "Original User",
    curruseusername: "Current User",
    reqoriuseusernameTips: "Please Select the Original User First",
    changeoriuseusernameTips: "Please Clear the Selected Office Assets and Replace the Original User!",
    useuseridsameTips: "Please Select Different Original User and Current User!"
  },
  voucherquery: {
    matnr: "Material",
    charg: "Batch",
    companycode: "Plant",
    lgort: "Storage Location",
    bwart: "Movement Type",
    mblnr: "Material Document",
    zeile: "Material Doc.Item",
    budat: "Posting Date",
    storenum: "Qty in Un. of Entry",
    chunit: "Unit of Entry",
    chzkeeper: "Goods Recipient",
    ext_doc_no: "Goods Receipt/Issue Slip",
    ebeln: "Purchase Order",
    sakto: "G/L Account",
    chwaers: "Currency",
    chkostl: "Cost Center",
    materialname: "Material Description",
    chbwart: "Movement Type Text",
    entrydate: "Entry Date",
    entrytime: "Time of Entry",
    chusnam: "User Name"
  }
}



// WEBPACK FOOTER //
// ./src/lang/pi.js